import { LitElement, html, css } from 'lit'
import { classMap } from 'lit/directives/class-map.js';
import { until } from 'lit/directives/until.js'
import * as localforage from 'localforage'
import { db } from './dexie.js'
import { getWallet } from './wallet.js'
import { changeFA2admin, printContractSignature } from "./admin/admin.js"

import { Router } from '@vaadin/router'

// using version 8.3.0 because of import issues https://github.com/codsen/codsen/issues/22
import { stripHtml } from 'string-strip-html'

const outlet = document.querySelector('#contentcontainer')

const GATEWAY = "https://cloudflare-ipfs.com/ipfs/"

export const router = new Router(outlet)

router.setRoutes([
  { path: '/', redirect: '/create' },
  { path: '/create', component: 'create-page' },
  { path: '/yours/:offset?', component: 'your-tokens' },
  { path: '/buy/:offset?', component: 'gallery-explore' },
  { path: '/artist/:creator/:offset?', component: 'gallery-artist' },
  { path: '/collection/:collectionid/:offset?', component: 'gallery-collection' },
  { path: '/about', component: 'about-page' },
  { path: '/token/:tokenid', component: 'token-infos' },
  { path: '/404', component: 'not-found' },
  { path: '/admin', component: 'admin-page' },
  { path: '(.*)', component: 'not-found' },
])

export class MiniPfp extends LitElement {

  static styles = css`
      
      ul {
        list-style: square;
      }
      
      li {
        padding: 0.25em;
      }

      a { 
        text-decoration: underline;
        color: var(--button-color);
      }

      a:visited { 
        color: var(--inactive-color);
      }
      

      a:active { 
        color: var(--feedback-color);
      }

      a:hover { 
        color: var(--inactive-color);
      }
      

      canvas {
        display: block;
        width: 80%;
      }

      .newtab:after {
        display: inline-block;
        content: "⇱";
        font-size: 1.2em;
        position: relative;
        top: 0.1em;
        margin-left: 0.5em;
        transform: rotate(90deg);
      }
      
      #container {
        margin-left: 30vw;
        margin-right: 30vw;
        margin-top: 1em;
        margin-bottom: 4em;
      }
      
      @media (max-width: 1300px) {
      
        #container {
          margin-left: 20vw;
          margin-right: 20vw;
        }
      
      }
      
      @media (max-width: 900px) {
      
        #container {
          margin-left: 10vw;
          margin-right: 10vw;
        }
      
      }
      
      @media (max-width: 700px) {
      
        #container {
          margin-left: 5vw;
          margin-right: 5vw;
        }
      
      }
      
      h1 {
        font-size: 4em;
        font-family: var(--title-font);
        color: var(--dark-text-color);
        margin: 0;
      }
      
      .smallerfont {
        font-size: 50%;
      }
      
      #intro {
        overflow: hidden;
        transform: rotate(353deg);
        margin-bottom: 2em;
        margin-top: -1em;
        position: relative;
        z-index: -10;
      }
      
      #intro h4 {
        font-size: 1.25em;
        font-weight: 600;
        color: var(--highlight-color);
        margin: 0;
        margin-top: 1em;
        margin-bottom: 1em;
      }
      
      #intro em {
        color: var(--light-text-color);
        font-size: 1.25em;
        font-weight: 500;
        margin-left: 1em;
      }
      
      #intro ul {
        color: var(--light-text-color);
        font-weight: 600;
        letter-spacing: 0.02em;
      }
      
      .tabs {
        display: flex;
        flex-direction: row;
        margin-bottom: 1em;
        flex-wrap: nowrap;
        position: relative;
        z-index: 10;
      }

      .tabs.previousnext {
        justify-content: right;
      }
      
      a.tab {
        color: var(--button-text-color);
        background-color: var(--highlight-color);
      
        text-decoration: none;
        text-align: center;
      
        /* top | right | bottom | left */
        padding: 0.5em 1em 0.4em 1em;
      
        border-top-left-radius: 0.2em;
        border-top-right-radius: 0.2em;
        border-bottom-left-radius: 0.2em;
        border-bottom-right-radius: 0.2em;
      
        margin-right: 0.8em;
        font-size: 90%;
      
        user-select: none;
      }
      
      a.tab.selectable:hover {
        background-color: var(--feedback-color);
        box-shadow: var(--colored-offset);
        margin-bottom: 0.5em;
        margin-top: -0.5em;
      }
      
      a.tab:active {
        background-color: var(--selected-color);
        color: var(--highlight-color);
      }
      
      a.tab.selected {
        background-color: var(--selected-color);
        color: var(--inactive-button-text-color);
        margin-bottom: 0.5em;
        margin-top: -0.5em;
        box-shadow: var(--colored-offset-inactive);
      }

      a.tab:last-child{
        margin-right: 0;
      }
      
      #layers-form {
        display: flex;
        flex-direction: column;
        margin-left: 0.5em;
      }
      
      .layercontainer {
        display: flex;
        flex-direction: column;
        margin-bottom: 2.5em;
      }

      .seriesnamelabel {
        font-weight: 800;
        letter-spacing: 0.02em;
        word-spacing: 0.05em;
      }

      .seriesnameinput{
        background: rgb(255, 255, 255);
        background: linear-gradient(90deg, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0) 40%, rgba(255, 255, 255, 0) 100%);
        border-color: #ffffffff;
        border-width: 0;
    
        margin-bottom: 1em;
        font-size: 1.3em;

        max-width: 100%;
        padding-left: var(--input-left-padding);

        font-family: var(--text-font);
        color: var(--dark-text-color);
      }

      .seriesdescriptionlabel {
        font-weight: 700;
        letter-spacing: 0.02em;
        word-spacing: 0.05em;
      }

      .seriesdescriptioninput,
      #seriesdescription {
        background: rgb(255, 255, 255);
        background: linear-gradient(90deg, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0) 40%, rgba(255, 255, 255, 0) 100%);
        border-color: #ffffffff;
        border-width: 0;
    
        margin-bottom: 2.5em;
        font-size: 0.9em;

        max-width: 100%;

        font-family: var(--text-font);
        color: var(--dark-text-color);

        padding-top: 0.25em;
        padding-left: var(--input-left-padding);
      }
      
      .layernamelabel {
      
        font-weight: 700;
        letter-spacing: 0.02em;
        word-spacing: 0.05em;
      }
      
      .filelabel {
        margin-top: 1em;
      }
      
      /* https://cssgradient.io */
      
      .attributeinput,
      .layernameinput {
        background: rgb(255, 255, 255);
        background: linear-gradient(90deg, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0) 40%, rgba(255, 255, 255, 0) 100%);
        border-color: #ffffffff;
        border-width: 0;

        min-width: 50%;
        width: fit-content;

        font-family: var(--text-font);
        color: var(--dark-text-color);

        padding-left: var(--input-left-padding);
      }
      
      input[type=file]{
        width: fit-content;
        margin-bottom: 0.3em;
      }
      
      .highlight {
      
        /* https://www.color-morph.com */
      
        background-color: #ffffff;
        background-image: radial-gradient(at 38% 48%, hsla(55, 93%, 56%, 1) 0, hsla(55, 93%, 56%, 0) 50%),
          radial-gradient(at 50% 23%, rgb(244, 103, 162) 0, hsla(120, 86%, 68%, 0) 50%),
          radial-gradient(at 66% 1%, hsla(358, 94%, 60%, 1) 0, hsla(358, 94%, 60%, 0) 50%),
          radial-gradient(at 9% 66%, hsla(330, 93%, 56%, 1) 0, hsla(330, 93%, 56%, 0) 50%),
          radial-gradient(at 83% 49%, rgb(245, 241, 23) 0, hsla(115, 89%, 56%, 0) 50%),
          radial-gradient(at 61% 36%, hsla(322, 90%, 50%, 1) 0, hsla(322, 90%, 50%, 0) 50%);
      }
      
      .layer-thumbnail {
        width: 10vw;
        min-width: 64px;
      
        /* https://www.cssmatic.com/box-shadow */
        box-shadow: 10px 10px 50px -20px rgba(255, 255, 255, 0.5);
      }
      
      #uploadall,
      #mintbutton {
        margin-top: 5vw;
        margin-left: 2vw;
        padding: 1em;
        background-color: var(--button-color);
        border-radius: 1em;
        border-width: 0;
        box-shadow: 0.5em 0.5em 0 0 var(--button-shadow-color);
        color: var(--button-text-color);
        user-select: none;
      }
      
      #uploadall:hover,  
      #mintbutton:hover {
        background-color: var(--feedback-color);
      }
      
      #uploadall:active,  
      #mintbutton:active{
        background-color: var(--selected-color);
        color: var(--highlight-color);
      }

      #uploadall.inactive,
      #mintbutton.inactive {
        background-color: var(--inactive-color);
        color: var(--inactive-button-text-color);
        cursor: default;
      }
      
      #uploadall.inactive:hover,
      #mintbutton.inactive:hover {
        background-color: var(--inactive-color);
      }

      .waiting {
        background-image: linear-gradient(270deg, #aec2fc, #66eb69, #ec85f4, #aec2fc);
        animation: scrollingBackground 40s infinite linear;
        color: var(--inactive-button-text-color);
        cursor: default;
      }

      @keyframes scrollingBackground {
        0% {
          background-position: 0 0
        }

        100% {
          background-position: 1000vw 0
        }
      }

      #mintbutton.done {
        background-color: var(--done-color);
        color: var(--inactive-button-text-color);
        cursor: default;
      }
      
      #mintbutton.done:hover {
        background-color: var(--done-color);
      }

      #mintbutton.failed {
        background-color: var(--fail-color);
        color: var(--inactive-button-text-color);
        cursor: default;
      }

      /* gallery  */

      .gallery{
        display: block;
        
      }

      gallery-thumbnail, 
      infos-thumbnail{
        min-width: 64px;
        max-width: 256px;

        background: var(--background-color);
        display: inline-block;
        margin-bottom: 1em;

        font-size: 70%;
      }

      gallery-thumbnail{
        width: 32%;
      }

      /* 3x0+2 = 2, 3x1+ 2 = 5 , 3x6+2 = 8 */

      gallery-thumbnail:nth-child(3n+2){
        margin-left: 2%;
        margin-right: 2%;

      }

      .gallerythumbnailname, 
      .gallerythumbnailcreator{
        margin-left: 1em;
        margin-right: 1em;
        margin-bottom: 1em;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
          
      }
      

      .gallerythumbnail a {
       color: var(--button-color)
      }

      
      /* 
      using new aspect ratio property. Sadly not supported on Safari version released before september 2021 
      That's why we also use the gallerythumbnailimagesizer padding trick, that we could drop in a year or two
      more solutions: https://stackoverflow.com/questions/5445491/height-equal-to-dynamic-width-css-fluid-layout 
      */

      .gallerythumbnailimagesizer{
        position: relative;
        width: 100%;
        height: 0;
        padding-bottom: 100%;
      }

      .gallerythumbnailimagesizer.spinner{
        background-position: center center;
        background-size: 100%;
        background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg width='692' height='692' viewBox='0 0 692 692' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M183.6 234.5C184.8 234.5 185.667 234.233 186.2 233.7C186.733 233.167 187.567 232.033 188.7 230.3L200.9 211.7C201.3 211.033 201.733 210.6 202.2 210.4C202.733 210.133 203.267 210 203.8 210H205.5C206.433 210 207.1 210.267 207.5 210.8C207.967 211.267 208.2 212.033 208.2 213.1V264H207.2V213.1C207.2 212.567 207.067 212.1 206.8 211.7C206.6 211.233 206.167 211 205.5 211H204C203.533 211 203.133 211.067 202.8 211.2C202.467 211.333 202.1 211.733 201.7 212.4L189.5 230.8C188.3 232.6 187.367 233.833 186.7 234.5C186.1 235.167 185.067 235.5 183.6 235.5C182.133 235.5 181.067 235.167 180.4 234.5C179.8 233.833 178.9 232.6 177.7 230.8L165.5 212.4C165.1 211.733 164.7 211.333 164.3 211.2C163.967 211.067 163.567 211 163.1 211H161.6C160.933 211 160.5 211.233 160.3 211.7C160.1 212.1 160 212.567 160 213.1V264H159V213.1C159 212.033 159.2 211.267 159.6 210.8C160.067 210.267 160.733 210 161.6 210H163.3C163.833 210 164.367 210.133 164.9 210.4C165.433 210.6 165.9 211.033 166.3 211.7L178.5 230.3C179.633 232.033 180.467 233.167 181 233.7C181.533 234.233 182.4 234.5 183.6 234.5ZM166.9 273C168.167 273 169.067 272.733 169.6 272.2C170.2 271.6 170.5 270.667 170.5 269.4V234.2L176.4 245.1C177 246.233 177.7 247.067 178.5 247.6C179.367 248.067 180.433 248.3 181.7 248.3H185.7C186.967 248.3 188 248.067 188.8 247.6C189.667 247.067 190.4 246.233 191 245.1L196.9 234.2V269.4C196.9 270.667 197.167 271.6 197.7 272.2C198.3 272.733 199.233 273 200.5 273H215.9C217.167 273 218.067 272.733 218.6 272.2C219.2 271.6 219.5 270.667 219.5 269.4V204.6C219.5 203.333 219.2 202.433 218.6 201.9C218.067 201.3 217.167 201 215.9 201H199.7C198.633 201 197.733 201.233 197 201.7C196.333 202.167 195.7 202.933 195.1 204L186.2 220.3C185.867 220.9 185.567 221.333 185.3 221.6C185.1 221.867 184.8 222 184.4 222H183.5C183.1 222 182.767 221.867 182.5 221.6C182.3 221.333 182.033 220.9 181.7 220.3L172.7 204C172.1 202.933 171.433 202.167 170.7 201.7C170.033 201.233 169.167 201 168.1 201H152C150.733 201 149.8 201.3 149.2 201.9C148.667 202.433 148.4 203.333 148.4 204.6V269.4C148.4 270.667 148.667 271.6 149.2 272.2C149.8 272.733 150.733 273 152 273H166.9ZM170.1 273.1L157.1 283.9C156.833 284.167 156.4 284.4 155.8 284.6C155.267 284.8 154.667 284.9 154 284.9H139.1C137.5 284.9 136.333 284.533 135.6 283.8C134.867 283.067 134.5 281.9 134.5 280.3V215.5C134.5 214.633 134.6 213.9 134.8 213.3C135.067 212.7 135.433 212.2 135.9 211.8L148.8 200.9C149.133 200.633 149.567 200.433 150.1 200.3C150.7 200.1 151.333 200 152 200H168.1C169.367 200 170.4 200.267 171.2 200.8C172.067 201.333 172.867 202.233 173.6 203.5L180.4 216L181.3 214.4C181.567 213.933 181.833 213.5 182.1 213.1C182.433 212.633 182.767 212.267 183.1 212L196 201.2C196.533 200.8 197.067 200.5 197.6 200.3C198.2 200.1 198.9 200 199.7 200H215.9C217.5 200 218.667 200.367 219.4 201.1C220.133 201.833 220.5 203 220.5 204.6V269.4C220.5 270.267 220.367 271 220.1 271.6C219.9 272.2 219.567 272.7 219.1 273.1L206.1 283.9C205.833 284.167 205.4 284.4 204.8 284.6C204.267 284.8 203.667 284.9 203 284.9H187.6C185.933 284.9 184.733 284.533 184 283.8C183.333 283.067 183 281.9 183 280.3V253.9L177.1 258.8C176.567 259.267 175.933 259.633 175.2 259.9C174.533 260.1 173.733 260.2 172.8 260.2H171.5V269.4C171.5 270.267 171.367 271 171.1 271.6C170.9 272.2 170.567 272.7 170.1 273.1ZM275.022 284.9H232.422C230.822 284.9 229.655 284.533 228.922 283.8C228.189 283.067 227.822 281.9 227.822 280.3V268.4C227.822 267.533 227.922 266.8 228.122 266.2C228.389 265.6 228.755 265.1 229.222 264.7L241.322 254.5V232.2H232.422C230.822 232.2 229.655 231.833 228.922 231.1C228.189 230.367 227.822 229.2 227.822 227.6V215.5C227.822 214.633 227.922 213.9 228.122 213.3C228.389 212.7 228.755 212.2 229.222 211.8L242.122 200.9C242.455 200.633 242.889 200.433 243.422 200.3C244.022 200.1 244.655 200 245.322 200H287.922C289.522 200 290.689 200.367 291.422 201.1C292.155 201.833 292.522 203 292.522 204.6V216.7C292.522 217.567 292.389 218.3 292.122 218.9C291.922 219.5 291.589 220 291.122 220.4L279.222 230.4V252.9H287.922C289.522 252.9 290.689 253.267 291.422 254C292.155 254.733 292.522 255.9 292.522 257.5V269.4C292.522 270.267 292.389 271 292.122 271.6C291.922 272.2 291.589 272.7 291.122 273.1L278.122 283.9C277.855 284.167 277.422 284.4 276.822 284.6C276.289 284.8 275.689 284.9 275.022 284.9ZM245.322 273H287.922C289.189 273 290.089 272.733 290.622 272.2C291.222 271.6 291.522 270.667 291.522 269.4V257.5C291.522 256.233 291.222 255.333 290.622 254.8C290.089 254.2 289.189 253.9 287.922 253.9H278.222V220.3H287.922C289.189 220.3 290.089 220.033 290.622 219.5C291.222 218.9 291.522 217.967 291.522 216.7V204.6C291.522 203.333 291.222 202.433 290.622 201.9C290.089 201.3 289.189 201 287.922 201H245.322C244.055 201 243.122 201.3 242.522 201.9C241.989 202.433 241.722 203.333 241.722 204.6V216.7C241.722 217.967 241.989 218.9 242.522 219.5C243.122 220.033 244.055 220.3 245.322 220.3H255.222V253.9H245.322C244.055 253.9 243.122 254.2 242.522 254.8C241.989 255.333 241.722 256.233 241.722 257.5V269.4C241.722 270.667 241.989 271.6 242.522 272.2C243.122 272.733 244.055 273 245.322 273ZM282.522 264H250.722V263H266.222V211H250.722V210H282.522V211H267.222V263H282.522V264ZM327.03 210.8L363.83 252.2V210H364.83V264H363.83V253.7L326.03 211.3C325.963 211.233 325.863 211.167 325.73 211.1C325.663 211.033 325.596 211 325.53 211C325.463 211 325.396 211.033 325.33 211.1C325.33 211.167 325.33 211.233 325.33 211.3V264H324.33V211.1C324.33 210.7 324.463 210.4 324.73 210.2C324.996 210 325.263 209.9 325.53 209.9C325.796 209.9 326.03 209.967 326.23 210.1C326.43 210.233 326.696 210.467 327.03 210.8ZM332.43 273C333.696 273 334.596 272.733 335.13 272.2C335.73 271.6 336.03 270.667 336.03 269.4V236.4L353.13 257.1V269.4C353.13 270.667 353.396 271.6 353.93 272.2C354.53 272.733 355.463 273 356.73 273H371.73C372.996 273 373.896 272.733 374.43 272.2C375.03 271.6 375.33 270.667 375.33 269.4V204.6C375.33 203.333 375.03 202.433 374.43 201.9C373.896 201.3 372.996 201 371.73 201H356.73C355.463 201 354.53 201.3 353.93 201.9C353.396 202.433 353.13 203.333 353.13 204.6V225.9L333.73 203.7C332.863 202.7 331.963 202 331.03 201.6C330.163 201.2 329.096 201 327.83 201H317.43C316.163 201 315.23 201.3 314.63 201.9C314.096 202.433 313.83 203.333 313.83 204.6V269.4C313.83 270.667 314.096 271.6 314.63 272.2C315.23 272.733 316.163 273 317.43 273H332.43ZM335.63 273.1L322.63 283.9C322.363 284.167 321.93 284.4 321.33 284.6C320.796 284.8 320.196 284.9 319.53 284.9H304.53C302.93 284.9 301.763 284.533 301.03 283.8C300.296 283.067 299.93 281.9 299.93 280.3V215.5C299.93 214.633 300.03 213.9 300.23 213.3C300.496 212.7 300.863 212.2 301.33 211.8L314.23 200.9C314.563 200.633 314.996 200.433 315.53 200.3C316.13 200.1 316.763 200 317.43 200H327.83C329.296 200 330.53 200.233 331.53 200.7C332.53 201.167 333.53 201.933 334.53 203L341.43 211L353.53 200.9C353.863 200.633 354.296 200.433 354.83 200.3C355.43 200.1 356.063 200 356.73 200H371.73C373.33 200 374.496 200.367 375.23 201.1C375.963 201.833 376.33 203 376.33 204.6V269.4C376.33 270.267 376.196 271 375.93 271.6C375.73 272.2 375.396 272.7 374.93 273.1L361.93 283.9C361.663 284.167 361.23 284.4 360.63 284.6C360.096 284.8 359.496 284.9 358.83 284.9H343.83C342.23 284.9 341.063 284.533 340.33 283.8C339.596 283.067 339.23 281.9 339.23 280.3V268.4L337.03 265.7V269.4C337.03 270.267 336.896 271 336.63 271.6C336.43 272.2 336.096 272.7 335.63 273.1ZM430.784 284.9H388.184C386.584 284.9 385.417 284.533 384.684 283.8C383.95 283.067 383.584 281.9 383.584 280.3V268.4C383.584 267.533 383.684 266.8 383.884 266.2C384.15 265.6 384.517 265.1 384.984 264.7L397.084 254.5V232.2H388.184C386.584 232.2 385.417 231.833 384.684 231.1C383.95 230.367 383.584 229.2 383.584 227.6V215.5C383.584 214.633 383.684 213.9 383.884 213.3C384.15 212.7 384.517 212.2 384.984 211.8L397.884 200.9C398.217 200.633 398.65 200.433 399.184 200.3C399.784 200.1 400.417 200 401.084 200H443.684C445.284 200 446.45 200.367 447.184 201.1C447.917 201.833 448.284 203 448.284 204.6V216.7C448.284 217.567 448.15 218.3 447.884 218.9C447.684 219.5 447.35 220 446.884 220.4L434.984 230.4V252.9H443.684C445.284 252.9 446.45 253.267 447.184 254C447.917 254.733 448.284 255.9 448.284 257.5V269.4C448.284 270.267 448.15 271 447.884 271.6C447.684 272.2 447.35 272.7 446.884 273.1L433.884 283.9C433.617 284.167 433.184 284.4 432.584 284.6C432.05 284.8 431.45 284.9 430.784 284.9ZM401.084 273H443.684C444.95 273 445.85 272.733 446.384 272.2C446.984 271.6 447.284 270.667 447.284 269.4V257.5C447.284 256.233 446.984 255.333 446.384 254.8C445.85 254.2 444.95 253.9 443.684 253.9H433.984V220.3H443.684C444.95 220.3 445.85 220.033 446.384 219.5C446.984 218.9 447.284 217.967 447.284 216.7V204.6C447.284 203.333 446.984 202.433 446.384 201.9C445.85 201.3 444.95 201 443.684 201H401.084C399.817 201 398.884 201.3 398.284 201.9C397.75 202.433 397.484 203.333 397.484 204.6V216.7C397.484 217.967 397.75 218.9 398.284 219.5C398.884 220.033 399.817 220.3 401.084 220.3H410.984V253.9H401.084C399.817 253.9 398.884 254.2 398.284 254.8C397.75 255.333 397.484 256.233 397.484 257.5V269.4C397.484 270.667 397.75 271.6 398.284 272.2C398.884 272.733 399.817 273 401.084 273ZM438.284 264H406.484V263H421.984V211H406.484V210H438.284V211H422.984V263H438.284V264ZM179.2 484.8H148.2C145 484.8 142.667 484.067 141.2 482.6C139.733 481.133 139 478.8 139 475.6V346C139 344.267 139.2 342.8 139.6 341.6C140.133 340.4 140.867 339.4 141.8 338.6L167.6 316.8C168.267 316.267 169.133 315.867 170.2 315.6C171.4 315.2 172.667 315 174 315H235.2C244.667 315 252.6 316 259 318C265.4 320 270.467 322.8 274.2 326.4C277.933 330 280.533 334.333 282 339.4C283.6 344.467 284.4 350 284.4 356V381.6C284.4 388 283.467 393.867 281.6 399.2C279.867 404.4 276.8 408.867 272.4 412.6L246.4 434.2C243.067 437 238.733 439.333 233.4 441.2C228.2 442.933 221.8 443.933 214.2 444.2V453.8C214.2 455.533 213.933 457 213.4 458.2C213 459.4 212.333 460.4 211.4 461.2L185.4 482.8C184.867 483.333 184 483.8 182.8 484.2C181.733 484.6 180.533 484.8 179.2 484.8ZM205 461C207.533 461 209.333 460.467 210.4 459.4C211.6 458.2 212.2 456.333 212.2 453.8V420.6H235.2C253.333 420.6 265.733 417 272.4 409.8C279.067 402.6 282.4 393.2 282.4 381.6V356C282.4 344.4 279.067 335 272.4 327.8C265.733 320.6 253.333 317 235.2 317H174C171.467 317 169.6 317.6 168.4 318.8C167.333 319.867 166.8 321.667 166.8 324.2V453.8C166.8 456.333 167.333 458.2 168.4 459.4C169.6 460.467 171.467 461 174 461H205ZM232.4 403.6H191.2V443H189.2V335H232.4C238.667 335 243.733 335.733 247.6 337.2C251.6 338.533 254.667 340.4 256.8 342.8C258.933 345.2 260.4 348.067 261.2 351.4C262 354.733 262.4 358.333 262.4 362.2V377C262.4 380.867 262 384.467 261.2 387.8C260.4 391 258.933 393.8 256.8 396.2C254.667 398.467 251.6 400.267 247.6 401.6C243.733 402.933 238.667 403.6 232.4 403.6ZM191.2 401.6H232.4C238.267 401.6 243 401 246.6 399.8C250.333 398.6 253.2 396.933 255.2 394.8C257.2 392.533 258.533 389.933 259.2 387C260 383.933 260.4 380.6 260.4 377V362.2C260.4 358.6 260 355.267 259.2 352.2C258.533 349.133 257.2 346.467 255.2 344.2C253.2 341.933 250.333 340.2 246.6 339C243 337.667 238.267 337 232.4 337H191.2V401.6ZM211.8 354.4H229.8C233.667 354.4 236.2 355.4 237.4 357.4C238.6 359.4 239.2 361.667 239.2 364.2V374.8C239.2 377.333 238.6 379.6 237.4 381.6C236.2 383.6 233.667 384.6 229.8 384.6H211.8V354.4ZM335.645 484.8H304.645C301.445 484.8 299.112 484.067 297.645 482.6C296.179 481.133 295.445 478.8 295.445 475.6V346C295.445 344.267 295.645 342.8 296.045 341.6C296.579 340.4 297.312 339.4 298.245 338.6L324.045 316.8C324.712 316.267 325.579 315.867 326.645 315.6C327.845 315.2 329.112 315 330.445 315H419.645C422.845 315 425.179 315.733 426.645 317.2C428.112 318.667 428.845 321 428.845 324.2V348C428.845 349.733 428.579 351.2 428.045 352.4C427.645 353.6 426.979 354.6 426.045 355.4L403.645 374C406.712 374 408.979 374.733 410.445 376.2C411.912 377.667 412.645 380 412.645 383.2V407.2C412.645 408.933 412.379 410.4 411.845 411.6C411.445 412.8 410.779 413.8 409.845 414.6L383.845 436.2C383.312 436.733 382.445 437.2 381.245 437.6C380.179 438 378.979 438.2 377.645 438.2H370.645V453.8C370.645 455.533 370.379 457 369.845 458.2C369.445 459.4 368.779 460.4 367.845 461.2L341.845 482.8C341.312 483.333 340.445 483.8 339.245 484.2C338.179 484.6 336.979 484.8 335.645 484.8ZM361.445 461C363.979 461 365.779 460.467 366.845 459.4C368.045 458.2 368.645 456.333 368.645 453.8V414.4H403.445C405.979 414.4 407.779 413.867 408.845 412.8C410.045 411.6 410.645 409.733 410.645 407.2V383.2C410.645 380.667 410.045 378.867 408.845 377.8C407.779 376.6 405.979 376 403.445 376H368.645V355.2H419.645C422.179 355.2 423.979 354.667 425.045 353.6C426.245 352.4 426.845 350.533 426.845 348V324.2C426.845 321.667 426.245 319.867 425.045 318.8C423.979 317.6 422.179 317 419.645 317H330.445C327.912 317 326.045 317.6 324.845 318.8C323.779 319.867 323.245 321.667 323.245 324.2V453.8C323.245 456.333 323.779 458.2 324.845 459.4C326.045 460.467 327.912 461 330.445 461H361.445ZM345.045 443V335H408.845V337H347.045V394.2H392.645V396.2H347.045V443H345.045ZM479.2 484.8H448.2C445 484.8 442.667 484.067 441.2 482.6C439.733 481.133 439 478.8 439 475.6V346C439 344.267 439.2 342.8 439.6 341.6C440.133 340.4 440.867 339.4 441.8 338.6L467.6 316.8C468.267 316.267 469.133 315.867 470.2 315.6C471.4 315.2 472.667 315 474 315H535.2C544.667 315 552.6 316 559 318C565.4 320 570.467 322.8 574.2 326.4C577.933 330 580.533 334.333 582 339.4C583.6 344.467 584.4 350 584.4 356V381.6C584.4 388 583.467 393.867 581.6 399.2C579.867 404.4 576.8 408.867 572.4 412.6L546.4 434.2C543.067 437 538.733 439.333 533.4 441.2C528.2 442.933 521.8 443.933 514.2 444.2V453.8C514.2 455.533 513.933 457 513.4 458.2C513 459.4 512.333 460.4 511.4 461.2L485.4 482.8C484.867 483.333 484 483.8 482.8 484.2C481.733 484.6 480.533 484.8 479.2 484.8ZM505 461C507.533 461 509.333 460.467 510.4 459.4C511.6 458.2 512.2 456.333 512.2 453.8V420.6H535.2C553.333 420.6 565.733 417 572.4 409.8C579.067 402.6 582.4 393.2 582.4 381.6V356C582.4 344.4 579.067 335 572.4 327.8C565.733 320.6 553.333 317 535.2 317H474C471.467 317 469.6 317.6 468.4 318.8C467.333 319.867 466.8 321.667 466.8 324.2V453.8C466.8 456.333 467.333 458.2 468.4 459.4C469.6 460.467 471.467 461 474 461H505ZM532.4 403.6H491.2V443H489.2V335H532.4C538.667 335 543.733 335.733 547.6 337.2C551.6 338.533 554.667 340.4 556.8 342.8C558.933 345.2 560.4 348.067 561.2 351.4C562 354.733 562.4 358.333 562.4 362.2V377C562.4 380.867 562 384.467 561.2 387.8C560.4 391 558.933 393.8 556.8 396.2C554.667 398.467 551.6 400.267 547.6 401.6C543.733 402.933 538.667 403.6 532.4 403.6ZM491.2 401.6H532.4C538.267 401.6 543 401 546.6 399.8C550.333 398.6 553.2 396.933 555.2 394.8C557.2 392.533 558.533 389.933 559.2 387C560 383.933 560.4 380.6 560.4 377V362.2C560.4 358.6 560 355.267 559.2 352.2C558.533 349.133 557.2 346.467 555.2 344.2C553.2 341.933 550.333 340.2 546.6 339C543 337.667 538.267 337 532.4 337H491.2V401.6ZM511.8 354.4H529.8C533.667 354.4 536.2 355.4 537.4 357.4C538.6 359.4 539.2 361.667 539.2 364.2V374.8C539.2 377.333 538.6 379.6 537.4 381.6C536.2 383.6 533.667 384.6 529.8 384.6H511.8V354.4Z' fill='black' fill-opacity='0.15'/%3e%3cpath d='M186.2 233.7L187.261 234.761L187.261 234.761L186.2 233.7ZM188.7 230.3L187.446 229.477L187.445 229.479L188.7 230.3ZM200.9 211.7L202.154 212.523L202.171 212.498L202.186 212.472L200.9 211.7ZM202.2 210.4L202.791 211.779L202.831 211.761L202.871 211.742L202.2 210.4ZM207.5 210.8L206.3 211.7L206.364 211.785L206.439 211.861L207.5 210.8ZM208.2 264V265.5H209.7V264H208.2ZM207.2 264H205.7V265.5H207.2V264ZM206.8 211.7L205.421 212.291L205.476 212.417L205.552 212.532L206.8 211.7ZM201.7 212.4L202.95 213.229L202.969 213.201L202.986 213.172L201.7 212.4ZM189.5 230.8L190.748 231.632L190.75 231.629L189.5 230.8ZM186.7 234.5L185.639 233.439L185.611 233.467L185.585 233.497L186.7 234.5ZM180.4 234.5L179.285 235.503L179.311 235.533L179.339 235.561L180.4 234.5ZM177.7 230.8L176.45 231.629L176.452 231.632L177.7 230.8ZM165.5 212.4L164.214 213.172L164.231 213.201L164.25 213.229L165.5 212.4ZM164.3 211.2L163.743 212.593L163.784 212.609L163.826 212.623L164.3 211.2ZM160.3 211.7L161.642 212.371L161.661 212.331L161.679 212.291L160.3 211.7ZM160 264V265.5H161.5V264H160ZM159 264H157.5V265.5H159V264ZM159.6 210.8L158.471 209.812L158.466 209.818L158.461 209.824L159.6 210.8ZM164.9 210.4L164.229 211.742L164.3 211.777L164.373 211.804L164.9 210.4ZM166.3 211.7L165.014 212.472L165.029 212.498L165.046 212.523L166.3 211.7ZM178.5 230.3L179.755 229.479L179.754 229.477L178.5 230.3ZM181 233.7L182.061 232.639L182.061 232.639L181 233.7ZM169.6 272.2L170.661 273.261L170.661 273.261L169.6 272.2ZM170.5 234.2L171.819 233.486L169 234.2H170.5ZM176.4 245.1L177.726 244.398L177.719 244.386L176.4 245.1ZM178.5 247.6L177.668 248.848L177.727 248.887L177.789 248.921L178.5 247.6ZM188.8 247.6L189.556 248.896L189.571 248.887L189.586 248.877L188.8 247.6ZM191 245.1L189.681 244.386L189.674 244.398L191 245.1ZM196.9 234.2H198.4L195.581 233.486L196.9 234.2ZM197.7 272.2L196.579 273.197L196.638 273.262L196.703 273.321L197.7 272.2ZM218.6 272.2L219.661 273.261L219.661 273.261L218.6 272.2ZM218.6 201.9L217.479 202.897L217.538 202.962L217.603 203.021L218.6 201.9ZM197 201.7L196.195 200.434L196.167 200.452L196.14 200.471L197 201.7ZM195.1 204L193.793 203.265L193.788 203.273L193.783 203.281L195.1 204ZM186.2 220.3L187.511 221.028L187.517 221.019L186.2 220.3ZM185.3 221.6L184.239 220.539L184.164 220.615L184.1 220.7L185.3 221.6ZM182.5 221.6L181.3 222.5L181.364 222.585L181.439 222.661L182.5 221.6ZM181.7 220.3L180.387 221.025L180.389 221.028L181.7 220.3ZM172.7 204L174.013 203.275L174.007 203.265L172.7 204ZM170.7 201.7L169.84 202.929L169.867 202.948L169.895 202.965L170.7 201.7ZM149.2 201.9L148.139 200.839L148.139 200.839L149.2 201.9ZM149.2 272.2L148.079 273.197L148.138 273.262L148.203 273.321L149.2 272.2ZM170.1 273.1L171.059 274.254L171.067 274.246L171.076 274.239L170.1 273.1ZM157.1 283.9L156.141 282.746L156.088 282.79L156.039 282.839L157.1 283.9ZM155.8 284.6L155.326 283.177L155.299 283.186L155.273 283.196L155.8 284.6ZM135.6 283.8L134.539 284.861L135.6 283.8ZM134.8 213.3L133.429 212.691L133.4 212.757L133.377 212.826L134.8 213.3ZM135.9 211.8L134.932 210.654L134.924 210.661L135.9 211.8ZM148.8 200.9L147.863 199.729L147.847 199.741L147.832 199.754L148.8 200.9ZM150.1 200.3L150.464 201.755L150.52 201.741L150.574 201.723L150.1 200.3ZM171.2 200.8L170.368 202.048L170.391 202.063L170.414 202.077L171.2 200.8ZM173.6 203.5L174.918 202.783L174.908 202.766L174.898 202.748L173.6 203.5ZM180.4 216L179.082 216.717L180.378 219.099L181.707 216.735L180.4 216ZM181.3 214.4L179.998 213.656L179.993 213.665L181.3 214.4ZM182.1 213.1L180.879 212.228L180.865 212.248L180.852 212.268L182.1 213.1ZM183.1 212L184.037 213.171L184.05 213.161L184.063 213.15L183.1 212ZM196 201.2L195.1 200L195.068 200.024L195.037 200.05L196 201.2ZM197.6 200.3L197.126 198.877L197.099 198.886L197.073 198.896L197.6 200.3ZM219.4 201.1L220.461 200.039L220.461 200.039L219.4 201.1ZM220.1 271.6L218.729 270.991L218.7 271.057L218.677 271.126L220.1 271.6ZM219.1 273.1L220.059 274.254L220.067 274.246L220.076 274.239L219.1 273.1ZM206.1 283.9L205.141 282.746L205.088 282.79L205.039 282.839L206.1 283.9ZM204.8 284.6L204.326 283.177L204.299 283.186L204.273 283.196L204.8 284.6ZM184 283.8L182.89 284.809L182.914 284.835L182.939 284.861L184 283.8ZM183 253.9H184.5V250.704L182.042 252.746L183 253.9ZM177.1 258.8L176.142 257.646L176.127 257.658L176.112 257.671L177.1 258.8ZM175.2 259.9L175.631 261.337L175.672 261.324L175.713 261.31L175.2 259.9ZM171.5 260.2V258.7H170V260.2H171.5ZM171.1 271.6L169.729 270.991L169.7 271.057L169.677 271.126L171.1 271.6ZM183.6 236C184.971 236 186.318 235.703 187.261 234.761L185.139 232.639C185.015 232.764 184.629 233 183.6 233V236ZM187.261 234.761C187.92 234.102 188.831 232.841 189.955 231.121L187.445 229.479C186.302 231.226 185.547 232.232 185.139 232.639L187.261 234.761ZM189.954 231.123L202.154 212.523L199.646 210.877L187.446 229.477L189.954 231.123ZM202.186 212.472C202.505 211.941 202.731 211.804 202.791 211.779L201.609 209.021C200.736 209.396 200.095 210.126 199.614 210.928L202.186 212.472ZM202.871 211.742C203.221 211.567 203.526 211.5 203.8 211.5V208.5C203.008 208.5 202.246 208.7 201.529 209.058L202.871 211.742ZM203.8 211.5H205.5V208.5H203.8V211.5ZM205.5 211.5C206.162 211.5 206.285 211.681 206.3 211.7L208.7 209.9C207.915 208.853 206.704 208.5 205.5 208.5V211.5ZM206.439 211.861C206.494 211.915 206.7 212.196 206.7 213.1H209.7C209.7 211.87 209.44 210.618 208.561 209.739L206.439 211.861ZM206.7 213.1V264H209.7V213.1H206.7ZM208.2 262.5H207.2V265.5H208.2V262.5ZM208.7 264V213.1H205.7V264H208.7ZM208.7 213.1C208.7 212.304 208.497 211.541 208.048 210.868L205.552 212.532C205.637 212.659 205.7 212.829 205.7 213.1H208.7ZM208.179 211.109C207.95 210.575 207.562 210.137 207.036 209.854C206.537 209.586 205.997 209.5 205.5 209.5V212.5C205.669 212.5 205.679 212.531 205.614 212.496C205.578 212.476 205.534 212.445 205.494 212.4C205.454 212.356 205.432 212.315 205.421 212.291L208.179 211.109ZM205.5 209.5H204V212.5H205.5V209.5ZM204 209.5C203.397 209.5 202.798 209.585 202.243 209.807L203.357 212.593C203.469 212.548 203.67 212.5 204 212.5V209.5ZM202.243 209.807C201.788 209.989 201.434 210.298 201.169 210.586C200.896 210.885 200.645 211.242 200.414 211.628L202.986 213.172C203.155 212.891 203.288 212.715 203.381 212.614C203.483 212.502 203.479 212.544 203.357 212.593L202.243 209.807ZM200.45 211.571L188.25 229.971L190.75 231.629L202.95 213.229L200.45 211.571ZM188.252 229.968C187.055 231.764 186.192 232.887 185.639 233.439L187.761 235.561C188.542 234.78 189.545 233.436 190.748 231.632L188.252 229.968ZM185.585 233.497C185.407 233.694 184.903 234 183.6 234V237C185.23 237 186.793 236.639 187.815 235.503L185.585 233.497ZM183.6 234C182.316 234 181.724 233.702 181.461 233.439L179.339 235.561C180.41 236.631 181.951 237 183.6 237V234ZM181.515 233.497C180.995 232.919 180.148 231.768 178.948 229.968L176.452 231.632C177.652 233.432 178.605 234.747 179.285 235.503L181.515 233.497ZM178.95 229.971L166.75 211.571L164.25 213.229L176.45 231.629L178.95 229.971ZM166.786 211.628C166.339 210.884 165.702 210.086 164.774 209.777L163.826 212.623C163.743 212.595 163.75 212.572 163.839 212.661C163.927 212.748 164.055 212.907 164.214 213.172L166.786 211.628ZM164.857 209.807C164.302 209.585 163.703 209.5 163.1 209.5V212.5C163.43 212.5 163.631 212.548 163.743 212.593L164.857 209.807ZM163.1 209.5H161.6V212.5H163.1V209.5ZM161.6 209.5C161.103 209.5 160.563 209.586 160.064 209.854C159.538 210.137 159.15 210.575 158.921 211.109L161.679 212.291C161.668 212.315 161.646 212.356 161.606 212.4C161.566 212.445 161.522 212.476 161.486 212.496C161.421 212.531 161.431 212.5 161.6 212.5V209.5ZM158.958 211.029C158.636 211.674 158.5 212.378 158.5 213.1H161.5C161.5 212.755 161.564 212.526 161.642 212.371L158.958 211.029ZM158.5 213.1V264H161.5V213.1H158.5ZM160 262.5H159V265.5H160V262.5ZM160.5 264V213.1H157.5V264H160.5ZM160.5 213.1C160.5 212.152 160.691 211.832 160.739 211.776L158.461 209.824C157.709 210.701 157.5 211.915 157.5 213.1H160.5ZM160.729 211.788C160.848 211.651 161.061 211.5 161.6 211.5V208.5C160.406 208.5 159.285 208.882 158.471 209.812L160.729 211.788ZM161.6 211.5H163.3V208.5H161.6V211.5ZM163.3 211.5C163.574 211.5 163.879 211.567 164.229 211.742L165.571 209.058C164.854 208.7 164.092 208.5 163.3 208.5V211.5ZM164.373 211.804C164.491 211.849 164.725 211.991 165.014 212.472L167.586 210.928C167.075 210.076 166.376 209.351 165.427 208.996L164.373 211.804ZM165.046 212.523L177.246 231.123L179.754 229.477L167.554 210.877L165.046 212.523ZM177.245 231.121C178.369 232.841 179.28 234.102 179.939 234.761L182.061 232.639C181.653 232.232 180.898 231.226 179.755 229.479L177.245 231.121ZM179.939 234.761C180.882 235.703 182.229 236 183.6 236V233C182.571 233 182.185 232.764 182.061 232.639L179.939 234.761ZM166.9 274.5C168.31 274.5 169.706 274.215 170.661 273.261L168.539 271.139C168.427 271.252 168.024 271.5 166.9 271.5V274.5ZM170.661 273.261C171.655 272.267 172 270.87 172 269.4H169C169 270.463 168.745 270.933 168.539 271.139L170.661 273.261ZM172 269.4V234.2H169V269.4H172ZM169.181 234.914L175.081 245.814L177.719 244.386L171.819 233.486L169.181 234.914ZM175.074 245.802C175.754 247.085 176.603 248.138 177.668 248.848L179.332 246.352C178.797 245.995 178.246 245.382 177.726 244.398L175.074 245.802ZM177.789 248.921C178.928 249.534 180.254 249.8 181.7 249.8V246.8C180.612 246.8 179.805 246.599 179.211 246.279L177.789 248.921ZM181.7 249.8H185.7V246.8H181.7V249.8ZM185.7 249.8C187.139 249.8 188.457 249.537 189.556 248.896L188.044 246.304C187.543 246.597 186.795 246.8 185.7 246.8V249.8ZM189.586 248.877C190.733 248.172 191.633 247.111 192.326 245.802L189.674 244.398C189.167 245.356 188.6 245.962 188.014 246.323L189.586 248.877ZM192.319 245.814L198.219 234.914L195.581 233.486L189.681 244.386L192.319 245.814ZM195.4 234.2V269.4H198.4V234.2H195.4ZM195.4 269.4C195.4 270.832 195.694 272.201 196.579 273.197L198.821 271.203C198.639 270.999 198.4 270.501 198.4 269.4H195.4ZM196.703 273.321C197.699 274.206 199.068 274.5 200.5 274.5V271.5C199.399 271.5 198.901 271.261 198.697 271.079L196.703 273.321ZM200.5 274.5H215.9V271.5H200.5V274.5ZM215.9 274.5C217.31 274.5 218.706 274.215 219.661 273.261L217.539 271.139C217.427 271.252 217.024 271.5 215.9 271.5V274.5ZM219.661 273.261C220.655 272.267 221 270.87 221 269.4H218C218 270.463 217.745 270.933 217.539 271.139L219.661 273.261ZM221 269.4V204.6H218V269.4H221ZM221 204.6C221 203.149 220.663 201.726 219.597 200.779L217.603 203.021C217.737 203.14 218 203.518 218 204.6H221ZM219.721 200.903C218.774 199.837 217.351 199.5 215.9 199.5V202.5C216.982 202.5 217.36 202.763 217.479 202.897L219.721 200.903ZM215.9 199.5H199.7V202.5H215.9V199.5ZM199.7 199.5C198.413 199.5 197.218 199.783 196.195 200.434L197.805 202.965C198.248 202.683 198.854 202.5 199.7 202.5V199.5ZM196.14 200.471C195.22 201.115 194.452 202.092 193.793 203.265L196.407 204.735C196.948 203.775 197.447 203.218 197.86 202.929L196.14 200.471ZM193.783 203.281L184.883 219.581L187.517 221.019L196.417 204.719L193.783 203.281ZM184.889 219.572C184.577 220.132 184.358 220.421 184.239 220.539L186.361 222.661C186.776 222.246 187.156 221.668 187.511 221.028L184.889 219.572ZM184.1 220.7C184.151 220.632 184.228 220.568 184.316 220.529C184.395 220.494 184.435 220.5 184.4 220.5V223.5C185.166 223.5 185.959 223.222 186.5 222.5L184.1 220.7ZM184.4 220.5H183.5V223.5H184.4V220.5ZM183.5 220.5C183.483 220.5 183.478 220.499 183.481 220.499C183.484 220.5 183.494 220.502 183.507 220.507C183.521 220.513 183.534 220.52 183.545 220.527C183.555 220.534 183.561 220.539 183.561 220.539L181.439 222.661C182.006 223.227 182.729 223.5 183.5 223.5V220.5ZM183.7 220.7C183.564 220.519 183.338 220.16 183.011 219.572L180.389 221.028C180.728 221.64 181.036 222.147 181.3 222.5L183.7 220.7ZM183.013 219.575L174.013 203.275L171.387 204.725L180.387 221.025L183.013 219.575ZM174.007 203.265C173.333 202.065 172.515 201.077 171.505 200.435L169.895 202.965C170.352 203.256 170.867 203.801 171.393 204.735L174.007 203.265ZM171.56 200.471C170.574 199.78 169.38 199.5 168.1 199.5V202.5C168.954 202.5 169.493 202.686 169.84 202.929L171.56 200.471ZM168.1 199.5H152V202.5H168.1V199.5ZM152 199.5C150.53 199.5 149.133 199.845 148.139 200.839L150.261 202.961C150.467 202.755 150.937 202.5 152 202.5V199.5ZM148.139 200.839C147.185 201.794 146.9 203.19 146.9 204.6H149.9C149.9 203.476 150.148 203.073 150.261 202.961L148.139 200.839ZM146.9 204.6V269.4H149.9V204.6H146.9ZM146.9 269.4C146.9 270.832 147.194 272.201 148.079 273.197L150.321 271.203C150.139 270.999 149.9 270.501 149.9 269.4H146.9ZM148.203 273.321C149.199 274.206 150.568 274.5 152 274.5V271.5C150.899 271.5 150.401 271.261 150.197 271.079L148.203 273.321ZM152 274.5H166.9V271.5H152V274.5ZM169.141 271.946L156.141 282.746L158.059 285.054L171.059 274.254L169.141 271.946ZM156.039 282.839C156.013 282.866 155.836 283.007 155.326 283.177L156.274 286.023C156.964 285.793 157.654 285.468 158.161 284.961L156.039 282.839ZM155.273 283.196C154.934 283.323 154.517 283.4 154 283.4V286.4C154.816 286.4 155.599 286.277 156.327 286.004L155.273 283.196ZM154 283.4H139.1V286.4H154V283.4ZM139.1 283.4C137.687 283.4 136.992 283.071 136.661 282.739L134.539 284.861C135.674 285.996 137.313 286.4 139.1 286.4V283.4ZM136.661 282.739C136.329 282.408 136 281.713 136 280.3H133C133 282.087 133.404 283.726 134.539 284.861L136.661 282.739ZM136 280.3V215.5H133V280.3H136ZM136 215.5C136 214.739 136.089 214.176 136.223 213.774L133.377 212.826C133.111 213.624 133 214.527 133 215.5H136ZM136.171 213.909C136.353 213.499 136.59 213.184 136.876 212.939L134.924 210.661C134.277 211.216 133.78 211.901 133.429 212.691L136.171 213.909ZM136.868 212.946L149.768 202.046L147.832 199.754L134.932 210.654L136.868 212.946ZM149.737 202.071C149.861 201.972 150.082 201.851 150.464 201.755L149.736 198.845C149.052 199.016 148.406 199.294 147.863 199.729L149.737 202.071ZM150.574 201.723C151.013 201.577 151.486 201.5 152 201.5V198.5C151.181 198.5 150.387 198.623 149.626 198.877L150.574 201.723ZM152 201.5H168.1V198.5H152V201.5ZM168.1 201.5C169.163 201.5 169.881 201.724 170.368 202.048L172.032 199.552C170.919 198.81 169.57 198.5 168.1 198.5V201.5ZM170.414 202.077C170.996 202.436 171.642 203.112 172.302 204.252L174.898 202.748C174.091 201.355 173.137 200.231 171.986 199.523L170.414 202.077ZM172.282 204.217L179.082 216.717L181.718 215.283L174.918 202.783L172.282 204.217ZM181.707 216.735L182.607 215.135L179.993 213.665L179.093 215.265L181.707 216.735ZM182.602 215.144C182.854 214.704 183.103 214.3 183.348 213.932L180.852 212.268C180.564 212.7 180.279 213.163 179.998 213.656L182.602 215.144ZM183.321 213.972C183.599 213.582 183.841 213.328 184.037 213.171L182.163 210.829C181.692 211.205 181.267 211.685 180.879 212.228L183.321 213.972ZM184.063 213.15L196.963 202.35L195.037 200.05L182.137 210.85L184.063 213.15ZM196.9 202.4C197.338 202.071 197.747 201.847 198.127 201.704L197.073 198.896C196.386 199.153 195.729 199.529 195.1 200L196.9 202.4ZM198.074 201.723C198.487 201.585 199.021 201.5 199.7 201.5V198.5C198.779 198.5 197.913 198.615 197.126 198.877L198.074 201.723ZM199.7 201.5H215.9V198.5H199.7V201.5ZM215.9 201.5C217.313 201.5 218.008 201.829 218.339 202.161L220.461 200.039C219.326 198.904 217.687 198.5 215.9 198.5V201.5ZM218.339 202.161C218.671 202.492 219 203.187 219 204.6H222C222 202.813 221.596 201.174 220.461 200.039L218.339 202.161ZM219 204.6V269.4H222V204.6H219ZM219 269.4C219 270.121 218.888 270.633 218.729 270.991L221.471 272.209C221.845 271.367 222 270.413 222 269.4H219ZM218.677 271.126C218.56 271.476 218.378 271.743 218.124 271.961L220.076 274.239C220.755 273.657 221.24 272.924 221.523 272.074L218.677 271.126ZM218.141 271.946L205.141 282.746L207.059 285.054L220.059 274.254L218.141 271.946ZM205.039 282.839C205.013 282.866 204.836 283.007 204.326 283.177L205.274 286.023C205.964 285.793 206.654 285.468 207.161 284.961L205.039 282.839ZM204.273 283.196C203.934 283.323 203.517 283.4 203 283.4V286.4C203.816 286.4 204.599 286.277 205.327 286.004L204.273 283.196ZM203 283.4H187.6V286.4H203V283.4ZM187.6 283.4C186.099 283.4 185.383 283.061 185.061 282.739L182.939 284.861C184.084 286.005 185.767 286.4 187.6 286.4V283.4ZM185.11 282.791C184.809 282.46 184.5 281.744 184.5 280.3H181.5C181.5 282.056 181.857 283.673 182.89 284.809L185.11 282.791ZM184.5 280.3V253.9H181.5V280.3H184.5ZM182.042 252.746L176.142 257.646L178.058 259.954L183.958 255.054L182.042 252.746ZM176.112 257.671C175.732 258.004 175.264 258.281 174.687 258.49L175.713 261.31C176.603 260.986 177.401 260.529 178.088 259.929L176.112 257.671ZM174.769 258.463C174.281 258.61 173.634 258.7 172.8 258.7V261.7C173.833 261.7 174.786 261.59 175.631 261.337L174.769 258.463ZM172.8 258.7H171.5V261.7H172.8V258.7ZM170 260.2V269.4H173V260.2H170ZM170 269.4C170 270.121 169.888 270.633 169.729 270.991L172.471 272.209C172.845 271.367 173 270.413 173 269.4H170ZM169.677 271.126C169.56 271.476 169.378 271.743 169.124 271.961L171.076 274.239C171.755 273.657 172.24 272.924 172.523 272.074L169.677 271.126ZM228.922 283.8L229.983 282.739L229.983 282.739L228.922 283.8ZM228.122 266.2L226.751 265.591L226.722 265.657L226.699 265.726L228.122 266.2ZM229.222 264.7L228.255 263.553L228.246 263.561L229.222 264.7ZM241.322 254.5L242.289 255.647L242.822 255.197V254.5H241.322ZM241.322 232.2H242.822V230.7H241.322V232.2ZM228.922 231.1L229.983 230.039L229.983 230.039L228.922 231.1ZM228.122 213.3L226.751 212.691L226.722 212.757L226.699 212.826L228.122 213.3ZM229.222 211.8L228.254 210.654L228.246 210.661L229.222 211.8ZM242.122 200.9L241.185 199.729L241.169 199.741L241.154 199.754L242.122 200.9ZM243.422 200.3L243.786 201.755L243.842 201.741L243.896 201.723L243.422 200.3ZM292.122 218.9L290.751 218.291L290.722 218.357L290.699 218.426L292.122 218.9ZM291.122 220.4L292.087 221.548L292.093 221.544L292.098 221.539L291.122 220.4ZM279.222 230.4L278.257 229.252L277.722 229.701V230.4H279.222ZM279.222 252.9H277.722V254.4H279.222V252.9ZM291.422 254L290.361 255.061L290.361 255.061L291.422 254ZM292.122 271.6L290.751 270.991L290.722 271.057L290.699 271.126L292.122 271.6ZM291.122 273.1L292.08 274.254L292.089 274.246L292.098 274.239L291.122 273.1ZM278.122 283.9L277.163 282.746L277.11 282.79L277.061 282.839L278.122 283.9ZM276.822 284.6L276.348 283.177L276.321 283.186L276.295 283.196L276.822 284.6ZM290.622 272.2L289.561 271.139L289.561 271.139L290.622 272.2ZM290.622 254.8L289.501 255.797L289.559 255.862L289.625 255.921L290.622 254.8ZM278.222 253.9H276.722V255.4H278.222V253.9ZM278.222 220.3V218.8H276.722V220.3H278.222ZM290.622 219.5L289.561 218.439L289.561 218.439L290.622 219.5ZM290.622 201.9L289.501 202.897L289.559 202.962L289.625 203.021L290.622 201.9ZM242.522 201.9L241.461 200.839L241.461 200.839L242.522 201.9ZM242.522 219.5L241.401 220.497L241.459 220.562L241.525 220.621L242.522 219.5ZM255.222 220.3H256.722V218.8H255.222V220.3ZM255.222 253.9V255.4H256.722V253.9H255.222ZM242.522 254.8L243.583 255.861L243.583 255.861L242.522 254.8ZM242.522 272.2L241.401 273.197L241.459 273.262L241.525 273.321L242.522 272.2ZM282.522 264V265.5H284.022V264H282.522ZM250.722 264H249.222V265.5H250.722V264ZM250.722 263V261.5H249.222V263H250.722ZM266.222 263V264.5H267.722V263H266.222ZM266.222 211H267.722V209.5H266.222V211ZM250.722 211H249.222V212.5H250.722V211ZM250.722 210V208.5H249.222V210H250.722ZM282.522 210H284.022V208.5H282.522V210ZM282.522 211V212.5H284.022V211H282.522ZM267.222 211V209.5H265.722V211H267.222ZM267.222 263H265.722V264.5H267.222V263ZM282.522 263H284.022V261.5H282.522V263ZM275.022 283.4H232.422V286.4H275.022V283.4ZM232.422 283.4C231.009 283.4 230.314 283.071 229.983 282.739L227.861 284.861C228.996 285.996 230.635 286.4 232.422 286.4V283.4ZM229.983 282.739C229.651 282.408 229.322 281.713 229.322 280.3H226.322C226.322 282.087 226.726 283.726 227.861 284.861L229.983 282.739ZM229.322 280.3V268.4H226.322V280.3H229.322ZM229.322 268.4C229.322 267.639 229.411 267.076 229.545 266.674L226.699 265.726C226.433 266.524 226.322 267.427 226.322 268.4H229.322ZM229.493 266.809C229.675 266.399 229.912 266.084 230.198 265.839L228.246 263.561C227.598 264.116 227.102 264.801 226.751 265.591L229.493 266.809ZM230.189 265.847L242.289 255.647L240.355 253.353L228.255 263.553L230.189 265.847ZM242.822 254.5V232.2H239.822V254.5H242.822ZM241.322 230.7H232.422V233.7H241.322V230.7ZM232.422 230.7C231.009 230.7 230.314 230.371 229.983 230.039L227.861 232.161C228.996 233.296 230.635 233.7 232.422 233.7V230.7ZM229.983 230.039C229.651 229.708 229.322 229.013 229.322 227.6H226.322C226.322 229.387 226.726 231.026 227.861 232.161L229.983 230.039ZM229.322 227.6V215.5H226.322V227.6H229.322ZM229.322 215.5C229.322 214.739 229.411 214.176 229.545 213.774L226.699 212.826C226.433 213.624 226.322 214.527 226.322 215.5H229.322ZM229.493 213.909C229.675 213.499 229.912 213.184 230.198 212.939L228.246 210.661C227.598 211.216 227.102 211.901 226.751 212.691L229.493 213.909ZM230.19 212.946L243.09 202.046L241.154 199.754L228.254 210.654L230.19 212.946ZM243.059 202.071C243.183 201.972 243.404 201.851 243.786 201.755L243.058 198.845C242.373 199.016 241.728 199.294 241.185 199.729L243.059 202.071ZM243.896 201.723C244.335 201.577 244.808 201.5 245.322 201.5V198.5C244.503 198.5 243.709 198.623 242.948 198.877L243.896 201.723ZM245.322 201.5H287.922V198.5H245.322V201.5ZM287.922 201.5C289.335 201.5 290.03 201.829 290.361 202.161L292.483 200.039C291.347 198.904 289.709 198.5 287.922 198.5V201.5ZM290.361 202.161C290.693 202.492 291.022 203.187 291.022 204.6H294.022C294.022 202.813 293.618 201.174 292.483 200.039L290.361 202.161ZM291.022 204.6V216.7H294.022V204.6H291.022ZM291.022 216.7C291.022 217.421 290.91 217.933 290.751 218.291L293.493 219.509C293.867 218.667 294.022 217.713 294.022 216.7H291.022ZM290.699 218.426C290.582 218.776 290.4 219.043 290.146 219.261L292.098 221.539C292.777 220.957 293.262 220.224 293.545 219.374L290.699 218.426ZM290.157 219.252L278.257 229.252L280.187 231.548L292.087 221.548L290.157 219.252ZM277.722 230.4V252.9H280.722V230.4H277.722ZM279.222 254.4H287.922V251.4H279.222V254.4ZM287.922 254.4C289.335 254.4 290.03 254.729 290.361 255.061L292.483 252.939C291.347 251.804 289.709 251.4 287.922 251.4V254.4ZM290.361 255.061C290.693 255.392 291.022 256.087 291.022 257.5H294.022C294.022 255.713 293.618 254.074 292.483 252.939L290.361 255.061ZM291.022 257.5V269.4H294.022V257.5H291.022ZM291.022 269.4C291.022 270.121 290.91 270.633 290.751 270.991L293.493 272.209C293.867 271.367 294.022 270.413 294.022 269.4H291.022ZM290.699 271.126C290.582 271.476 290.4 271.743 290.146 271.961L292.098 274.239C292.777 273.657 293.262 272.924 293.545 272.074L290.699 271.126ZM290.163 271.946L277.163 282.746L279.08 285.054L292.08 274.254L290.163 271.946ZM277.061 282.839C277.035 282.866 276.857 283.007 276.348 283.177L277.296 286.023C277.986 285.793 278.676 285.468 279.183 284.961L277.061 282.839ZM276.295 283.196C275.956 283.323 275.539 283.4 275.022 283.4V286.4C275.838 286.4 276.621 286.277 277.349 286.004L276.295 283.196ZM245.322 274.5H287.922V271.5H245.322V274.5ZM287.922 274.5C289.332 274.5 290.728 274.215 291.683 273.261L289.561 271.139C289.449 271.252 289.045 271.5 287.922 271.5V274.5ZM291.683 273.261C292.676 272.267 293.022 270.87 293.022 269.4H290.022C290.022 270.463 289.767 270.933 289.561 271.139L291.683 273.261ZM293.022 269.4V257.5H290.022V269.4H293.022ZM293.022 257.5C293.022 256.049 292.684 254.626 291.618 253.679L289.625 255.921C289.759 256.04 290.022 256.418 290.022 257.5H293.022ZM291.743 253.803C290.795 252.737 289.373 252.4 287.922 252.4V255.4C289.004 255.4 289.382 255.663 289.501 255.797L291.743 253.803ZM287.922 252.4H278.222V255.4H287.922V252.4ZM279.722 253.9V220.3H276.722V253.9H279.722ZM278.222 221.8H287.922V218.8H278.222V221.8ZM287.922 221.8C289.332 221.8 290.728 221.515 291.683 220.561L289.561 218.439C289.449 218.552 289.045 218.8 287.922 218.8V221.8ZM291.683 220.561C292.676 219.567 293.022 218.17 293.022 216.7H290.022C290.022 217.763 289.767 218.233 289.561 218.439L291.683 220.561ZM293.022 216.7V204.6H290.022V216.7H293.022ZM293.022 204.6C293.022 203.149 292.684 201.726 291.618 200.779L289.625 203.021C289.759 203.14 290.022 203.518 290.022 204.6H293.022ZM291.743 200.903C290.795 199.837 289.373 199.5 287.922 199.5V202.5C289.004 202.5 289.382 202.763 289.501 202.897L291.743 200.903ZM287.922 199.5H245.322V202.5H287.922V199.5ZM245.322 199.5C243.851 199.5 242.455 199.845 241.461 200.839L243.583 202.961C243.789 202.755 244.259 202.5 245.322 202.5V199.5ZM241.461 200.839C240.507 201.794 240.222 203.19 240.222 204.6H243.222C243.222 203.476 243.47 203.073 243.583 202.961L241.461 200.839ZM240.222 204.6V216.7H243.222V204.6H240.222ZM240.222 216.7C240.222 218.132 240.516 219.501 241.401 220.497L243.643 218.503C243.461 218.299 243.222 217.801 243.222 216.7H240.222ZM241.525 220.621C242.521 221.506 243.89 221.8 245.322 221.8V218.8C244.221 218.8 243.723 218.561 243.518 218.379L241.525 220.621ZM245.322 221.8H255.222V218.8H245.322V221.8ZM253.722 220.3V253.9H256.722V220.3H253.722ZM255.222 252.4H245.322V255.4H255.222V252.4ZM245.322 252.4C243.851 252.4 242.455 252.745 241.461 253.739L243.583 255.861C243.789 255.655 244.259 255.4 245.322 255.4V252.4ZM241.461 253.739C240.507 254.694 240.222 256.09 240.222 257.5H243.222C243.222 256.376 243.47 255.973 243.583 255.861L241.461 253.739ZM240.222 257.5V269.4H243.222V257.5H240.222ZM240.222 269.4C240.222 270.832 240.516 272.201 241.401 273.197L243.643 271.203C243.461 270.999 243.222 270.501 243.222 269.4H240.222ZM241.525 273.321C242.521 274.206 243.89 274.5 245.322 274.5V271.5C244.221 271.5 243.723 271.261 243.518 271.079L241.525 273.321ZM282.522 262.5H250.722V265.5H282.522V262.5ZM252.222 264V263H249.222V264H252.222ZM250.722 264.5H266.222V261.5H250.722V264.5ZM267.722 263V211H264.722V263H267.722ZM266.222 209.5H250.722V212.5H266.222V209.5ZM252.222 211V210H249.222V211H252.222ZM250.722 211.5H282.522V208.5H250.722V211.5ZM281.022 210V211H284.022V210H281.022ZM282.522 209.5H267.222V212.5H282.522V209.5ZM265.722 211V263H268.722V211H265.722ZM267.222 264.5H282.522V261.5H267.222V264.5ZM281.022 263V264H284.022V263H281.022ZM327.03 210.8L328.151 209.803L328.122 209.771L328.09 209.739L327.03 210.8ZM363.83 252.2L362.709 253.197L365.33 256.145V252.2H363.83ZM363.83 210V208.5H362.33V210H363.83ZM364.83 210H366.33V208.5H364.83V210ZM364.83 264V265.5H366.33V264H364.83ZM363.83 264H362.33V265.5H363.83V264ZM363.83 253.7H365.33V253.128L364.949 252.702L363.83 253.7ZM326.03 211.3L327.149 210.302L327.121 210.27L327.09 210.239L326.03 211.3ZM325.73 211.1L324.669 212.161L324.841 212.333L325.059 212.442L325.73 211.1ZM325.33 211.1L324.269 210.039L323.83 210.479V211.1H325.33ZM325.33 264V265.5H326.83V264H325.33ZM324.33 264H322.83V265.5H324.33V264ZM326.23 210.1L325.398 211.348L325.398 211.348L326.23 210.1ZM335.13 272.2L334.069 271.139L334.069 271.139L335.13 272.2ZM336.03 236.4L337.186 235.445L334.53 232.229V236.4H336.03ZM353.13 257.1H354.63V256.561L354.286 256.145L353.13 257.1ZM353.93 272.2L352.809 273.197L352.867 273.262L352.933 273.321L353.93 272.2ZM374.43 272.2L373.369 271.139L373.369 271.139L374.43 272.2ZM374.43 201.9L373.309 202.897L373.367 202.962L373.433 203.021L374.43 201.9ZM353.93 201.9L354.99 202.961L353.93 201.9ZM353.13 225.9L352 226.887L354.63 229.896V225.9H353.13ZM333.73 203.7L332.596 204.682L332.6 204.687L333.73 203.7ZM331.03 201.6L330.401 202.962L330.42 202.971L330.439 202.979L331.03 201.6ZM314.63 201.9L313.569 200.839L313.569 200.839L314.63 201.9ZM314.63 272.2L313.509 273.197L313.567 273.262L313.633 273.321L314.63 272.2ZM335.63 273.1L336.588 274.254L336.597 274.246L336.606 274.239L335.63 273.1ZM322.63 283.9L321.671 282.746L321.618 282.79L321.569 282.839L322.63 283.9ZM321.33 284.6L320.855 283.177L320.829 283.186L320.803 283.196L321.33 284.6ZM301.03 283.8L299.969 284.861L301.03 283.8ZM300.23 213.3L298.859 212.691L298.83 212.757L298.807 212.826L300.23 213.3ZM301.33 211.8L300.362 210.654L300.353 210.661L301.33 211.8ZM314.23 200.9L313.293 199.729L313.277 199.741L313.262 199.754L314.23 200.9ZM315.53 200.3L315.893 201.755L315.949 201.741L316.004 201.723L315.53 200.3ZM331.53 200.7L332.164 199.341L332.164 199.341L331.53 200.7ZM334.53 203L335.666 202.02L335.645 201.997L335.624 201.974L334.53 203ZM341.43 211L340.294 211.98L341.258 213.097L342.391 212.152L341.43 211ZM353.53 200.9L352.593 199.729L352.58 199.738L352.568 199.748L353.53 200.9ZM354.83 200.3L355.194 201.755L355.249 201.741L355.304 201.723L354.83 200.3ZM375.23 201.1L376.29 200.039L376.29 200.039L375.23 201.1ZM375.93 271.6L374.559 270.991L374.53 271.057L374.507 271.126L375.93 271.6ZM374.93 273.1L375.888 274.254L375.897 274.246L375.906 274.239L374.93 273.1ZM361.93 283.9L360.971 282.746L360.918 282.79L360.869 282.839L361.93 283.9ZM360.63 284.6L360.155 283.177L360.129 283.186L360.103 283.196L360.63 284.6ZM340.33 283.8L341.39 282.739L341.39 282.739L340.33 283.8ZM339.23 268.4H340.73V267.866L340.393 267.452L339.23 268.4ZM337.03 265.7L338.193 264.752L335.53 261.484V265.7H337.03ZM336.63 271.6L335.259 270.991L335.23 271.057L335.207 271.126L336.63 271.6ZM325.909 211.797L362.709 253.197L364.951 251.203L328.151 209.803L325.909 211.797ZM365.33 252.2V210H362.33V252.2H365.33ZM363.83 211.5H364.83V208.5H363.83V211.5ZM363.33 210V264H366.33V210H363.33ZM364.83 262.5H363.83V265.5H364.83V262.5ZM365.33 264V253.7H362.33V264H365.33ZM364.949 252.702L327.149 210.302L324.91 212.298L362.71 254.698L364.949 252.702ZM327.09 210.239C326.863 210.012 326.604 209.86 326.401 209.758L325.059 212.442C325.083 212.453 325.085 212.456 325.073 212.448C325.062 212.441 325.022 212.413 324.969 212.361L327.09 210.239ZM326.79 210.039C326.56 209.809 326.134 209.5 325.53 209.5V212.5C325.058 212.5 324.766 212.257 324.669 212.161L326.79 210.039ZM325.53 209.5C324.925 209.5 324.499 209.809 324.269 210.039L326.39 212.161C326.294 212.257 326.001 212.5 325.53 212.5V209.5ZM323.83 211.1C323.83 211.1 323.83 211.1 323.83 211.1C323.83 211.101 323.83 211.101 323.83 211.101C323.83 211.101 323.83 211.101 323.83 211.101C323.83 211.101 323.83 211.101 323.83 211.102C323.83 211.102 323.83 211.102 323.83 211.102C323.83 211.102 323.83 211.102 323.83 211.102C323.83 211.102 323.83 211.103 323.83 211.103C323.83 211.103 323.83 211.103 323.83 211.103C323.83 211.103 323.83 211.103 323.83 211.104C323.83 211.104 323.83 211.104 323.83 211.104C323.83 211.104 323.83 211.104 323.83 211.104C323.83 211.104 323.83 211.105 323.83 211.105C323.83 211.105 323.83 211.105 323.83 211.105C323.83 211.105 323.83 211.105 323.83 211.105C323.83 211.106 323.83 211.106 323.83 211.106C323.83 211.106 323.83 211.106 323.83 211.106C323.83 211.106 323.83 211.107 323.83 211.107C323.83 211.107 323.83 211.107 323.83 211.107C323.83 211.107 323.83 211.107 323.83 211.107C323.83 211.108 323.83 211.108 323.83 211.108C323.83 211.108 323.83 211.108 323.83 211.108C323.83 211.108 323.83 211.108 323.83 211.109C323.83 211.109 323.83 211.109 323.83 211.109C323.83 211.109 323.83 211.109 323.83 211.109C323.83 211.11 323.83 211.11 323.83 211.11C323.83 211.11 323.83 211.11 323.83 211.11C323.83 211.11 323.83 211.11 323.83 211.111C323.83 211.111 323.83 211.111 323.83 211.111C323.83 211.111 323.83 211.111 323.83 211.111C323.83 211.111 323.83 211.112 323.83 211.112C323.83 211.112 323.83 211.112 323.83 211.112C323.83 211.112 323.83 211.112 323.83 211.112C323.83 211.113 323.83 211.113 323.83 211.113C323.83 211.113 323.83 211.113 323.83 211.113C323.83 211.113 323.83 211.114 323.83 211.114C323.83 211.114 323.83 211.114 323.83 211.114C323.83 211.114 323.83 211.114 323.83 211.114C323.83 211.115 323.83 211.115 323.83 211.115C323.83 211.115 323.83 211.115 323.83 211.115C323.83 211.115 323.83 211.115 323.83 211.116C323.83 211.116 323.83 211.116 323.83 211.116C323.83 211.116 323.83 211.116 323.83 211.116C323.83 211.117 323.83 211.117 323.83 211.117C323.83 211.117 323.83 211.117 323.83 211.117C323.83 211.117 323.83 211.117 323.83 211.118C323.83 211.118 323.83 211.118 323.83 211.118C323.83 211.118 323.83 211.118 323.83 211.118C323.83 211.118 323.83 211.119 323.83 211.119C323.83 211.119 323.83 211.119 323.83 211.119C323.83 211.119 323.83 211.119 323.83 211.12C323.83 211.12 323.83 211.12 323.83 211.12C323.83 211.12 323.83 211.12 323.83 211.12C323.83 211.12 323.83 211.121 323.83 211.121C323.83 211.121 323.83 211.121 323.83 211.121C323.83 211.121 323.83 211.121 323.83 211.121C323.83 211.122 323.83 211.122 323.83 211.122C323.83 211.122 323.83 211.122 323.83 211.122C323.83 211.122 323.83 211.123 323.83 211.123C323.83 211.123 323.83 211.123 323.83 211.123C323.83 211.123 323.83 211.123 323.83 211.123C323.83 211.124 323.83 211.124 323.83 211.124C323.83 211.124 323.83 211.124 323.83 211.124C323.83 211.124 323.83 211.124 323.83 211.125C323.83 211.125 323.83 211.125 323.83 211.125C323.83 211.125 323.83 211.125 323.83 211.125C323.83 211.126 323.83 211.126 323.83 211.126C323.83 211.126 323.83 211.126 323.83 211.126C323.83 211.126 323.83 211.126 323.83 211.127C323.83 211.127 323.83 211.127 323.83 211.127C323.83 211.127 323.83 211.127 323.83 211.127C323.83 211.127 323.83 211.128 323.83 211.128C323.83 211.128 323.83 211.128 323.83 211.128C323.83 211.128 323.83 211.128 323.83 211.129C323.83 211.129 323.83 211.129 323.83 211.129C323.83 211.129 323.83 211.129 323.83 211.129C323.83 211.129 323.83 211.13 323.83 211.13C323.83 211.13 323.83 211.13 323.83 211.13C323.83 211.13 323.83 211.13 323.83 211.13C323.83 211.131 323.83 211.131 323.83 211.131C323.83 211.131 323.83 211.131 323.83 211.131C323.83 211.131 323.83 211.132 323.83 211.132C323.83 211.132 323.83 211.132 323.83 211.132C323.83 211.132 323.83 211.132 323.83 211.132C323.83 211.133 323.83 211.133 323.83 211.133C323.83 211.133 323.83 211.133 323.83 211.133C323.83 211.133 323.83 211.133 323.83 211.134C323.83 211.134 323.83 211.134 323.83 211.134C323.83 211.134 323.83 211.134 323.83 211.134C323.83 211.135 323.83 211.135 323.83 211.135C323.83 211.135 323.83 211.135 323.83 211.135C323.83 211.135 323.83 211.135 323.83 211.136C323.83 211.136 323.83 211.136 323.83 211.136C323.83 211.136 323.83 211.136 323.83 211.136C323.83 211.136 323.83 211.137 323.83 211.137C323.83 211.137 323.83 211.137 323.83 211.137C323.83 211.137 323.83 211.137 323.83 211.137C323.83 211.138 323.83 211.138 323.83 211.138C323.83 211.138 323.83 211.138 323.83 211.138C323.83 211.138 323.83 211.139 323.83 211.139C323.83 211.139 323.83 211.139 323.83 211.139C323.83 211.139 323.83 211.139 323.83 211.139C323.83 211.14 323.83 211.14 323.83 211.14C323.83 211.14 323.83 211.14 323.83 211.14C323.83 211.14 323.83 211.14 323.83 211.141C323.83 211.141 323.83 211.141 323.83 211.141C323.83 211.141 323.83 211.141 323.83 211.141C323.83 211.142 323.83 211.142 323.83 211.142C323.83 211.142 323.83 211.142 323.83 211.142C323.83 211.142 323.83 211.142 323.83 211.143C323.83 211.143 323.83 211.143 323.83 211.143C323.83 211.143 323.83 211.143 323.83 211.143C323.83 211.143 323.83 211.144 323.83 211.144C323.83 211.144 323.83 211.144 323.83 211.144C323.83 211.144 323.83 211.144 323.83 211.145C323.83 211.145 323.83 211.145 323.83 211.145C323.83 211.145 323.83 211.145 323.83 211.145C323.83 211.145 323.83 211.146 323.83 211.146C323.83 211.146 323.83 211.146 323.83 211.146C323.83 211.146 323.83 211.146 323.83 211.146C323.83 211.147 323.83 211.147 323.83 211.147C323.83 211.147 323.83 211.147 323.83 211.147C323.83 211.147 323.83 211.148 323.83 211.148C323.83 211.148 323.83 211.148 323.83 211.148C323.83 211.148 323.83 211.148 323.83 211.148C323.83 211.149 323.83 211.149 323.83 211.149C323.83 211.149 323.83 211.149 323.83 211.149C323.83 211.149 323.83 211.149 323.83 211.15C323.83 211.15 323.83 211.15 323.83 211.15C323.83 211.15 323.83 211.15 323.83 211.15C323.83 211.151 323.83 211.151 323.83 211.151C323.83 211.151 323.83 211.151 323.83 211.151C323.83 211.151 323.83 211.151 323.83 211.152C323.83 211.152 323.83 211.152 323.83 211.152C323.83 211.152 323.83 211.152 323.83 211.152C323.83 211.152 323.83 211.153 323.83 211.153C323.83 211.153 323.83 211.153 323.83 211.153C323.83 211.153 323.83 211.153 323.83 211.154C323.83 211.154 323.83 211.154 323.83 211.154C323.83 211.154 323.83 211.154 323.83 211.154C323.83 211.154 323.83 211.155 323.83 211.155C323.83 211.155 323.83 211.155 323.83 211.155C323.83 211.155 323.83 211.155 323.83 211.155C323.83 211.156 323.83 211.156 323.83 211.156C323.83 211.156 323.83 211.156 323.83 211.156C323.83 211.156 323.83 211.157 323.83 211.157C323.83 211.157 323.83 211.157 323.83 211.157C323.83 211.157 323.83 211.157 323.83 211.157C323.83 211.158 323.83 211.158 323.83 211.158C323.83 211.158 323.83 211.158 323.83 211.158C323.83 211.158 323.83 211.158 323.83 211.159C323.83 211.159 323.83 211.159 323.83 211.159C323.83 211.159 323.83 211.159 323.83 211.159C323.83 211.16 323.83 211.16 323.83 211.16C323.83 211.16 323.83 211.16 323.83 211.16C323.83 211.16 323.83 211.16 323.83 211.161C323.83 211.161 323.83 211.161 323.83 211.161C323.83 211.161 323.83 211.161 323.83 211.161C323.83 211.161 323.83 211.162 323.83 211.162C323.83 211.162 323.83 211.162 323.83 211.162C323.83 211.162 323.83 211.162 323.83 211.162C323.83 211.163 323.83 211.163 323.83 211.163C323.83 211.163 323.83 211.163 323.83 211.163C323.83 211.163 323.83 211.164 323.83 211.164C323.83 211.164 323.83 211.164 323.83 211.164C323.83 211.164 323.83 211.164 323.83 211.164C323.83 211.165 323.83 211.165 323.83 211.165C323.83 211.165 323.83 211.165 323.83 211.165C323.83 211.165 323.83 211.165 323.83 211.166C323.83 211.166 323.83 211.166 323.83 211.166C323.83 211.166 323.83 211.166 323.83 211.166C323.83 211.167 323.83 211.167 323.83 211.167C323.83 211.167 323.83 211.167 323.83 211.167C323.83 211.167 323.83 211.167 323.83 211.168C323.83 211.168 323.83 211.168 323.83 211.168C323.83 211.168 323.83 211.168 323.83 211.168C323.83 211.168 323.83 211.169 323.83 211.169C323.83 211.169 323.83 211.169 323.83 211.169C323.83 211.169 323.83 211.169 323.83 211.17C323.83 211.17 323.83 211.17 323.83 211.17C323.83 211.17 323.83 211.17 323.83 211.17C323.83 211.17 323.83 211.171 323.83 211.171C323.83 211.171 323.83 211.171 323.83 211.171C323.83 211.171 323.83 211.171 323.83 211.171C323.83 211.172 323.83 211.172 323.83 211.172C323.83 211.172 323.83 211.172 323.83 211.172C323.83 211.172 323.83 211.173 323.83 211.173C323.83 211.173 323.83 211.173 323.83 211.173C323.83 211.173 323.83 211.173 323.83 211.173C323.83 211.174 323.83 211.174 323.83 211.174C323.83 211.174 323.83 211.174 323.83 211.174C323.83 211.174 323.83 211.174 323.83 211.175C323.83 211.175 323.83 211.175 323.83 211.175C323.83 211.175 323.83 211.175 323.83 211.175C323.83 211.176 323.83 211.176 323.83 211.176C323.83 211.176 323.83 211.176 323.83 211.176C323.83 211.176 323.83 211.176 323.83 211.177C323.83 211.177 323.83 211.177 323.83 211.177C323.83 211.177 323.83 211.177 323.83 211.177C323.83 211.177 323.83 211.178 323.83 211.178C323.83 211.178 323.83 211.178 323.83 211.178C323.83 211.178 323.83 211.178 323.83 211.179C323.83 211.179 323.83 211.179 323.83 211.179C323.83 211.179 323.83 211.179 323.83 211.179C323.83 211.179 323.83 211.18 323.83 211.18C323.83 211.18 323.83 211.18 323.83 211.18C323.83 211.18 323.83 211.18 323.83 211.18C323.83 211.181 323.83 211.181 323.83 211.181C323.83 211.181 323.83 211.181 323.83 211.181C323.83 211.181 323.83 211.182 323.83 211.182C323.83 211.182 323.83 211.182 323.83 211.182C323.83 211.182 323.83 211.182 323.83 211.182C323.83 211.183 323.83 211.183 323.83 211.183C323.83 211.183 323.83 211.183 323.83 211.183C323.83 211.183 323.83 211.183 323.83 211.184C323.83 211.184 323.83 211.184 323.83 211.184C323.83 211.184 323.83 211.184 323.83 211.184C323.83 211.185 323.83 211.185 323.83 211.185C323.83 211.185 323.83 211.185 323.83 211.185C323.83 211.185 323.83 211.185 323.83 211.186C323.83 211.186 323.83 211.186 323.83 211.186C323.83 211.186 323.83 211.186 323.83 211.186C323.83 211.186 323.83 211.187 323.83 211.187C323.83 211.187 323.83 211.187 323.83 211.187C323.83 211.187 323.83 211.187 323.83 211.187C323.83 211.188 323.83 211.188 323.83 211.188C323.83 211.188 323.83 211.188 323.83 211.188C323.83 211.188 323.83 211.189 323.83 211.189C323.83 211.189 323.83 211.189 323.83 211.189C323.83 211.189 323.83 211.189 323.83 211.189C323.83 211.19 323.83 211.19 323.83 211.19C323.83 211.19 323.83 211.19 323.83 211.19C323.83 211.19 323.83 211.19 323.83 211.191C323.83 211.191 323.83 211.191 323.83 211.191C323.83 211.191 323.83 211.191 323.83 211.191C323.83 211.192 323.83 211.192 323.83 211.192C323.83 211.192 323.83 211.192 323.83 211.192C323.83 211.192 323.83 211.192 323.83 211.193C323.83 211.193 323.83 211.193 323.83 211.193C323.83 211.193 323.83 211.193 323.83 211.193C323.83 211.193 323.83 211.194 323.83 211.194C323.83 211.194 323.83 211.194 323.83 211.194C323.83 211.194 323.83 211.194 323.83 211.195C323.83 211.195 323.83 211.195 323.83 211.195C323.83 211.195 323.83 211.195 323.83 211.195C323.83 211.195 323.83 211.196 323.83 211.196C323.83 211.196 323.83 211.196 323.83 211.196C323.83 211.196 323.83 211.196 323.83 211.196C323.83 211.197 323.83 211.197 323.83 211.197C323.83 211.197 323.83 211.197 323.83 211.197C323.83 211.197 323.83 211.198 323.83 211.198C323.83 211.198 323.83 211.198 323.83 211.198C323.83 211.198 323.83 211.198 323.83 211.198C323.83 211.199 323.83 211.199 323.83 211.199C323.83 211.199 323.83 211.199 323.83 211.199C323.83 211.199 323.83 211.199 323.83 211.2C323.83 211.2 323.83 211.2 323.83 211.2C323.83 211.2 323.83 211.2 323.83 211.2C323.83 211.201 323.83 211.201 323.83 211.201C323.83 211.201 323.83 211.201 323.83 211.201C323.83 211.201 323.83 211.201 323.83 211.202C323.83 211.202 323.83 211.202 323.83 211.202C323.83 211.202 323.83 211.202 323.83 211.202C323.83 211.202 323.83 211.203 323.83 211.203C323.83 211.203 323.83 211.203 323.83 211.203C323.83 211.203 323.83 211.203 323.83 211.204C323.83 211.204 323.83 211.204 323.83 211.204C323.83 211.204 323.83 211.204 323.83 211.204C323.83 211.204 323.83 211.205 323.83 211.205C323.83 211.205 323.83 211.205 323.83 211.205C323.83 211.205 323.83 211.205 323.83 211.205C323.83 211.206 323.83 211.206 323.83 211.206C323.83 211.206 323.83 211.206 323.83 211.206C323.83 211.206 323.83 211.207 323.83 211.207C323.83 211.207 323.83 211.207 323.83 211.207C323.83 211.207 323.83 211.207 323.83 211.207C323.83 211.208 323.83 211.208 323.83 211.208C323.83 211.208 323.83 211.208 323.83 211.208C323.83 211.208 323.83 211.208 323.83 211.209C323.83 211.209 323.83 211.209 323.83 211.209C323.83 211.209 323.83 211.209 323.83 211.209C323.83 211.21 323.83 211.21 323.83 211.21C323.83 211.21 323.83 211.21 323.83 211.21C323.83 211.21 323.83 211.21 323.83 211.211C323.83 211.211 323.83 211.211 323.83 211.211C323.83 211.211 323.83 211.211 323.83 211.211C323.83 211.211 323.83 211.212 323.83 211.212C323.83 211.212 323.83 211.212 323.83 211.212C323.83 211.212 323.83 211.212 323.83 211.212C323.83 211.213 323.83 211.213 323.83 211.213C323.83 211.213 323.83 211.213 323.83 211.213C323.83 211.213 323.83 211.214 323.83 211.214C323.83 211.214 323.83 211.214 323.83 211.214C323.83 211.214 323.83 211.214 323.83 211.214C323.83 211.215 323.83 211.215 323.83 211.215C323.83 211.215 323.83 211.215 323.83 211.215C323.83 211.215 323.83 211.215 323.83 211.216C323.83 211.216 323.83 211.216 323.83 211.216C323.83 211.216 323.83 211.216 323.83 211.216C323.83 211.217 323.83 211.217 323.83 211.217C323.83 211.217 323.83 211.217 323.83 211.217C323.83 211.217 323.83 211.217 323.83 211.218C323.83 211.218 323.83 211.218 323.83 211.218C323.83 211.218 323.83 211.218 323.83 211.218C323.83 211.218 323.83 211.219 323.83 211.219C323.83 211.219 323.83 211.219 323.83 211.219C323.83 211.219 323.83 211.219 323.83 211.22C323.83 211.22 323.83 211.22 323.83 211.22C323.83 211.22 323.83 211.22 323.83 211.22C323.83 211.22 323.83 211.221 323.83 211.221C323.83 211.221 323.83 211.221 323.83 211.221C323.83 211.221 323.83 211.221 323.83 211.221C323.83 211.222 323.83 211.222 323.83 211.222C323.83 211.222 323.83 211.222 323.83 211.222C323.83 211.222 323.83 211.223 323.83 211.223C323.83 211.223 323.83 211.223 323.83 211.223C323.83 211.223 323.83 211.223 323.83 211.223C323.83 211.224 323.83 211.224 323.83 211.224C323.83 211.224 323.83 211.224 323.83 211.224C323.83 211.224 323.83 211.224 323.83 211.225C323.83 211.225 323.83 211.225 323.83 211.225C323.83 211.225 323.83 211.225 323.83 211.225C323.83 211.226 323.83 211.226 323.83 211.226C323.83 211.226 323.83 211.226 323.83 211.226C323.83 211.226 323.83 211.226 323.83 211.227C323.83 211.227 323.83 211.227 323.83 211.227C323.83 211.227 323.83 211.227 323.83 211.227C323.83 211.227 323.83 211.228 323.83 211.228C323.83 211.228 323.83 211.228 323.83 211.228C323.83 211.228 323.83 211.228 323.83 211.229C323.83 211.229 323.83 211.229 323.83 211.229C323.83 211.229 323.83 211.229 323.83 211.229C323.83 211.229 323.83 211.23 323.83 211.23C323.83 211.23 323.83 211.23 323.83 211.23C323.83 211.23 323.83 211.23 323.83 211.23C323.83 211.231 323.83 211.231 323.83 211.231C323.83 211.231 323.83 211.231 323.83 211.231C323.83 211.231 323.83 211.232 323.83 211.232C323.83 211.232 323.83 211.232 323.83 211.232C323.83 211.232 323.83 211.232 323.83 211.232C323.83 211.233 323.83 211.233 323.83 211.233C323.83 211.233 323.83 211.233 323.83 211.233C323.83 211.233 323.83 211.233 323.83 211.234C323.83 211.234 323.83 211.234 323.83 211.234C323.83 211.234 323.83 211.234 323.83 211.234C323.83 211.235 323.83 211.235 323.83 211.235C323.83 211.235 323.83 211.235 323.83 211.235C323.83 211.235 323.83 211.235 323.83 211.236C323.83 211.236 323.83 211.236 323.83 211.236C323.83 211.236 323.83 211.236 323.83 211.236C323.83 211.236 323.83 211.237 323.83 211.237C323.83 211.237 323.83 211.237 323.83 211.237C323.83 211.237 323.83 211.237 323.83 211.237C323.83 211.238 323.83 211.238 323.83 211.238C323.83 211.238 323.83 211.238 323.83 211.238C323.83 211.238 323.83 211.239 323.83 211.239C323.83 211.239 323.83 211.239 323.83 211.239C323.83 211.239 323.83 211.239 323.83 211.239C323.83 211.24 323.83 211.24 323.83 211.24C323.83 211.24 323.83 211.24 323.83 211.24C323.83 211.24 323.83 211.24 323.83 211.241C323.83 211.241 323.83 211.241 323.83 211.241C323.83 211.241 323.83 211.241 323.83 211.241C323.83 211.242 323.83 211.242 323.83 211.242C323.83 211.242 323.83 211.242 323.83 211.242C323.83 211.242 323.83 211.242 323.83 211.243C323.83 211.243 323.83 211.243 323.83 211.243C323.83 211.243 323.83 211.243 323.83 211.243C323.83 211.243 323.83 211.244 323.83 211.244C323.83 211.244 323.83 211.244 323.83 211.244C323.83 211.244 323.83 211.244 323.83 211.245C323.83 211.245 323.83 211.245 323.83 211.245C323.83 211.245 323.83 211.245 323.83 211.245C323.83 211.245 323.83 211.246 323.83 211.246C323.83 211.246 323.83 211.246 323.83 211.246C323.83 211.246 323.83 211.246 323.83 211.246C323.83 211.247 323.83 211.247 323.83 211.247C323.83 211.247 323.83 211.247 323.83 211.247C323.83 211.247 323.83 211.248 323.83 211.248C323.83 211.248 323.83 211.248 323.83 211.248C323.83 211.248 323.83 211.248 323.83 211.248C323.83 211.249 323.83 211.249 323.83 211.249C323.83 211.249 323.83 211.249 323.83 211.249C323.83 211.249 323.83 211.249 323.83 211.25C323.83 211.25 323.83 211.25 323.83 211.25C323.83 211.25 323.83 211.25 323.83 211.25C323.83 211.251 323.83 211.251 323.83 211.251C323.83 211.251 323.83 211.251 323.83 211.251C323.83 211.251 323.83 211.251 323.83 211.252C323.83 211.252 323.83 211.252 323.83 211.252C323.83 211.252 323.83 211.252 323.83 211.252C323.83 211.252 323.83 211.253 323.83 211.253C323.83 211.253 323.83 211.253 323.83 211.253C323.83 211.253 323.83 211.253 323.83 211.254C323.83 211.254 323.83 211.254 323.83 211.254C323.83 211.254 323.83 211.254 323.83 211.254C323.83 211.254 323.83 211.255 323.83 211.255C323.83 211.255 323.83 211.255 323.83 211.255C323.83 211.255 323.83 211.255 323.83 211.255C323.83 211.256 323.83 211.256 323.83 211.256C323.83 211.256 323.83 211.256 323.83 211.256C323.83 211.256 323.83 211.257 323.83 211.257C323.83 211.257 323.83 211.257 323.83 211.257C323.83 211.257 323.83 211.257 323.83 211.257C323.83 211.258 323.83 211.258 323.83 211.258C323.83 211.258 323.83 211.258 323.83 211.258C323.83 211.258 323.83 211.258 323.83 211.259C323.83 211.259 323.83 211.259 323.83 211.259C323.83 211.259 323.83 211.259 323.83 211.259C323.83 211.26 323.83 211.26 323.83 211.26C323.83 211.26 323.83 211.26 323.83 211.26C323.83 211.26 323.83 211.26 323.83 211.261C323.83 211.261 323.83 211.261 323.83 211.261C323.83 211.261 323.83 211.261 323.83 211.261C323.83 211.261 323.83 211.262 323.83 211.262C323.83 211.262 323.83 211.262 323.83 211.262C323.83 211.262 323.83 211.262 323.83 211.262C323.83 211.263 323.83 211.263 323.83 211.263C323.83 211.263 323.83 211.263 323.83 211.263C323.83 211.263 323.83 211.264 323.83 211.264C323.83 211.264 323.83 211.264 323.83 211.264C323.83 211.264 323.83 211.264 323.83 211.264C323.83 211.265 323.83 211.265 323.83 211.265C323.83 211.265 323.83 211.265 323.83 211.265C323.83 211.265 323.83 211.265 323.83 211.266C323.83 211.266 323.83 211.266 323.83 211.266C323.83 211.266 323.83 211.266 323.83 211.266C323.83 211.267 323.83 211.267 323.83 211.267C323.83 211.267 323.83 211.267 323.83 211.267C323.83 211.267 323.83 211.267 323.83 211.268C323.83 211.268 323.83 211.268 323.83 211.268C323.83 211.268 323.83 211.268 323.83 211.268C323.83 211.268 323.83 211.269 323.83 211.269C323.83 211.269 323.83 211.269 323.83 211.269C323.83 211.269 323.83 211.269 323.83 211.27C323.83 211.27 323.83 211.27 323.83 211.27C323.83 211.27 323.83 211.27 323.83 211.27C323.83 211.27 323.83 211.271 323.83 211.271C323.83 211.271 323.83 211.271 323.83 211.271C323.83 211.271 323.83 211.271 323.83 211.271C323.83 211.272 323.83 211.272 323.83 211.272C323.83 211.272 323.83 211.272 323.83 211.272C323.83 211.272 323.83 211.273 323.83 211.273C323.83 211.273 323.83 211.273 323.83 211.273C323.83 211.273 323.83 211.273 323.83 211.273C323.83 211.274 323.83 211.274 323.83 211.274C323.83 211.274 323.83 211.274 323.83 211.274C323.83 211.274 323.83 211.274 323.83 211.275C323.83 211.275 323.83 211.275 323.83 211.275C323.83 211.275 323.83 211.275 323.83 211.275C323.83 211.276 323.83 211.276 323.83 211.276C323.83 211.276 323.83 211.276 323.83 211.276C323.83 211.276 323.83 211.276 323.83 211.277C323.83 211.277 323.83 211.277 323.83 211.277C323.83 211.277 323.83 211.277 323.83 211.277C323.83 211.277 323.83 211.278 323.83 211.278C323.83 211.278 323.83 211.278 323.83 211.278C323.83 211.278 323.83 211.278 323.83 211.279C323.83 211.279 323.83 211.279 323.83 211.279C323.83 211.279 323.83 211.279 323.83 211.279C323.83 211.279 323.83 211.28 323.83 211.28C323.83 211.28 323.83 211.28 323.83 211.28C323.83 211.28 323.83 211.28 323.83 211.28C323.83 211.281 323.83 211.281 323.83 211.281C323.83 211.281 323.83 211.281 323.83 211.281C323.83 211.281 323.83 211.282 323.83 211.282C323.83 211.282 323.83 211.282 323.83 211.282C323.83 211.282 323.83 211.282 323.83 211.282C323.83 211.283 323.83 211.283 323.83 211.283C323.83 211.283 323.83 211.283 323.83 211.283C323.83 211.283 323.83 211.283 323.83 211.284C323.83 211.284 323.83 211.284 323.83 211.284C323.83 211.284 323.83 211.284 323.83 211.284C323.83 211.285 323.83 211.285 323.83 211.285C323.83 211.285 323.83 211.285 323.83 211.285C323.83 211.285 323.83 211.285 323.83 211.286C323.83 211.286 323.83 211.286 323.83 211.286C323.83 211.286 323.83 211.286 323.83 211.286C323.83 211.286 323.83 211.287 323.83 211.287C323.83 211.287 323.83 211.287 323.83 211.287C323.83 211.287 323.83 211.287 323.83 211.287C323.83 211.288 323.83 211.288 323.83 211.288C323.83 211.288 323.83 211.288 323.83 211.288C323.83 211.288 323.83 211.289 323.83 211.289C323.83 211.289 323.83 211.289 323.83 211.289C323.83 211.289 323.83 211.289 323.83 211.289C323.83 211.29 323.83 211.29 323.83 211.29C323.83 211.29 323.83 211.29 323.83 211.29C323.83 211.29 323.83 211.29 323.83 211.291C323.83 211.291 323.83 211.291 323.83 211.291C323.83 211.291 323.83 211.291 323.83 211.291C323.83 211.292 323.83 211.292 323.83 211.292C323.83 211.292 323.83 211.292 323.83 211.292C323.83 211.292 323.83 211.292 323.83 211.293C323.83 211.293 323.83 211.293 323.83 211.293C323.83 211.293 323.83 211.293 323.83 211.293C323.83 211.293 323.83 211.294 323.83 211.294C323.83 211.294 323.83 211.294 323.83 211.294C323.83 211.294 323.83 211.294 323.83 211.295C323.83 211.295 323.83 211.295 323.83 211.295C323.83 211.295 323.83 211.295 323.83 211.295C323.83 211.295 323.83 211.296 323.83 211.296C323.83 211.296 323.83 211.296 323.83 211.296C323.83 211.296 323.83 211.296 323.83 211.296C323.83 211.297 323.83 211.297 323.83 211.297C323.83 211.297 323.83 211.297 323.83 211.297C323.83 211.297 323.83 211.298 323.83 211.298C323.83 211.298 323.83 211.298 323.83 211.298C323.83 211.298 323.83 211.298 323.83 211.298C323.83 211.299 323.83 211.299 323.83 211.299C323.83 211.299 323.83 211.299 323.83 211.299C323.83 211.299 323.83 211.299 323.83 211.3C323.83 211.3 323.83 211.3 323.83 211.3H326.83C326.83 211.3 326.83 211.3 326.83 211.3C326.83 211.299 326.83 211.299 326.83 211.299C326.83 211.299 326.83 211.299 326.83 211.299C326.83 211.299 326.83 211.299 326.83 211.298C326.83 211.298 326.83 211.298 326.83 211.298C326.83 211.298 326.83 211.298 326.83 211.298C326.83 211.298 326.83 211.297 326.83 211.297C326.83 211.297 326.83 211.297 326.83 211.297C326.83 211.297 326.83 211.297 326.83 211.296C326.83 211.296 326.83 211.296 326.83 211.296C326.83 211.296 326.83 211.296 326.83 211.296C326.83 211.296 326.83 211.295 326.83 211.295C326.83 211.295 326.83 211.295 326.83 211.295C326.83 211.295 326.83 211.295 326.83 211.295C326.83 211.294 326.83 211.294 326.83 211.294C326.83 211.294 326.83 211.294 326.83 211.294C326.83 211.294 326.83 211.293 326.83 211.293C326.83 211.293 326.83 211.293 326.83 211.293C326.83 211.293 326.83 211.293 326.83 211.293C326.83 211.292 326.83 211.292 326.83 211.292C326.83 211.292 326.83 211.292 326.83 211.292C326.83 211.292 326.83 211.292 326.83 211.291C326.83 211.291 326.83 211.291 326.83 211.291C326.83 211.291 326.83 211.291 326.83 211.291C326.83 211.29 326.83 211.29 326.83 211.29C326.83 211.29 326.83 211.29 326.83 211.29C326.83 211.29 326.83 211.29 326.83 211.289C326.83 211.289 326.83 211.289 326.83 211.289C326.83 211.289 326.83 211.289 326.83 211.289C326.83 211.289 326.83 211.288 326.83 211.288C326.83 211.288 326.83 211.288 326.83 211.288C326.83 211.288 326.83 211.288 326.83 211.287C326.83 211.287 326.83 211.287 326.83 211.287C326.83 211.287 326.83 211.287 326.83 211.287C326.83 211.287 326.83 211.286 326.83 211.286C326.83 211.286 326.83 211.286 326.83 211.286C326.83 211.286 326.83 211.286 326.83 211.286C326.83 211.285 326.83 211.285 326.83 211.285C326.83 211.285 326.83 211.285 326.83 211.285C326.83 211.285 326.83 211.285 326.83 211.284C326.83 211.284 326.83 211.284 326.83 211.284C326.83 211.284 326.83 211.284 326.83 211.284C326.83 211.283 326.83 211.283 326.83 211.283C326.83 211.283 326.83 211.283 326.83 211.283C326.83 211.283 326.83 211.283 326.83 211.282C326.83 211.282 326.83 211.282 326.83 211.282C326.83 211.282 326.83 211.282 326.83 211.282C326.83 211.282 326.83 211.281 326.83 211.281C326.83 211.281 326.83 211.281 326.83 211.281C326.83 211.281 326.83 211.281 326.83 211.28C326.83 211.28 326.83 211.28 326.83 211.28C326.83 211.28 326.83 211.28 326.83 211.28C326.83 211.28 326.83 211.279 326.83 211.279C326.83 211.279 326.83 211.279 326.83 211.279C326.83 211.279 326.83 211.279 326.83 211.279C326.83 211.278 326.83 211.278 326.83 211.278C326.83 211.278 326.83 211.278 326.83 211.278C326.83 211.278 326.83 211.277 326.83 211.277C326.83 211.277 326.83 211.277 326.83 211.277C326.83 211.277 326.83 211.277 326.83 211.277C326.83 211.276 326.83 211.276 326.83 211.276C326.83 211.276 326.83 211.276 326.83 211.276C326.83 211.276 326.83 211.276 326.83 211.275C326.83 211.275 326.83 211.275 326.83 211.275C326.83 211.275 326.83 211.275 326.83 211.275C326.83 211.274 326.83 211.274 326.83 211.274C326.83 211.274 326.83 211.274 326.83 211.274C326.83 211.274 326.83 211.274 326.83 211.273C326.83 211.273 326.83 211.273 326.83 211.273C326.83 211.273 326.83 211.273 326.83 211.273C326.83 211.273 326.83 211.272 326.83 211.272C326.83 211.272 326.83 211.272 326.83 211.272C326.83 211.272 326.83 211.272 326.83 211.271C326.83 211.271 326.83 211.271 326.83 211.271C326.83 211.271 326.83 211.271 326.83 211.271C326.83 211.271 326.83 211.27 326.83 211.27C326.83 211.27 326.83 211.27 326.83 211.27C326.83 211.27 326.83 211.27 326.83 211.27C326.83 211.269 326.83 211.269 326.83 211.269C326.83 211.269 326.83 211.269 326.83 211.269C326.83 211.269 326.83 211.268 326.83 211.268C326.83 211.268 326.83 211.268 326.83 211.268C326.83 211.268 326.83 211.268 326.83 211.268C326.83 211.267 326.83 211.267 326.83 211.267C326.83 211.267 326.83 211.267 326.83 211.267C326.83 211.267 326.83 211.267 326.83 211.266C326.83 211.266 326.83 211.266 326.83 211.266C326.83 211.266 326.83 211.266 326.83 211.266C326.83 211.265 326.83 211.265 326.83 211.265C326.83 211.265 326.83 211.265 326.83 211.265C326.83 211.265 326.83 211.265 326.83 211.264C326.83 211.264 326.83 211.264 326.83 211.264C326.83 211.264 326.83 211.264 326.83 211.264C326.83 211.264 326.83 211.263 326.83 211.263C326.83 211.263 326.83 211.263 326.83 211.263C326.83 211.263 326.83 211.263 326.83 211.262C326.83 211.262 326.83 211.262 326.83 211.262C326.83 211.262 326.83 211.262 326.83 211.262C326.83 211.262 326.83 211.261 326.83 211.261C326.83 211.261 326.83 211.261 326.83 211.261C326.83 211.261 326.83 211.261 326.83 211.261C326.83 211.26 326.83 211.26 326.83 211.26C326.83 211.26 326.83 211.26 326.83 211.26C326.83 211.26 326.83 211.26 326.83 211.259C326.83 211.259 326.83 211.259 326.83 211.259C326.83 211.259 326.83 211.259 326.83 211.259C326.83 211.258 326.83 211.258 326.83 211.258C326.83 211.258 326.83 211.258 326.83 211.258C326.83 211.258 326.83 211.258 326.83 211.257C326.83 211.257 326.83 211.257 326.83 211.257C326.83 211.257 326.83 211.257 326.83 211.257C326.83 211.257 326.83 211.256 326.83 211.256C326.83 211.256 326.83 211.256 326.83 211.256C326.83 211.256 326.83 211.256 326.83 211.255C326.83 211.255 326.83 211.255 326.83 211.255C326.83 211.255 326.83 211.255 326.83 211.255C326.83 211.255 326.83 211.254 326.83 211.254C326.83 211.254 326.83 211.254 326.83 211.254C326.83 211.254 326.83 211.254 326.83 211.254C326.83 211.253 326.83 211.253 326.83 211.253C326.83 211.253 326.83 211.253 326.83 211.253C326.83 211.253 326.83 211.252 326.83 211.252C326.83 211.252 326.83 211.252 326.83 211.252C326.83 211.252 326.83 211.252 326.83 211.252C326.83 211.251 326.83 211.251 326.83 211.251C326.83 211.251 326.83 211.251 326.83 211.251C326.83 211.251 326.83 211.251 326.83 211.25C326.83 211.25 326.83 211.25 326.83 211.25C326.83 211.25 326.83 211.25 326.83 211.25C326.83 211.249 326.83 211.249 326.83 211.249C326.83 211.249 326.83 211.249 326.83 211.249C326.83 211.249 326.83 211.249 326.83 211.248C326.83 211.248 326.83 211.248 326.83 211.248C326.83 211.248 326.83 211.248 326.83 211.248C326.83 211.248 326.83 211.247 326.83 211.247C326.83 211.247 326.83 211.247 326.83 211.247C326.83 211.247 326.83 211.247 326.83 211.246C326.83 211.246 326.83 211.246 326.83 211.246C326.83 211.246 326.83 211.246 326.83 211.246C326.83 211.246 326.83 211.245 326.83 211.245C326.83 211.245 326.83 211.245 326.83 211.245C326.83 211.245 326.83 211.245 326.83 211.245C326.83 211.244 326.83 211.244 326.83 211.244C326.83 211.244 326.83 211.244 326.83 211.244C326.83 211.244 326.83 211.243 326.83 211.243C326.83 211.243 326.83 211.243 326.83 211.243C326.83 211.243 326.83 211.243 326.83 211.243C326.83 211.242 326.83 211.242 326.83 211.242C326.83 211.242 326.83 211.242 326.83 211.242C326.83 211.242 326.83 211.242 326.83 211.241C326.83 211.241 326.83 211.241 326.83 211.241C326.83 211.241 326.83 211.241 326.83 211.241C326.83 211.24 326.83 211.24 326.83 211.24C326.83 211.24 326.83 211.24 326.83 211.24C326.83 211.24 326.83 211.24 326.83 211.239C326.83 211.239 326.83 211.239 326.83 211.239C326.83 211.239 326.83 211.239 326.83 211.239C326.83 211.239 326.83 211.238 326.83 211.238C326.83 211.238 326.83 211.238 326.83 211.238C326.83 211.238 326.83 211.238 326.83 211.237C326.83 211.237 326.83 211.237 326.83 211.237C326.83 211.237 326.83 211.237 326.83 211.237C326.83 211.237 326.83 211.236 326.83 211.236C326.83 211.236 326.83 211.236 326.83 211.236C326.83 211.236 326.83 211.236 326.83 211.236C326.83 211.235 326.83 211.235 326.83 211.235C326.83 211.235 326.83 211.235 326.83 211.235C326.83 211.235 326.83 211.235 326.83 211.234C326.83 211.234 326.83 211.234 326.83 211.234C326.83 211.234 326.83 211.234 326.83 211.234C326.83 211.233 326.83 211.233 326.83 211.233C326.83 211.233 326.83 211.233 326.83 211.233C326.83 211.233 326.83 211.233 326.83 211.232C326.83 211.232 326.83 211.232 326.83 211.232C326.83 211.232 326.83 211.232 326.83 211.232C326.83 211.232 326.83 211.231 326.83 211.231C326.83 211.231 326.83 211.231 326.83 211.231C326.83 211.231 326.83 211.231 326.83 211.23C326.83 211.23 326.83 211.23 326.83 211.23C326.83 211.23 326.83 211.23 326.83 211.23C326.83 211.23 326.83 211.229 326.83 211.229C326.83 211.229 326.83 211.229 326.83 211.229C326.83 211.229 326.83 211.229 326.83 211.229C326.83 211.228 326.83 211.228 326.83 211.228C326.83 211.228 326.83 211.228 326.83 211.228C326.83 211.228 326.83 211.227 326.83 211.227C326.83 211.227 326.83 211.227 326.83 211.227C326.83 211.227 326.83 211.227 326.83 211.227C326.83 211.226 326.83 211.226 326.83 211.226C326.83 211.226 326.83 211.226 326.83 211.226C326.83 211.226 326.83 211.226 326.83 211.225C326.83 211.225 326.83 211.225 326.83 211.225C326.83 211.225 326.83 211.225 326.83 211.225C326.83 211.224 326.83 211.224 326.83 211.224C326.83 211.224 326.83 211.224 326.83 211.224C326.83 211.224 326.83 211.224 326.83 211.223C326.83 211.223 326.83 211.223 326.83 211.223C326.83 211.223 326.83 211.223 326.83 211.223C326.83 211.223 326.83 211.222 326.83 211.222C326.83 211.222 326.83 211.222 326.83 211.222C326.83 211.222 326.83 211.222 326.83 211.221C326.83 211.221 326.83 211.221 326.83 211.221C326.83 211.221 326.83 211.221 326.83 211.221C326.83 211.221 326.83 211.22 326.83 211.22C326.83 211.22 326.83 211.22 326.83 211.22C326.83 211.22 326.83 211.22 326.83 211.22C326.83 211.219 326.83 211.219 326.83 211.219C326.83 211.219 326.83 211.219 326.83 211.219C326.83 211.219 326.83 211.218 326.83 211.218C326.83 211.218 326.83 211.218 326.83 211.218C326.83 211.218 326.83 211.218 326.83 211.218C326.83 211.217 326.83 211.217 326.83 211.217C326.83 211.217 326.83 211.217 326.83 211.217C326.83 211.217 326.83 211.217 326.83 211.216C326.83 211.216 326.83 211.216 326.83 211.216C326.83 211.216 326.83 211.216 326.83 211.216C326.83 211.215 326.83 211.215 326.83 211.215C326.83 211.215 326.83 211.215 326.83 211.215C326.83 211.215 326.83 211.215 326.83 211.214C326.83 211.214 326.83 211.214 326.83 211.214C326.83 211.214 326.83 211.214 326.83 211.214C326.83 211.214 326.83 211.213 326.83 211.213C326.83 211.213 326.83 211.213 326.83 211.213C326.83 211.213 326.83 211.213 326.83 211.212C326.83 211.212 326.83 211.212 326.83 211.212C326.83 211.212 326.83 211.212 326.83 211.212C326.83 211.212 326.83 211.211 326.83 211.211C326.83 211.211 326.83 211.211 326.83 211.211C326.83 211.211 326.83 211.211 326.83 211.211C326.83 211.21 326.83 211.21 326.83 211.21C326.83 211.21 326.83 211.21 326.83 211.21C326.83 211.21 326.83 211.21 326.83 211.209C326.83 211.209 326.83 211.209 326.83 211.209C326.83 211.209 326.83 211.209 326.83 211.209C326.83 211.208 326.83 211.208 326.83 211.208C326.83 211.208 326.83 211.208 326.83 211.208C326.83 211.208 326.83 211.208 326.83 211.207C326.83 211.207 326.83 211.207 326.83 211.207C326.83 211.207 326.83 211.207 326.83 211.207C326.83 211.207 326.83 211.206 326.83 211.206C326.83 211.206 326.83 211.206 326.83 211.206C326.83 211.206 326.83 211.206 326.83 211.205C326.83 211.205 326.83 211.205 326.83 211.205C326.83 211.205 326.83 211.205 326.83 211.205C326.83 211.205 326.83 211.204 326.83 211.204C326.83 211.204 326.83 211.204 326.83 211.204C326.83 211.204 326.83 211.204 326.83 211.204C326.83 211.203 326.83 211.203 326.83 211.203C326.83 211.203 326.83 211.203 326.83 211.203C326.83 211.203 326.83 211.202 326.83 211.202C326.83 211.202 326.83 211.202 326.83 211.202C326.83 211.202 326.83 211.202 326.83 211.202C326.83 211.201 326.83 211.201 326.83 211.201C326.83 211.201 326.83 211.201 326.83 211.201C326.83 211.201 326.83 211.201 326.83 211.2C326.83 211.2 326.83 211.2 326.83 211.2C326.83 211.2 326.83 211.2 326.83 211.2C326.83 211.199 326.83 211.199 326.83 211.199C326.83 211.199 326.83 211.199 326.83 211.199C326.83 211.199 326.83 211.199 326.83 211.198C326.83 211.198 326.83 211.198 326.83 211.198C326.83 211.198 326.83 211.198 326.83 211.198C326.83 211.198 326.83 211.197 326.83 211.197C326.83 211.197 326.83 211.197 326.83 211.197C326.83 211.197 326.83 211.197 326.83 211.196C326.83 211.196 326.83 211.196 326.83 211.196C326.83 211.196 326.83 211.196 326.83 211.196C326.83 211.196 326.83 211.195 326.83 211.195C326.83 211.195 326.83 211.195 326.83 211.195C326.83 211.195 326.83 211.195 326.83 211.195C326.83 211.194 326.83 211.194 326.83 211.194C326.83 211.194 326.83 211.194 326.83 211.194C326.83 211.194 326.83 211.193 326.83 211.193C326.83 211.193 326.83 211.193 326.83 211.193C326.83 211.193 326.83 211.193 326.83 211.193C326.83 211.192 326.83 211.192 326.83 211.192C326.83 211.192 326.83 211.192 326.83 211.192C326.83 211.192 326.83 211.192 326.83 211.191C326.83 211.191 326.83 211.191 326.83 211.191C326.83 211.191 326.83 211.191 326.83 211.191C326.83 211.19 326.83 211.19 326.83 211.19C326.83 211.19 326.83 211.19 326.83 211.19C326.83 211.19 326.83 211.19 326.83 211.189C326.83 211.189 326.83 211.189 326.83 211.189C326.83 211.189 326.83 211.189 326.83 211.189C326.83 211.189 326.83 211.188 326.83 211.188C326.83 211.188 326.83 211.188 326.83 211.188C326.83 211.188 326.83 211.188 326.83 211.187C326.83 211.187 326.83 211.187 326.83 211.187C326.83 211.187 326.83 211.187 326.83 211.187C326.83 211.187 326.83 211.186 326.83 211.186C326.83 211.186 326.83 211.186 326.83 211.186C326.83 211.186 326.83 211.186 326.83 211.186C326.83 211.185 326.83 211.185 326.83 211.185C326.83 211.185 326.83 211.185 326.83 211.185C326.83 211.185 326.83 211.185 326.83 211.184C326.83 211.184 326.83 211.184 326.83 211.184C326.83 211.184 326.83 211.184 326.83 211.184C326.83 211.183 326.83 211.183 326.83 211.183C326.83 211.183 326.83 211.183 326.83 211.183C326.83 211.183 326.83 211.183 326.83 211.182C326.83 211.182 326.83 211.182 326.83 211.182C326.83 211.182 326.83 211.182 326.83 211.182C326.83 211.182 326.83 211.181 326.83 211.181C326.83 211.181 326.83 211.181 326.83 211.181C326.83 211.181 326.83 211.181 326.83 211.18C326.83 211.18 326.83 211.18 326.83 211.18C326.83 211.18 326.83 211.18 326.83 211.18C326.83 211.18 326.83 211.179 326.83 211.179C326.83 211.179 326.83 211.179 326.83 211.179C326.83 211.179 326.83 211.179 326.83 211.179C326.83 211.178 326.83 211.178 326.83 211.178C326.83 211.178 326.83 211.178 326.83 211.178C326.83 211.178 326.83 211.177 326.83 211.177C326.83 211.177 326.83 211.177 326.83 211.177C326.83 211.177 326.83 211.177 326.83 211.177C326.83 211.176 326.83 211.176 326.83 211.176C326.83 211.176 326.83 211.176 326.83 211.176C326.83 211.176 326.83 211.176 326.83 211.175C326.83 211.175 326.83 211.175 326.83 211.175C326.83 211.175 326.83 211.175 326.83 211.175C326.83 211.174 326.83 211.174 326.83 211.174C326.83 211.174 326.83 211.174 326.83 211.174C326.83 211.174 326.83 211.174 326.83 211.173C326.83 211.173 326.83 211.173 326.83 211.173C326.83 211.173 326.83 211.173 326.83 211.173C326.83 211.173 326.83 211.172 326.83 211.172C326.83 211.172 326.83 211.172 326.83 211.172C326.83 211.172 326.83 211.172 326.83 211.171C326.83 211.171 326.83 211.171 326.83 211.171C326.83 211.171 326.83 211.171 326.83 211.171C326.83 211.171 326.83 211.17 326.83 211.17C326.83 211.17 326.83 211.17 326.83 211.17C326.83 211.17 326.83 211.17 326.83 211.17C326.83 211.169 326.83 211.169 326.83 211.169C326.83 211.169 326.83 211.169 326.83 211.169C326.83 211.169 326.83 211.168 326.83 211.168C326.83 211.168 326.83 211.168 326.83 211.168C326.83 211.168 326.83 211.168 326.83 211.168C326.83 211.167 326.83 211.167 326.83 211.167C326.83 211.167 326.83 211.167 326.83 211.167C326.83 211.167 326.83 211.167 326.83 211.166C326.83 211.166 326.83 211.166 326.83 211.166C326.83 211.166 326.83 211.166 326.83 211.166C326.83 211.165 326.83 211.165 326.83 211.165C326.83 211.165 326.83 211.165 326.83 211.165C326.83 211.165 326.83 211.165 326.83 211.164C326.83 211.164 326.83 211.164 326.83 211.164C326.83 211.164 326.83 211.164 326.83 211.164C326.83 211.164 326.83 211.163 326.83 211.163C326.83 211.163 326.83 211.163 326.83 211.163C326.83 211.163 326.83 211.163 326.83 211.162C326.83 211.162 326.83 211.162 326.83 211.162C326.83 211.162 326.83 211.162 326.83 211.162C326.83 211.162 326.83 211.161 326.83 211.161C326.83 211.161 326.83 211.161 326.83 211.161C326.83 211.161 326.83 211.161 326.83 211.161C326.83 211.16 326.83 211.16 326.83 211.16C326.83 211.16 326.83 211.16 326.83 211.16C326.83 211.16 326.83 211.16 326.83 211.159C326.83 211.159 326.83 211.159 326.83 211.159C326.83 211.159 326.83 211.159 326.83 211.159C326.83 211.158 326.83 211.158 326.83 211.158C326.83 211.158 326.83 211.158 326.83 211.158C326.83 211.158 326.83 211.158 326.83 211.157C326.83 211.157 326.83 211.157 326.83 211.157C326.83 211.157 326.83 211.157 326.83 211.157C326.83 211.157 326.83 211.156 326.83 211.156C326.83 211.156 326.83 211.156 326.83 211.156C326.83 211.156 326.83 211.156 326.83 211.155C326.83 211.155 326.83 211.155 326.83 211.155C326.83 211.155 326.83 211.155 326.83 211.155C326.83 211.155 326.83 211.154 326.83 211.154C326.83 211.154 326.83 211.154 326.83 211.154C326.83 211.154 326.83 211.154 326.83 211.154C326.83 211.153 326.83 211.153 326.83 211.153C326.83 211.153 326.83 211.153 326.83 211.153C326.83 211.153 326.83 211.152 326.83 211.152C326.83 211.152 326.83 211.152 326.83 211.152C326.83 211.152 326.83 211.152 326.83 211.152C326.83 211.151 326.83 211.151 326.83 211.151C326.83 211.151 326.83 211.151 326.83 211.151C326.83 211.151 326.83 211.151 326.83 211.15C326.83 211.15 326.83 211.15 326.83 211.15C326.83 211.15 326.83 211.15 326.83 211.15C326.83 211.149 326.83 211.149 326.83 211.149C326.83 211.149 326.83 211.149 326.83 211.149C326.83 211.149 326.83 211.149 326.83 211.148C326.83 211.148 326.83 211.148 326.83 211.148C326.83 211.148 326.83 211.148 326.83 211.148C326.83 211.148 326.83 211.147 326.83 211.147C326.83 211.147 326.83 211.147 326.83 211.147C326.83 211.147 326.83 211.147 326.83 211.146C326.83 211.146 326.83 211.146 326.83 211.146C326.83 211.146 326.83 211.146 326.83 211.146C326.83 211.146 326.83 211.145 326.83 211.145C326.83 211.145 326.83 211.145 326.83 211.145C326.83 211.145 326.83 211.145 326.83 211.145C326.83 211.144 326.83 211.144 326.83 211.144C326.83 211.144 326.83 211.144 326.83 211.144C326.83 211.144 326.83 211.143 326.83 211.143C326.83 211.143 326.83 211.143 326.83 211.143C326.83 211.143 326.83 211.143 326.83 211.143C326.83 211.142 326.83 211.142 326.83 211.142C326.83 211.142 326.83 211.142 326.83 211.142C326.83 211.142 326.83 211.142 326.83 211.141C326.83 211.141 326.83 211.141 326.83 211.141C326.83 211.141 326.83 211.141 326.83 211.141C326.83 211.14 326.83 211.14 326.83 211.14C326.83 211.14 326.83 211.14 326.83 211.14C326.83 211.14 326.83 211.14 326.83 211.139C326.83 211.139 326.83 211.139 326.83 211.139C326.83 211.139 326.83 211.139 326.83 211.139C326.83 211.139 326.83 211.138 326.83 211.138C326.83 211.138 326.83 211.138 326.83 211.138C326.83 211.138 326.83 211.138 326.83 211.137C326.83 211.137 326.83 211.137 326.83 211.137C326.83 211.137 326.83 211.137 326.83 211.137C326.83 211.137 326.83 211.136 326.83 211.136C326.83 211.136 326.83 211.136 326.83 211.136C326.83 211.136 326.83 211.136 326.83 211.136C326.83 211.135 326.83 211.135 326.83 211.135C326.83 211.135 326.83 211.135 326.83 211.135C326.83 211.135 326.83 211.135 326.83 211.134C326.83 211.134 326.83 211.134 326.83 211.134C326.83 211.134 326.83 211.134 326.83 211.134C326.83 211.133 326.83 211.133 326.83 211.133C326.83 211.133 326.83 211.133 326.83 211.133C326.83 211.133 326.83 211.133 326.83 211.132C326.83 211.132 326.83 211.132 326.83 211.132C326.83 211.132 326.83 211.132 326.83 211.132C326.83 211.132 326.83 211.131 326.83 211.131C326.83 211.131 326.83 211.131 326.83 211.131C326.83 211.131 326.83 211.131 326.83 211.13C326.83 211.13 326.83 211.13 326.83 211.13C326.83 211.13 326.83 211.13 326.83 211.13C326.83 211.13 326.83 211.129 326.83 211.129C326.83 211.129 326.83 211.129 326.83 211.129C326.83 211.129 326.83 211.129 326.83 211.129C326.83 211.128 326.83 211.128 326.83 211.128C326.83 211.128 326.83 211.128 326.83 211.128C326.83 211.128 326.83 211.127 326.83 211.127C326.83 211.127 326.83 211.127 326.83 211.127C326.83 211.127 326.83 211.127 326.83 211.127C326.83 211.126 326.83 211.126 326.83 211.126C326.83 211.126 326.83 211.126 326.83 211.126C326.83 211.126 326.83 211.126 326.83 211.125C326.83 211.125 326.83 211.125 326.83 211.125C326.83 211.125 326.83 211.125 326.83 211.125C326.83 211.124 326.83 211.124 326.83 211.124C326.83 211.124 326.83 211.124 326.83 211.124C326.83 211.124 326.83 211.124 326.83 211.123C326.83 211.123 326.83 211.123 326.83 211.123C326.83 211.123 326.83 211.123 326.83 211.123C326.83 211.123 326.83 211.122 326.83 211.122C326.83 211.122 326.83 211.122 326.83 211.122C326.83 211.122 326.83 211.122 326.83 211.121C326.83 211.121 326.83 211.121 326.83 211.121C326.83 211.121 326.83 211.121 326.83 211.121C326.83 211.121 326.83 211.12 326.83 211.12C326.83 211.12 326.83 211.12 326.83 211.12C326.83 211.12 326.83 211.12 326.83 211.12C326.83 211.119 326.83 211.119 326.83 211.119C326.83 211.119 326.83 211.119 326.83 211.119C326.83 211.119 326.83 211.118 326.83 211.118C326.83 211.118 326.83 211.118 326.83 211.118C326.83 211.118 326.83 211.118 326.83 211.118C326.83 211.117 326.83 211.117 326.83 211.117C326.83 211.117 326.83 211.117 326.83 211.117C326.83 211.117 326.83 211.117 326.83 211.116C326.83 211.116 326.83 211.116 326.83 211.116C326.83 211.116 326.83 211.116 326.83 211.116C326.83 211.115 326.83 211.115 326.83 211.115C326.83 211.115 326.83 211.115 326.83 211.115C326.83 211.115 326.83 211.115 326.83 211.114C326.83 211.114 326.83 211.114 326.83 211.114C326.83 211.114 326.83 211.114 326.83 211.114C326.83 211.114 326.83 211.113 326.83 211.113C326.83 211.113 326.83 211.113 326.83 211.113C326.83 211.113 326.83 211.113 326.83 211.112C326.83 211.112 326.83 211.112 326.83 211.112C326.83 211.112 326.83 211.112 326.83 211.112C326.83 211.112 326.83 211.111 326.83 211.111C326.83 211.111 326.83 211.111 326.83 211.111C326.83 211.111 326.83 211.111 326.83 211.111C326.83 211.11 326.83 211.11 326.83 211.11C326.83 211.11 326.83 211.11 326.83 211.11C326.83 211.11 326.83 211.11 326.83 211.109C326.83 211.109 326.83 211.109 326.83 211.109C326.83 211.109 326.83 211.109 326.83 211.109C326.83 211.108 326.83 211.108 326.83 211.108C326.83 211.108 326.83 211.108 326.83 211.108C326.83 211.108 326.83 211.108 326.83 211.107C326.83 211.107 326.83 211.107 326.83 211.107C326.83 211.107 326.83 211.107 326.83 211.107C326.83 211.107 326.83 211.106 326.83 211.106C326.83 211.106 326.83 211.106 326.83 211.106C326.83 211.106 326.83 211.106 326.83 211.105C326.83 211.105 326.83 211.105 326.83 211.105C326.83 211.105 326.83 211.105 326.83 211.105C326.83 211.105 326.83 211.104 326.83 211.104C326.83 211.104 326.83 211.104 326.83 211.104C326.83 211.104 326.83 211.104 326.83 211.104C326.83 211.103 326.83 211.103 326.83 211.103C326.83 211.103 326.83 211.103 326.83 211.103C326.83 211.103 326.83 211.102 326.83 211.102C326.83 211.102 326.83 211.102 326.83 211.102C326.83 211.102 326.83 211.102 326.83 211.102C326.83 211.101 326.83 211.101 326.83 211.101C326.83 211.101 326.83 211.101 326.83 211.101C326.83 211.101 326.83 211.101 326.83 211.1C326.83 211.1 326.83 211.1 326.83 211.1H323.83ZM323.83 211.3V264H326.83V211.3H323.83ZM325.33 262.5H324.33V265.5H325.33V262.5ZM325.83 264V211.1H322.83V264H325.83ZM325.83 211.1C325.83 211.065 325.835 211.105 325.8 211.184C325.761 211.272 325.698 211.349 325.63 211.4L323.83 209C323.108 209.541 322.83 210.334 322.83 211.1H325.83ZM325.63 211.4C325.668 211.371 325.677 211.372 325.656 211.379C325.633 211.388 325.588 211.4 325.53 211.4V208.4C324.865 208.4 324.29 208.655 323.83 209L325.63 211.4ZM325.53 211.4C325.537 211.4 325.522 211.401 325.493 211.392C325.462 211.383 325.428 211.368 325.398 211.348L327.062 208.852C326.589 208.537 326.059 208.4 325.53 208.4V211.4ZM325.398 211.348C325.47 211.397 325.652 211.544 325.969 211.861L328.09 209.739C327.74 209.389 327.389 209.07 327.062 208.852L325.398 211.348ZM332.43 274.5C333.839 274.5 335.236 274.215 336.19 273.261L334.069 271.139C333.957 271.252 333.553 271.5 332.43 271.5V274.5ZM336.19 273.261C337.184 272.267 337.53 270.87 337.53 269.4H334.53C334.53 270.463 334.275 270.933 334.069 271.139L336.19 273.261ZM337.53 269.4V236.4H334.53V269.4H337.53ZM334.873 237.355L351.973 258.055L354.286 256.145L337.186 235.445L334.873 237.355ZM351.63 257.1V269.4H354.63V257.1H351.63ZM351.63 269.4C351.63 270.832 351.924 272.201 352.809 273.197L355.051 271.203C354.869 270.999 354.63 270.501 354.63 269.4H351.63ZM352.933 273.321C353.928 274.206 355.298 274.5 356.73 274.5V271.5C355.628 271.5 355.131 271.261 354.926 271.079L352.933 273.321ZM356.73 274.5H371.73V271.5H356.73V274.5ZM371.73 274.5C373.139 274.5 374.536 274.215 375.49 273.261L373.369 271.139C373.257 271.252 372.853 271.5 371.73 271.5V274.5ZM375.49 273.261C376.484 272.267 376.83 270.87 376.83 269.4H373.83C373.83 270.463 373.575 270.933 373.369 271.139L375.49 273.261ZM376.83 269.4V204.6H373.83V269.4H376.83ZM376.83 204.6C376.83 203.149 376.492 201.726 375.426 200.779L373.433 203.021C373.567 203.14 373.83 203.518 373.83 204.6H376.83ZM375.551 200.903C374.603 199.837 373.181 199.5 371.73 199.5V202.5C372.812 202.5 373.189 202.763 373.309 202.897L375.551 200.903ZM371.73 199.5H356.73V202.5H371.73V199.5ZM356.73 199.5C355.259 199.5 353.863 199.845 352.869 200.839L354.99 202.961C355.196 202.755 355.667 202.5 356.73 202.5V199.5ZM352.869 200.839C351.915 201.794 351.63 203.19 351.63 204.6H354.63C354.63 203.476 354.878 203.073 354.99 202.961L352.869 200.839ZM351.63 204.6V225.9H354.63V204.6H351.63ZM354.259 224.913L334.859 202.713L332.6 204.687L352 226.887L354.259 224.913ZM334.863 202.718C333.891 201.596 332.816 200.733 331.621 200.221L330.439 202.979C331.11 203.267 331.835 203.804 332.596 204.682L334.863 202.718ZM331.658 200.238C330.541 199.722 329.246 199.5 327.83 199.5V202.5C328.947 202.5 329.785 202.678 330.401 202.962L331.658 200.238ZM327.83 199.5H317.43V202.5H327.83V199.5ZM317.43 199.5C315.959 199.5 314.563 199.845 313.569 200.839L315.69 202.961C315.896 202.755 316.367 202.5 317.43 202.5V199.5ZM313.569 200.839C312.615 201.794 312.33 203.19 312.33 204.6H315.33C315.33 203.476 315.578 203.073 315.69 202.961L313.569 200.839ZM312.33 204.6V269.4H315.33V204.6H312.33ZM312.33 269.4C312.33 270.832 312.624 272.201 313.509 273.197L315.751 271.203C315.569 270.999 315.33 270.501 315.33 269.4H312.33ZM313.633 273.321C314.628 274.206 315.998 274.5 317.43 274.5V271.5C316.328 271.5 315.831 271.261 315.626 271.079L313.633 273.321ZM317.43 274.5H332.43V271.5H317.43V274.5ZM334.671 271.946L321.671 282.746L323.588 285.054L336.588 274.254L334.671 271.946ZM321.569 282.839C321.543 282.866 321.365 283.007 320.855 283.177L321.804 286.023C322.494 285.793 323.183 285.468 323.69 284.961L321.569 282.839ZM320.803 283.196C320.464 283.323 320.047 283.4 319.53 283.4V286.4C320.346 286.4 321.129 286.277 321.856 286.004L320.803 283.196ZM319.53 283.4H304.53V286.4H319.53V283.4ZM304.53 283.4C303.117 283.4 302.422 283.071 302.09 282.739L299.969 284.861C301.104 285.996 302.743 286.4 304.53 286.4V283.4ZM302.09 282.739C301.759 282.408 301.43 281.713 301.43 280.3H298.43C298.43 282.087 298.834 283.726 299.969 284.861L302.09 282.739ZM301.43 280.3V215.5H298.43V280.3H301.43ZM301.43 215.5C301.43 214.739 301.519 214.176 301.653 213.774L298.807 212.826C298.541 213.624 298.43 214.527 298.43 215.5H301.43ZM301.6 213.909C301.783 213.499 302.02 213.184 302.306 212.939L300.353 210.661C299.706 211.216 299.21 211.901 298.859 212.691L301.6 213.909ZM302.298 212.946L315.198 202.046L313.262 199.754L300.362 210.654L302.298 212.946ZM315.167 202.071C315.291 201.972 315.511 201.851 315.893 201.755L315.166 198.845C314.481 199.016 313.836 199.294 313.293 199.729L315.167 202.071ZM316.004 201.723C316.443 201.577 316.915 201.5 317.43 201.5V198.5C316.611 198.5 315.816 198.623 315.055 198.877L316.004 201.723ZM317.43 201.5H327.83V198.5H317.43V201.5ZM327.83 201.5C329.146 201.5 330.148 201.711 330.895 202.059L332.164 199.341C330.911 198.756 329.447 198.5 327.83 198.5V201.5ZM330.895 202.059C331.676 202.424 332.526 203.056 333.435 204.026L335.624 201.974C334.533 200.811 333.383 199.91 332.164 199.341L330.895 202.059ZM333.394 203.98L340.294 211.98L342.566 210.02L335.666 202.02L333.394 203.98ZM342.391 212.152L354.491 202.052L352.568 199.748L340.468 209.848L342.391 212.152ZM354.467 202.071C354.591 201.972 354.811 201.851 355.194 201.755L354.466 198.845C353.781 199.016 353.136 199.294 352.593 199.729L354.467 202.071ZM355.304 201.723C355.743 201.577 356.215 201.5 356.73 201.5V198.5C355.911 198.5 355.116 198.623 354.355 198.877L355.304 201.723ZM356.73 201.5H371.73V198.5H356.73V201.5ZM371.73 201.5C373.143 201.5 373.837 201.829 374.169 202.161L376.29 200.039C375.155 198.904 373.517 198.5 371.73 198.5V201.5ZM374.169 202.161C374.501 202.492 374.83 203.187 374.83 204.6H377.83C377.83 202.813 377.425 201.174 376.29 200.039L374.169 202.161ZM374.83 204.6V269.4H377.83V204.6H374.83ZM374.83 269.4C374.83 270.121 374.718 270.633 374.559 270.991L377.3 272.209C377.675 271.367 377.83 270.413 377.83 269.4H374.83ZM374.507 271.126C374.39 271.476 374.208 271.743 373.954 271.961L375.906 274.239C376.585 273.657 377.069 272.924 377.353 272.074L374.507 271.126ZM373.971 271.946L360.971 282.746L362.888 285.054L375.888 274.254L373.971 271.946ZM360.869 282.839C360.843 282.866 360.665 283.007 360.155 283.177L361.104 286.023C361.794 285.793 362.483 285.468 362.99 284.961L360.869 282.839ZM360.103 283.196C359.764 283.323 359.347 283.4 358.83 283.4V286.4C359.646 286.4 360.429 286.277 361.156 286.004L360.103 283.196ZM358.83 283.4H343.83V286.4H358.83V283.4ZM343.83 283.4C342.417 283.4 341.722 283.071 341.39 282.739L339.269 284.861C340.404 285.996 342.043 286.4 343.83 286.4V283.4ZM341.39 282.739C341.059 282.408 340.73 281.713 340.73 280.3H337.73C337.73 282.087 338.134 283.726 339.269 284.861L341.39 282.739ZM340.73 280.3V268.4H337.73V280.3H340.73ZM340.393 267.452L338.193 264.752L335.867 266.648L338.067 269.348L340.393 267.452ZM335.53 265.7V269.4H338.53V265.7H335.53ZM335.53 269.4C335.53 270.121 335.418 270.633 335.259 270.991L338 272.209C338.375 271.367 338.53 270.413 338.53 269.4H335.53ZM335.207 271.126C335.09 271.476 334.908 271.743 334.654 271.961L336.606 274.239C337.285 273.657 337.769 272.924 338.053 272.074L335.207 271.126ZM384.684 283.8L385.744 282.739L385.744 282.739L384.684 283.8ZM383.884 266.2L382.513 265.591L382.483 265.657L382.461 265.726L383.884 266.2ZM384.984 264.7L384.017 263.553L384.007 263.561L384.984 264.7ZM397.084 254.5L398.05 255.647L398.584 255.197V254.5H397.084ZM397.084 232.2H398.584V230.7H397.084V232.2ZM384.684 231.1L385.744 230.039L385.744 230.039L384.684 231.1ZM383.884 213.3L382.513 212.691L382.483 212.757L382.461 212.826L383.884 213.3ZM384.984 211.8L384.015 210.654L384.007 210.661L384.984 211.8ZM397.884 200.9L396.947 199.729L396.931 199.741L396.915 199.754L397.884 200.9ZM399.184 200.3L399.547 201.755L399.603 201.741L399.658 201.723L399.184 200.3ZM447.884 218.9L446.513 218.291L446.483 218.357L446.461 218.426L447.884 218.9ZM446.884 220.4L447.849 221.548L447.854 221.544L447.86 221.539L446.884 220.4ZM434.984 230.4L434.019 229.252L433.484 229.701V230.4H434.984ZM434.984 252.9H433.484V254.4H434.984V252.9ZM447.184 254L446.123 255.061L446.123 255.061L447.184 254ZM447.884 271.6L446.513 270.991L446.483 271.057L446.461 271.126L447.884 271.6ZM446.884 273.1L447.842 274.254L447.851 274.246L447.86 274.239L446.884 273.1ZM433.884 283.9L432.925 282.746L432.872 282.79L432.823 282.839L433.884 283.9ZM432.584 284.6L432.109 283.177L432.083 283.186L432.057 283.196L432.584 284.6ZM446.384 272.2L445.323 271.139L445.323 271.139L446.384 272.2ZM446.384 254.8L445.262 255.797L445.321 255.862L445.387 255.921L446.384 254.8ZM433.984 253.9H432.484V255.4H433.984V253.9ZM433.984 220.3V218.8H432.484V220.3H433.984ZM446.384 219.5L445.323 218.439L445.323 218.439L446.384 219.5ZM446.384 201.9L445.262 202.897L445.321 202.962L445.387 203.021L446.384 201.9ZM398.284 201.9L397.223 200.839L397.223 200.839L398.284 201.9ZM398.284 219.5L397.162 220.497L397.221 220.562L397.287 220.621L398.284 219.5ZM410.984 220.3H412.484V218.8H410.984V220.3ZM410.984 253.9V255.4H412.484V253.9H410.984ZM398.284 254.8L399.344 255.861L399.344 255.861L398.284 254.8ZM398.284 272.2L397.162 273.197L397.221 273.262L397.287 273.321L398.284 272.2ZM438.284 264V265.5H439.784V264H438.284ZM406.484 264H404.984V265.5H406.484V264ZM406.484 263V261.5H404.984V263H406.484ZM421.984 263V264.5H423.484V263H421.984ZM421.984 211H423.484V209.5H421.984V211ZM406.484 211H404.984V212.5H406.484V211ZM406.484 210V208.5H404.984V210H406.484ZM438.284 210H439.784V208.5H438.284V210ZM438.284 211V212.5H439.784V211H438.284ZM422.984 211V209.5H421.484V211H422.984ZM422.984 263H421.484V264.5H422.984V263ZM438.284 263H439.784V261.5H438.284V263ZM430.784 283.4H388.184V286.4H430.784V283.4ZM388.184 283.4C386.77 283.4 386.076 283.071 385.744 282.739L383.623 284.861C384.758 285.996 386.397 286.4 388.184 286.4V283.4ZM385.744 282.739C385.413 282.408 385.084 281.713 385.084 280.3H382.084C382.084 282.087 382.488 283.726 383.623 284.861L385.744 282.739ZM385.084 280.3V268.4H382.084V280.3H385.084ZM385.084 268.4C385.084 267.639 385.173 267.076 385.307 266.674L382.461 265.726C382.195 266.524 382.084 267.427 382.084 268.4H385.084ZM385.254 266.809C385.437 266.399 385.674 266.084 385.96 265.839L384.007 263.561C383.36 264.116 382.864 264.801 382.513 265.591L385.254 266.809ZM385.95 265.847L398.05 255.647L396.117 253.353L384.017 263.553L385.95 265.847ZM398.584 254.5V232.2H395.584V254.5H398.584ZM397.084 230.7H388.184V233.7H397.084V230.7ZM388.184 230.7C386.77 230.7 386.076 230.371 385.744 230.039L383.623 232.161C384.758 233.296 386.397 233.7 388.184 233.7V230.7ZM385.744 230.039C385.413 229.708 385.084 229.013 385.084 227.6H382.084C382.084 229.387 382.488 231.026 383.623 232.161L385.744 230.039ZM385.084 227.6V215.5H382.084V227.6H385.084ZM385.084 215.5C385.084 214.739 385.173 214.176 385.307 213.774L382.461 212.826C382.195 213.624 382.084 214.527 382.084 215.5H385.084ZM385.254 213.909C385.437 213.499 385.674 213.184 385.96 212.939L384.007 210.661C383.36 211.216 382.864 211.901 382.513 212.691L385.254 213.909ZM385.952 212.946L398.852 202.046L396.915 199.754L384.015 210.654L385.952 212.946ZM398.821 202.071C398.944 201.972 399.165 201.851 399.547 201.755L398.82 198.845C398.135 199.016 397.489 199.294 396.947 199.729L398.821 202.071ZM399.658 201.723C400.097 201.577 400.569 201.5 401.084 201.5V198.5C400.264 198.5 399.47 198.623 398.709 198.877L399.658 201.723ZM401.084 201.5H443.684V198.5H401.084V201.5ZM443.684 201.5C445.097 201.5 445.791 201.829 446.123 202.161L448.244 200.039C447.109 198.904 445.47 198.5 443.684 198.5V201.5ZM446.123 202.161C446.455 202.492 446.784 203.187 446.784 204.6H449.784C449.784 202.813 449.379 201.174 448.244 200.039L446.123 202.161ZM446.784 204.6V216.7H449.784V204.6H446.784ZM446.784 216.7C446.784 217.421 446.672 217.933 446.513 218.291L449.254 219.509C449.629 218.667 449.784 217.713 449.784 216.7H446.784ZM446.461 218.426C446.344 218.776 446.161 219.043 445.907 219.261L447.86 221.539C448.539 220.957 449.023 220.224 449.307 219.374L446.461 218.426ZM445.919 219.252L434.019 229.252L435.949 231.548L447.849 221.548L445.919 219.252ZM433.484 230.4V252.9H436.484V230.4H433.484ZM434.984 254.4H443.684V251.4H434.984V254.4ZM443.684 254.4C445.097 254.4 445.791 254.729 446.123 255.061L448.244 252.939C447.109 251.804 445.47 251.4 443.684 251.4V254.4ZM446.123 255.061C446.455 255.392 446.784 256.087 446.784 257.5H449.784C449.784 255.713 449.379 254.074 448.244 252.939L446.123 255.061ZM446.784 257.5V269.4H449.784V257.5H446.784ZM446.784 269.4C446.784 270.121 446.672 270.633 446.513 270.991L449.254 272.209C449.629 271.367 449.784 270.413 449.784 269.4H446.784ZM446.461 271.126C446.344 271.476 446.161 271.743 445.907 271.961L447.86 274.239C448.539 273.657 449.023 272.924 449.307 272.074L446.461 271.126ZM445.925 271.946L432.925 282.746L434.842 285.054L447.842 274.254L445.925 271.946ZM432.823 282.839C432.797 282.866 432.619 283.007 432.109 283.177L433.058 286.023C433.748 285.793 434.437 285.468 434.944 284.961L432.823 282.839ZM432.057 283.196C431.718 283.323 431.3 283.4 430.784 283.4V286.4C431.6 286.4 432.383 286.277 433.11 286.004L432.057 283.196ZM401.084 274.5H443.684V271.5H401.084V274.5ZM443.684 274.5C445.093 274.5 446.49 274.215 447.444 273.261L445.323 271.139C445.211 271.252 444.807 271.5 443.684 271.5V274.5ZM447.444 273.261C448.438 272.267 448.784 270.87 448.784 269.4H445.784C445.784 270.463 445.529 270.933 445.323 271.139L447.444 273.261ZM448.784 269.4V257.5H445.784V269.4H448.784ZM448.784 257.5C448.784 256.049 448.446 254.626 447.38 253.679L445.387 255.921C445.521 256.04 445.784 256.418 445.784 257.5H448.784ZM447.505 253.803C446.557 252.737 445.135 252.4 443.684 252.4V255.4C444.766 255.4 445.143 255.663 445.262 255.797L447.505 253.803ZM443.684 252.4H433.984V255.4H443.684V252.4ZM435.484 253.9V220.3H432.484V253.9H435.484ZM433.984 221.8H443.684V218.8H433.984V221.8ZM443.684 221.8C445.093 221.8 446.49 221.515 447.444 220.561L445.323 218.439C445.211 218.552 444.807 218.8 443.684 218.8V221.8ZM447.444 220.561C448.438 219.567 448.784 218.17 448.784 216.7H445.784C445.784 217.763 445.529 218.233 445.323 218.439L447.444 220.561ZM448.784 216.7V204.6H445.784V216.7H448.784ZM448.784 204.6C448.784 203.149 448.446 201.726 447.38 200.779L445.387 203.021C445.521 203.14 445.784 203.518 445.784 204.6H448.784ZM447.505 200.903C446.557 199.837 445.135 199.5 443.684 199.5V202.5C444.766 202.5 445.143 202.763 445.262 202.897L447.505 200.903ZM443.684 199.5H401.084V202.5H443.684V199.5ZM401.084 199.5C399.613 199.5 398.217 199.845 397.223 200.839L399.344 202.961C399.55 202.755 400.021 202.5 401.084 202.5V199.5ZM397.223 200.839C396.269 201.794 395.984 203.19 395.984 204.6H398.984C398.984 203.476 399.232 203.073 399.344 202.961L397.223 200.839ZM395.984 204.6V216.7H398.984V204.6H395.984ZM395.984 216.7C395.984 218.132 396.278 219.501 397.162 220.497L399.405 218.503C399.223 218.299 398.984 217.801 398.984 216.7H395.984ZM397.287 220.621C398.282 221.506 399.652 221.8 401.084 221.8V218.8C399.982 218.8 399.485 218.561 399.28 218.379L397.287 220.621ZM401.084 221.8H410.984V218.8H401.084V221.8ZM409.484 220.3V253.9H412.484V220.3H409.484ZM410.984 252.4H401.084V255.4H410.984V252.4ZM401.084 252.4C399.613 252.4 398.217 252.745 397.223 253.739L399.344 255.861C399.55 255.655 400.021 255.4 401.084 255.4V252.4ZM397.223 253.739C396.269 254.694 395.984 256.09 395.984 257.5H398.984C398.984 256.376 399.232 255.973 399.344 255.861L397.223 253.739ZM395.984 257.5V269.4H398.984V257.5H395.984ZM395.984 269.4C395.984 270.832 396.278 272.201 397.162 273.197L399.405 271.203C399.223 270.999 398.984 270.501 398.984 269.4H395.984ZM397.287 273.321C398.282 274.206 399.652 274.5 401.084 274.5V271.5C399.982 271.5 399.485 271.261 399.28 271.079L397.287 273.321ZM438.284 262.5H406.484V265.5H438.284V262.5ZM407.984 264V263H404.984V264H407.984ZM406.484 264.5H421.984V261.5H406.484V264.5ZM423.484 263V211H420.484V263H423.484ZM421.984 209.5H406.484V212.5H421.984V209.5ZM407.984 211V210H404.984V211H407.984ZM406.484 211.5H438.284V208.5H406.484V211.5ZM436.784 210V211H439.784V210H436.784ZM438.284 209.5H422.984V212.5H438.284V209.5ZM421.484 211V263H424.484V211H421.484ZM422.984 264.5H438.284V261.5H422.984V264.5ZM436.784 263V264H439.784V263H436.784ZM141.2 482.6L140.139 483.661L141.2 482.6ZM139.6 341.6L138.229 340.991L138.2 341.057L138.177 341.126L139.6 341.6ZM141.8 338.6L140.832 337.454L140.824 337.461L141.8 338.6ZM167.6 316.8L166.663 315.629L166.647 315.641L166.632 315.654L167.6 316.8ZM170.2 315.6L170.564 317.055L170.62 317.041L170.674 317.023L170.2 315.6ZM259 318L259.447 316.568L259.447 316.568L259 318ZM282 339.4L280.559 339.817L280.564 339.834L280.57 339.852L282 339.4ZM281.6 399.2L280.184 398.704L280.181 398.715L280.177 398.726L281.6 399.2ZM272.4 412.6L273.359 413.754L273.365 413.749L273.37 413.744L272.4 412.6ZM246.4 434.2L245.441 433.046L245.435 433.051L246.4 434.2ZM233.4 441.2L233.874 442.623L233.885 442.619L233.896 442.616L233.4 441.2ZM214.2 444.2L214.147 442.701L212.7 442.752V444.2H214.2ZM213.4 458.2L212.029 457.591L212 457.657L211.977 457.726L213.4 458.2ZM211.4 461.2L212.359 462.354L212.367 462.346L212.376 462.339L211.4 461.2ZM185.4 482.8L184.441 481.646L184.388 481.69L184.339 481.739L185.4 482.8ZM182.8 484.2L182.326 482.777L182.299 482.786L182.273 482.796L182.8 484.2ZM210.4 459.4L209.339 458.339L209.339 458.339L210.4 459.4ZM212.2 420.6V419.1H210.7V420.6H212.2ZM272.4 409.8L271.299 408.781L271.299 408.781L272.4 409.8ZM272.4 327.8L271.299 328.819L271.299 328.819L272.4 327.8ZM168.4 318.8L167.339 317.739L167.339 317.739L168.4 318.8ZM168.4 459.4L167.279 460.397L167.338 460.462L167.403 460.521L168.4 459.4ZM191.2 403.6V402.1H189.7V403.6H191.2ZM191.2 443V444.5H192.7V443H191.2ZM189.2 443H187.7V444.5H189.2V443ZM189.2 335V333.5H187.7V335H189.2ZM247.6 337.2L247.068 338.602L247.097 338.613L247.126 338.623L247.6 337.2ZM256.8 342.8L255.679 343.797L255.679 343.797L256.8 342.8ZM261.2 351.4L259.741 351.75L259.741 351.75L261.2 351.4ZM261.2 387.8L262.655 388.164L262.657 388.157L262.659 388.15L261.2 387.8ZM256.8 396.2L257.892 397.228L257.907 397.213L257.921 397.197L256.8 396.2ZM247.6 401.6L247.126 400.177L247.118 400.179L247.111 400.182L247.6 401.6ZM191.2 401.6H189.7V403.1H191.2V401.6ZM246.6 399.8L246.141 398.372L246.133 398.374L246.126 398.377L246.6 399.8ZM255.2 394.8L256.294 395.826L256.31 395.809L256.325 395.792L255.2 394.8ZM259.2 387L257.749 386.621L257.743 386.644L257.737 386.668L259.2 387ZM259.2 352.2L257.734 352.519L257.741 352.549L257.749 352.579L259.2 352.2ZM255.2 344.2L256.325 343.208L256.325 343.208L255.2 344.2ZM246.6 339L246.079 340.407L246.11 340.418L246.141 340.428L246.6 339ZM191.2 337V335.5H189.7V337H191.2ZM211.8 354.4V352.9H210.3V354.4H211.8ZM237.4 357.4L236.114 358.172L236.114 358.172L237.4 357.4ZM237.4 381.6L238.686 382.372L238.686 382.372L237.4 381.6ZM211.8 384.6H210.3V386.1H211.8V384.6ZM179.2 483.3H148.2V486.3H179.2V483.3ZM148.2 483.3C145.187 483.3 143.326 482.604 142.261 481.539L140.139 483.661C142.008 485.529 144.813 486.3 148.2 486.3V483.3ZM142.261 481.539C141.196 480.474 140.5 478.613 140.5 475.6H137.5C137.5 478.987 138.271 481.792 140.139 483.661L142.261 481.539ZM140.5 475.6V346H137.5V475.6H140.5ZM140.5 346C140.5 344.373 140.689 343.076 141.023 342.074L138.177 341.126C137.711 342.524 137.5 344.161 137.5 346H140.5ZM140.971 342.209C141.42 341.199 142.023 340.384 142.776 339.739L140.824 337.461C139.71 338.416 138.847 339.601 138.229 340.991L140.971 342.209ZM142.768 339.746L168.568 317.946L166.632 315.654L140.832 337.454L142.768 339.746ZM168.537 317.971C168.994 317.606 169.648 317.284 170.564 317.055L169.836 314.145C168.618 314.449 167.539 314.928 166.663 315.629L168.537 317.971ZM170.674 317.023C171.713 316.677 172.819 316.5 174 316.5V313.5C172.514 313.5 171.087 313.723 169.726 314.177L170.674 317.023ZM174 316.5H235.2V313.5H174V316.5ZM235.2 316.5C244.572 316.5 252.343 317.491 258.553 319.432L259.447 316.568C252.857 314.509 244.761 313.5 235.2 313.5V316.5ZM258.553 319.432C264.793 321.382 269.635 324.082 273.159 327.48L275.241 325.32C271.298 321.518 266.007 318.618 259.447 316.568L258.553 319.432ZM273.159 327.48C276.7 330.894 279.164 334.998 280.559 339.817L283.441 338.983C281.903 333.669 279.167 329.106 275.241 325.32L273.159 327.48ZM280.57 339.852C282.118 344.755 282.9 350.134 282.9 356H285.9C285.9 349.866 285.082 344.179 283.43 338.948L280.57 339.852ZM282.9 356V381.6H285.9V356H282.9ZM282.9 381.6C282.9 387.853 281.988 393.55 280.184 398.704L283.016 399.696C284.945 394.183 285.9 388.147 285.9 381.6H282.9ZM280.177 398.726C278.535 403.651 275.632 407.891 271.43 411.456L273.37 413.744C277.968 409.843 281.198 405.149 283.023 399.674L280.177 398.726ZM271.441 411.446L245.441 433.046L247.359 435.354L273.359 413.754L271.441 411.446ZM245.435 433.051C242.275 435.706 238.115 437.961 232.904 439.784L233.896 442.616C239.352 440.706 243.858 438.294 247.365 435.349L245.435 433.051ZM232.926 439.777C227.903 441.451 221.655 442.437 214.147 442.701L214.253 445.699C221.945 445.429 228.497 444.416 233.874 442.623L232.926 439.777ZM212.7 444.2V453.8H215.7V444.2H212.7ZM212.7 453.8C212.7 455.387 212.455 456.633 212.029 457.591L214.771 458.809C215.412 457.367 215.7 455.679 215.7 453.8H212.7ZM211.977 457.726C211.66 458.676 211.145 459.443 210.424 460.061L212.376 462.339C213.522 461.357 214.34 460.124 214.823 458.674L211.977 457.726ZM210.441 460.046L184.441 481.646L186.359 483.954L212.359 462.354L210.441 460.046ZM184.339 481.739C184.046 482.032 183.436 482.407 182.326 482.777L183.274 485.623C184.564 485.193 185.687 484.634 186.461 483.861L184.339 481.739ZM182.273 482.796C181.401 483.123 180.384 483.3 179.2 483.3V486.3C180.683 486.3 182.066 486.077 183.327 485.604L182.273 482.796ZM205 462.5C207.676 462.5 209.973 461.948 211.461 460.461L209.339 458.339C208.694 458.985 207.39 459.5 205 459.5V462.5ZM211.461 460.461C213.055 458.867 213.7 456.537 213.7 453.8H210.7C210.7 456.13 210.145 457.533 209.339 458.339L211.461 460.461ZM213.7 453.8V420.6H210.7V453.8H213.7ZM212.2 422.1H235.2V419.1H212.2V422.1ZM235.2 422.1C253.428 422.1 266.387 418.502 273.501 410.819L271.299 408.781C265.08 415.498 253.239 419.1 235.2 419.1V422.1ZM273.501 410.819C280.47 403.292 283.9 393.505 283.9 381.6H280.9C280.9 392.895 277.664 401.908 271.299 408.781L273.501 410.819ZM283.9 381.6V356H280.9V381.6H283.9ZM283.9 356C283.9 344.095 280.47 334.308 273.501 326.781L271.299 328.819C277.664 335.692 280.9 344.705 280.9 356H283.9ZM273.501 326.781C266.387 319.098 253.428 315.5 235.2 315.5V318.5C253.239 318.5 265.08 322.102 271.299 328.819L273.501 326.781ZM235.2 315.5H174V318.5H235.2V315.5ZM174 315.5C171.263 315.5 168.933 316.145 167.339 317.739L169.461 319.861C170.267 319.055 171.67 318.5 174 318.5V315.5ZM167.339 317.739C165.852 319.227 165.3 321.524 165.3 324.2H168.3C168.3 321.81 168.815 320.506 169.461 319.861L167.339 317.739ZM165.3 324.2V453.8H168.3V324.2H165.3ZM165.3 453.8C165.3 456.499 165.861 458.801 167.279 460.397L169.521 458.403C168.806 457.599 168.3 456.168 168.3 453.8H165.3ZM167.403 460.521C168.999 461.939 171.301 462.5 174 462.5V459.5C171.632 459.5 170.201 458.994 169.397 458.279L167.403 460.521ZM174 462.5H205V459.5H174V462.5ZM232.4 402.1H191.2V405.1H232.4V402.1ZM189.7 403.6V443H192.7V403.6H189.7ZM191.2 441.5H189.2V444.5H191.2V441.5ZM190.7 443V335H187.7V443H190.7ZM189.2 336.5H232.4V333.5H189.2V336.5ZM232.4 336.5C238.569 336.5 243.435 337.225 247.068 338.602L248.132 335.798C244.031 334.242 238.764 333.5 232.4 333.5V336.5ZM247.126 338.623C250.952 339.899 253.766 341.645 255.679 343.797L257.921 341.803C255.567 339.155 252.248 337.168 248.074 335.777L247.126 338.623ZM255.679 343.797C257.637 346 258.995 348.64 259.741 351.75L262.659 351.05C261.805 347.493 260.229 344.4 257.921 341.803L255.679 343.797ZM259.741 351.75C260.511 354.955 260.9 358.436 260.9 362.2H263.9C263.9 358.23 263.489 354.511 262.659 351.05L259.741 351.75ZM260.9 362.2V377H263.9V362.2H260.9ZM260.9 377C260.9 380.764 260.511 384.245 259.741 387.45L262.659 388.15C263.489 384.689 263.9 380.97 263.9 377H260.9ZM259.745 387.436C259.002 390.408 257.647 392.989 255.679 395.203L257.921 397.197C260.22 394.611 261.798 391.592 262.655 388.164L259.745 387.436ZM255.708 395.172C253.794 397.205 250.97 398.896 247.126 400.177L248.074 403.023C252.23 401.638 255.539 399.728 257.892 397.228L255.708 395.172ZM247.111 400.182C243.462 401.44 238.579 402.1 232.4 402.1V405.1C238.754 405.1 244.005 404.426 248.089 403.018L247.111 400.182ZM191.2 403.1H232.4V400.1H191.2V403.1ZM232.4 403.1C238.35 403.1 243.262 402.494 247.074 401.223L246.126 398.377C242.738 399.506 238.183 400.1 232.4 400.1V403.1ZM247.059 401.228C250.955 399.976 254.071 398.198 256.294 395.826L254.106 393.774C252.329 395.669 249.711 397.224 246.141 398.372L247.059 401.228ZM256.325 395.792C258.49 393.338 259.94 390.512 260.663 387.332L257.737 386.668C257.127 389.355 255.91 391.728 254.075 393.808L256.325 395.792ZM260.651 387.379C261.488 384.173 261.9 380.711 261.9 377H258.9C258.9 380.489 258.512 383.694 257.749 386.621L260.651 387.379ZM261.9 377V362.2H258.9V377H261.9ZM261.9 362.2C261.9 358.489 261.488 355.027 260.651 351.821L257.749 352.579C258.512 355.506 258.9 358.711 258.9 362.2H261.9ZM260.666 351.881C259.947 348.575 258.501 345.674 256.325 343.208L254.075 345.192C255.899 347.26 257.12 349.692 257.734 352.519L260.666 351.881ZM256.325 343.208C254.1 340.687 250.975 338.831 247.059 337.572L246.141 340.428C249.692 341.569 252.3 343.18 254.075 345.192L256.325 343.208ZM247.121 337.593C243.29 336.175 238.361 335.5 232.4 335.5V338.5C238.173 338.5 242.71 339.159 246.079 340.407L247.121 337.593ZM232.4 335.5H191.2V338.5H232.4V335.5ZM189.7 337V401.6H192.7V337H189.7ZM211.8 355.9H229.8V352.9H211.8V355.9ZM229.8 355.9C233.498 355.9 235.329 356.863 236.114 358.172L238.686 356.628C237.071 353.937 233.835 352.9 229.8 352.9V355.9ZM236.114 358.172C237.162 359.919 237.7 361.914 237.7 364.2H240.7C240.7 361.419 240.038 358.881 238.686 356.628L236.114 358.172ZM237.7 364.2V374.8H240.7V364.2H237.7ZM237.7 374.8C237.7 377.086 237.162 379.081 236.114 380.828L238.686 382.372C240.038 380.119 240.7 377.581 240.7 374.8H237.7ZM236.114 380.828C235.329 382.137 233.498 383.1 229.8 383.1V386.1C233.835 386.1 237.071 385.063 238.686 382.372L236.114 380.828ZM229.8 383.1H211.8V386.1H229.8V383.1ZM213.3 384.6V354.4H210.3V384.6H213.3ZM297.645 482.6L296.585 483.661L297.645 482.6ZM296.045 341.6L294.675 340.991L294.645 341.057L294.622 341.126L296.045 341.6ZM298.245 338.6L297.277 337.454L297.269 337.461L298.245 338.6ZM324.045 316.8L323.108 315.629L323.093 315.641L323.077 315.654L324.045 316.8ZM326.645 315.6L327.009 317.055L327.065 317.041L327.12 317.023L326.645 315.6ZM426.645 317.2L427.706 316.139L427.706 316.139L426.645 317.2ZM428.045 352.4L426.675 351.791L426.645 351.857L426.622 351.926L428.045 352.4ZM426.045 355.4L427.004 356.554L427.013 356.547L427.022 356.539L426.045 355.4ZM403.645 374L402.687 372.846L399.491 375.5H403.645V374ZM410.445 376.2L409.385 377.261L409.385 377.261L410.445 376.2ZM411.845 411.6L410.475 410.991L410.445 411.057L410.422 411.126L411.845 411.6ZM409.845 414.6L410.804 415.754L410.813 415.746L410.822 415.739L409.845 414.6ZM383.845 436.2L382.887 435.046L382.834 435.09L382.785 435.139L383.845 436.2ZM381.245 437.6L380.771 436.177L380.745 436.186L380.719 436.196L381.245 437.6ZM370.645 438.2V436.7H369.145V438.2H370.645ZM369.845 458.2L368.475 457.591L368.445 457.657L368.422 457.726L369.845 458.2ZM367.845 461.2L368.804 462.354L368.813 462.346L368.821 462.339L367.845 461.2ZM341.845 482.8L340.887 481.646L340.834 481.69L340.785 481.739L341.845 482.8ZM339.245 484.2L338.771 482.777L338.745 482.786L338.719 482.796L339.245 484.2ZM366.845 459.4L365.785 458.339L365.785 458.339L366.845 459.4ZM368.645 414.4V412.9H367.145V414.4H368.645ZM408.845 412.8L409.906 413.861L409.906 413.861L408.845 412.8ZM408.845 377.8L407.724 378.797L407.783 378.862L407.849 378.921L408.845 377.8ZM368.645 376H367.145V377.5H368.645V376ZM368.645 355.2V353.7H367.145V355.2H368.645ZM425.045 353.6L423.985 352.539L425.045 353.6ZM425.045 318.8L423.924 319.797L423.983 319.862L424.049 319.921L425.045 318.8ZM324.845 318.8L323.785 317.739L323.785 317.739L324.845 318.8ZM324.845 459.4L323.724 460.397L323.783 460.462L323.849 460.521L324.845 459.4ZM345.045 443H343.545V444.5H345.045V443ZM345.045 335V333.5H343.545V335H345.045ZM408.845 335H410.345V333.5H408.845V335ZM408.845 337V338.5H410.345V337H408.845ZM347.045 337V335.5H345.545V337H347.045ZM347.045 394.2H345.545V395.7H347.045V394.2ZM392.645 394.2H394.145V392.7H392.645V394.2ZM392.645 396.2V397.7H394.145V396.2H392.645ZM347.045 396.2V394.7H345.545V396.2H347.045ZM347.045 443V444.5H348.545V443H347.045ZM335.645 483.3H304.645V486.3H335.645V483.3ZM304.645 483.3C301.632 483.3 299.771 482.604 298.706 481.539L296.585 483.661C298.453 485.529 301.258 486.3 304.645 486.3V483.3ZM298.706 481.539C297.641 480.474 296.945 478.613 296.945 475.6H293.945C293.945 478.987 294.716 481.792 296.585 483.661L298.706 481.539ZM296.945 475.6V346H293.945V475.6H296.945ZM296.945 346C296.945 344.373 297.134 343.076 297.468 342.074L294.622 341.126C294.156 342.524 293.945 344.161 293.945 346H296.945ZM297.416 342.209C297.865 341.199 298.469 340.384 299.222 339.739L297.269 337.461C296.155 338.416 295.292 339.601 294.675 340.991L297.416 342.209ZM299.213 339.746L325.013 317.946L323.077 315.654L297.277 337.454L299.213 339.746ZM324.982 317.971C325.439 317.606 326.094 317.284 327.009 317.055L326.282 314.145C325.064 314.449 323.984 314.928 323.108 315.629L324.982 317.971ZM327.12 317.023C328.159 316.677 329.264 316.5 330.445 316.5V313.5C328.96 313.5 327.532 313.723 326.171 314.177L327.12 317.023ZM330.445 316.5H419.645V313.5H330.445V316.5ZM419.645 316.5C422.658 316.5 424.52 317.196 425.585 318.261L427.706 316.139C425.838 314.271 423.032 313.5 419.645 313.5V316.5ZM425.585 318.261C426.65 319.326 427.345 321.187 427.345 324.2H430.345C430.345 320.813 429.574 318.008 427.706 316.139L425.585 318.261ZM427.345 324.2V348H430.345V324.2H427.345ZM427.345 348C427.345 349.587 427.1 350.833 426.675 351.791L429.416 353.009C430.057 351.567 430.345 349.879 430.345 348H427.345ZM426.622 351.926C426.306 352.876 425.79 353.643 425.069 354.261L427.022 356.539C428.167 355.557 428.985 354.324 429.468 352.874L426.622 351.926ZM425.087 354.246L402.687 372.846L404.604 375.154L427.004 356.554L425.087 354.246ZM403.645 375.5C406.503 375.5 408.31 376.186 409.385 377.261L411.506 375.139C409.648 373.281 406.921 372.5 403.645 372.5V375.5ZM409.385 377.261C410.45 378.326 411.145 380.187 411.145 383.2H414.145C414.145 379.813 413.374 377.008 411.506 375.139L409.385 377.261ZM411.145 383.2V407.2H414.145V383.2H411.145ZM411.145 407.2C411.145 408.787 410.9 410.033 410.475 410.991L413.216 412.209C413.857 410.767 414.145 409.079 414.145 407.2H411.145ZM410.422 411.126C410.106 412.076 409.59 412.843 408.869 413.461L410.822 415.739C411.967 414.757 412.785 413.524 413.268 412.074L410.422 411.126ZM408.887 413.446L382.887 435.046L384.804 437.354L410.804 415.754L408.887 413.446ZM382.785 435.139C382.492 435.432 381.881 435.807 380.771 436.177L381.72 439.023C383.01 438.593 384.132 438.034 384.906 437.261L382.785 435.139ZM380.719 436.196C379.846 436.523 378.829 436.7 377.645 436.7V439.7C379.128 439.7 380.511 439.477 381.772 439.004L380.719 436.196ZM377.645 436.7H370.645V439.7H377.645V436.7ZM369.145 438.2V453.8H372.145V438.2H369.145ZM369.145 453.8C369.145 455.387 368.9 456.633 368.475 457.591L371.216 458.809C371.857 457.367 372.145 455.679 372.145 453.8H369.145ZM368.422 457.726C368.106 458.676 367.59 459.443 366.869 460.061L368.821 462.339C369.967 461.357 370.785 460.124 371.268 458.674L368.422 457.726ZM366.887 460.046L340.887 481.646L342.804 483.954L368.804 462.354L366.887 460.046ZM340.785 481.739C340.492 482.032 339.881 482.407 338.771 482.777L339.72 485.623C341.01 485.193 342.132 484.634 342.906 483.861L340.785 481.739ZM338.719 482.796C337.846 483.123 336.829 483.3 335.645 483.3V486.3C337.128 486.3 338.511 486.077 339.772 485.604L338.719 482.796ZM361.445 462.5C364.122 462.5 366.418 461.948 367.906 460.461L365.785 458.339C365.139 458.985 363.836 459.5 361.445 459.5V462.5ZM367.906 460.461C369.5 458.867 370.145 456.537 370.145 453.8H367.145C367.145 456.13 366.591 457.533 365.785 458.339L367.906 460.461ZM370.145 453.8V414.4H367.145V453.8H370.145ZM368.645 415.9H403.445V412.9H368.645V415.9ZM403.445 415.9C406.122 415.9 408.418 415.348 409.906 413.861L407.785 411.739C407.139 412.385 405.836 412.9 403.445 412.9V415.9ZM409.906 413.861C411.5 412.267 412.145 409.937 412.145 407.2H409.145C409.145 409.53 408.591 410.933 407.785 411.739L409.906 413.861ZM412.145 407.2V383.2H409.145V407.2H412.145ZM412.145 383.2C412.145 380.482 411.508 378.16 409.842 376.679L407.849 378.921C408.583 379.574 409.145 380.851 409.145 383.2H412.145ZM409.966 376.803C408.486 375.137 406.163 374.5 403.445 374.5V377.5C405.794 377.5 407.072 378.063 407.724 378.797L409.966 376.803ZM403.445 374.5H368.645V377.5H403.445V374.5ZM370.145 376V355.2H367.145V376H370.145ZM368.645 356.7H419.645V353.7H368.645V356.7ZM419.645 356.7C422.322 356.7 424.618 356.148 426.106 354.661L423.985 352.539C423.339 353.185 422.036 353.7 419.645 353.7V356.7ZM426.106 354.661C427.7 353.067 428.345 350.737 428.345 348H425.345C425.345 350.33 424.791 351.733 423.985 352.539L426.106 354.661ZM428.345 348V324.2H425.345V348H428.345ZM428.345 324.2C428.345 321.482 427.708 319.16 426.042 317.679L424.049 319.921C424.783 320.574 425.345 321.851 425.345 324.2H428.345ZM426.166 317.803C424.686 316.137 422.363 315.5 419.645 315.5V318.5C421.994 318.5 423.272 319.063 423.924 319.797L426.166 317.803ZM419.645 315.5H330.445V318.5H419.645V315.5ZM330.445 315.5C327.708 315.5 325.379 316.145 323.785 317.739L325.906 319.861C326.712 319.055 328.116 318.5 330.445 318.5V315.5ZM323.785 317.739C322.297 319.227 321.745 321.524 321.745 324.2H324.745C324.745 321.81 325.26 320.506 325.906 319.861L323.785 317.739ZM321.745 324.2V453.8H324.745V324.2H321.745ZM321.745 453.8C321.745 456.499 322.306 458.801 323.724 460.397L325.966 458.403C325.251 457.599 324.745 456.168 324.745 453.8H321.745ZM323.849 460.521C325.444 461.939 327.747 462.5 330.445 462.5V459.5C328.077 459.5 326.647 458.994 325.842 458.279L323.849 460.521ZM330.445 462.5H361.445V459.5H330.445V462.5ZM346.545 443V335H343.545V443H346.545ZM345.045 336.5H408.845V333.5H345.045V336.5ZM407.345 335V337H410.345V335H407.345ZM408.845 335.5H347.045V338.5H408.845V335.5ZM345.545 337V394.2H348.545V337H345.545ZM347.045 395.7H392.645V392.7H347.045V395.7ZM391.145 394.2V396.2H394.145V394.2H391.145ZM392.645 394.7H347.045V397.7H392.645V394.7ZM345.545 396.2V443H348.545V396.2H345.545ZM347.045 441.5H345.045V444.5H347.045V441.5ZM441.2 482.6L440.139 483.661L441.2 482.6ZM439.6 341.6L438.229 340.991L438.2 341.057L438.177 341.126L439.6 341.6ZM441.8 338.6L440.832 337.454L440.824 337.461L441.8 338.6ZM467.6 316.8L466.663 315.629L466.647 315.641L466.632 315.654L467.6 316.8ZM470.2 315.6L470.564 317.055L470.62 317.041L470.674 317.023L470.2 315.6ZM559 318L559.447 316.568L559.447 316.568L559 318ZM582 339.4L580.559 339.817L580.564 339.834L580.57 339.852L582 339.4ZM581.6 399.2L580.184 398.704L580.181 398.715L580.177 398.726L581.6 399.2ZM572.4 412.6L573.359 413.754L573.365 413.749L573.37 413.744L572.4 412.6ZM546.4 434.2L545.441 433.046L545.435 433.051L546.4 434.2ZM533.4 441.2L533.874 442.623L533.885 442.619L533.896 442.616L533.4 441.2ZM514.2 444.2L514.147 442.701L512.7 442.752V444.2H514.2ZM513.4 458.2L512.029 457.591L512 457.657L511.977 457.726L513.4 458.2ZM511.4 461.2L512.359 462.354L512.367 462.346L512.376 462.339L511.4 461.2ZM485.4 482.8L484.441 481.646L484.388 481.69L484.339 481.739L485.4 482.8ZM482.8 484.2L482.326 482.777L482.299 482.786L482.273 482.796L482.8 484.2ZM510.4 459.4L509.339 458.339L509.339 458.339L510.4 459.4ZM512.2 420.6V419.1H510.7V420.6H512.2ZM572.4 409.8L571.299 408.781L571.299 408.781L572.4 409.8ZM572.4 327.8L571.299 328.819L571.299 328.819L572.4 327.8ZM468.4 318.8L467.339 317.739L467.339 317.739L468.4 318.8ZM468.4 459.4L467.279 460.397L467.338 460.462L467.403 460.521L468.4 459.4ZM491.2 403.6V402.1H489.7V403.6H491.2ZM491.2 443V444.5H492.7V443H491.2ZM489.2 443H487.7V444.5H489.2V443ZM489.2 335V333.5H487.7V335H489.2ZM547.6 337.2L547.068 338.602L547.097 338.613L547.126 338.623L547.6 337.2ZM556.8 342.8L555.679 343.797L555.679 343.797L556.8 342.8ZM561.2 351.4L559.741 351.75L559.741 351.75L561.2 351.4ZM561.2 387.8L562.655 388.164L562.657 388.157L562.659 388.15L561.2 387.8ZM556.8 396.2L557.892 397.228L557.907 397.213L557.921 397.197L556.8 396.2ZM547.6 401.6L547.126 400.177L547.118 400.179L547.111 400.182L547.6 401.6ZM491.2 401.6H489.7V403.1H491.2V401.6ZM546.6 399.8L546.141 398.372L546.133 398.374L546.126 398.377L546.6 399.8ZM555.2 394.8L556.294 395.826L556.31 395.809L556.325 395.792L555.2 394.8ZM559.2 387L557.749 386.621L557.743 386.644L557.737 386.668L559.2 387ZM559.2 352.2L557.734 352.519L557.741 352.549L557.749 352.579L559.2 352.2ZM555.2 344.2L556.325 343.208L556.325 343.208L555.2 344.2ZM546.6 339L546.079 340.407L546.11 340.418L546.141 340.428L546.6 339ZM491.2 337V335.5H489.7V337H491.2ZM511.8 354.4V352.9H510.3V354.4H511.8ZM537.4 357.4L536.114 358.172L536.114 358.172L537.4 357.4ZM537.4 381.6L538.686 382.372L538.686 382.372L537.4 381.6ZM511.8 384.6H510.3V386.1H511.8V384.6ZM479.2 483.3H448.2V486.3H479.2V483.3ZM448.2 483.3C445.187 483.3 443.326 482.604 442.261 481.539L440.139 483.661C442.008 485.529 444.813 486.3 448.2 486.3V483.3ZM442.261 481.539C441.196 480.474 440.5 478.613 440.5 475.6H437.5C437.5 478.987 438.271 481.792 440.139 483.661L442.261 481.539ZM440.5 475.6V346H437.5V475.6H440.5ZM440.5 346C440.5 344.373 440.689 343.076 441.023 342.074L438.177 341.126C437.711 342.524 437.5 344.161 437.5 346H440.5ZM440.971 342.209C441.42 341.199 442.023 340.384 442.776 339.739L440.824 337.461C439.71 338.416 438.847 339.601 438.229 340.991L440.971 342.209ZM442.768 339.746L468.568 317.946L466.632 315.654L440.832 337.454L442.768 339.746ZM468.537 317.971C468.994 317.606 469.648 317.284 470.564 317.055L469.836 314.145C468.618 314.449 467.539 314.928 466.663 315.629L468.537 317.971ZM470.674 317.023C471.713 316.677 472.819 316.5 474 316.5V313.5C472.514 313.5 471.087 313.723 469.726 314.177L470.674 317.023ZM474 316.5H535.2V313.5H474V316.5ZM535.2 316.5C544.572 316.5 552.343 317.491 558.553 319.432L559.447 316.568C552.857 314.509 544.761 313.5 535.2 313.5V316.5ZM558.553 319.432C564.793 321.382 569.635 324.082 573.159 327.48L575.241 325.32C571.298 321.518 566.007 318.618 559.447 316.568L558.553 319.432ZM573.159 327.48C576.7 330.894 579.164 334.998 580.559 339.817L583.441 338.983C581.903 333.669 579.167 329.106 575.241 325.32L573.159 327.48ZM580.57 339.852C582.118 344.755 582.9 350.134 582.9 356H585.9C585.9 349.866 585.082 344.179 583.43 338.948L580.57 339.852ZM582.9 356V381.6H585.9V356H582.9ZM582.9 381.6C582.9 387.853 581.988 393.55 580.184 398.704L583.016 399.696C584.945 394.183 585.9 388.147 585.9 381.6H582.9ZM580.177 398.726C578.535 403.651 575.632 407.891 571.43 411.456L573.37 413.744C577.968 409.843 581.198 405.149 583.023 399.674L580.177 398.726ZM571.441 411.446L545.441 433.046L547.359 435.354L573.359 413.754L571.441 411.446ZM545.435 433.051C542.275 435.706 538.115 437.961 532.904 439.784L533.896 442.616C539.352 440.706 543.858 438.294 547.365 435.349L545.435 433.051ZM532.926 439.777C527.903 441.451 521.655 442.437 514.147 442.701L514.253 445.699C521.945 445.429 528.497 444.416 533.874 442.623L532.926 439.777ZM512.7 444.2V453.8H515.7V444.2H512.7ZM512.7 453.8C512.7 455.387 512.455 456.633 512.029 457.591L514.771 458.809C515.412 457.367 515.7 455.679 515.7 453.8H512.7ZM511.977 457.726C511.66 458.676 511.145 459.443 510.424 460.061L512.376 462.339C513.522 461.357 514.34 460.124 514.823 458.674L511.977 457.726ZM510.441 460.046L484.441 481.646L486.359 483.954L512.359 462.354L510.441 460.046ZM484.339 481.739C484.046 482.032 483.436 482.407 482.326 482.777L483.274 485.623C484.564 485.193 485.687 484.634 486.461 483.861L484.339 481.739ZM482.273 482.796C481.401 483.123 480.384 483.3 479.2 483.3V486.3C480.683 486.3 482.066 486.077 483.327 485.604L482.273 482.796ZM505 462.5C507.676 462.5 509.973 461.948 511.461 460.461L509.339 458.339C508.694 458.985 507.39 459.5 505 459.5V462.5ZM511.461 460.461C513.055 458.867 513.7 456.537 513.7 453.8H510.7C510.7 456.13 510.145 457.533 509.339 458.339L511.461 460.461ZM513.7 453.8V420.6H510.7V453.8H513.7ZM512.2 422.1H535.2V419.1H512.2V422.1ZM535.2 422.1C553.428 422.1 566.387 418.502 573.501 410.819L571.299 408.781C565.08 415.498 553.239 419.1 535.2 419.1V422.1ZM573.501 410.819C580.47 403.292 583.9 393.505 583.9 381.6H580.9C580.9 392.895 577.664 401.908 571.299 408.781L573.501 410.819ZM583.9 381.6V356H580.9V381.6H583.9ZM583.9 356C583.9 344.095 580.47 334.308 573.501 326.781L571.299 328.819C577.664 335.692 580.9 344.705 580.9 356H583.9ZM573.501 326.781C566.387 319.098 553.428 315.5 535.2 315.5V318.5C553.239 318.5 565.08 322.102 571.299 328.819L573.501 326.781ZM535.2 315.5H474V318.5H535.2V315.5ZM474 315.5C471.263 315.5 468.933 316.145 467.339 317.739L469.461 319.861C470.267 319.055 471.67 318.5 474 318.5V315.5ZM467.339 317.739C465.852 319.227 465.3 321.524 465.3 324.2H468.3C468.3 321.81 468.815 320.506 469.461 319.861L467.339 317.739ZM465.3 324.2V453.8H468.3V324.2H465.3ZM465.3 453.8C465.3 456.499 465.861 458.801 467.279 460.397L469.521 458.403C468.806 457.599 468.3 456.168 468.3 453.8H465.3ZM467.403 460.521C468.999 461.939 471.301 462.5 474 462.5V459.5C471.632 459.5 470.201 458.994 469.397 458.279L467.403 460.521ZM474 462.5H505V459.5H474V462.5ZM532.4 402.1H491.2V405.1H532.4V402.1ZM489.7 403.6V443H492.7V403.6H489.7ZM491.2 441.5H489.2V444.5H491.2V441.5ZM490.7 443V335H487.7V443H490.7ZM489.2 336.5H532.4V333.5H489.2V336.5ZM532.4 336.5C538.569 336.5 543.435 337.225 547.068 338.602L548.132 335.798C544.031 334.242 538.764 333.5 532.4 333.5V336.5ZM547.126 338.623C550.952 339.899 553.766 341.645 555.679 343.797L557.921 341.803C555.567 339.155 552.248 337.168 548.074 335.777L547.126 338.623ZM555.679 343.797C557.637 346 558.995 348.64 559.741 351.75L562.659 351.05C561.805 347.493 560.229 344.4 557.921 341.803L555.679 343.797ZM559.741 351.75C560.511 354.955 560.9 358.436 560.9 362.2H563.9C563.9 358.23 563.489 354.511 562.659 351.05L559.741 351.75ZM560.9 362.2V377H563.9V362.2H560.9ZM560.9 377C560.9 380.764 560.511 384.245 559.741 387.45L562.659 388.15C563.489 384.689 563.9 380.97 563.9 377H560.9ZM559.745 387.436C559.002 390.408 557.647 392.989 555.679 395.203L557.921 397.197C560.22 394.611 561.798 391.592 562.655 388.164L559.745 387.436ZM555.708 395.172C553.794 397.205 550.97 398.896 547.126 400.177L548.074 403.023C552.23 401.638 555.539 399.728 557.892 397.228L555.708 395.172ZM547.111 400.182C543.462 401.44 538.579 402.1 532.4 402.1V405.1C538.754 405.1 544.005 404.426 548.089 403.018L547.111 400.182ZM491.2 403.1H532.4V400.1H491.2V403.1ZM532.4 403.1C538.35 403.1 543.262 402.494 547.074 401.223L546.126 398.377C542.738 399.506 538.183 400.1 532.4 400.1V403.1ZM547.059 401.228C550.955 399.976 554.071 398.198 556.294 395.826L554.106 393.774C552.329 395.669 549.711 397.224 546.141 398.372L547.059 401.228ZM556.325 395.792C558.49 393.338 559.94 390.512 560.663 387.332L557.737 386.668C557.127 389.355 555.91 391.728 554.075 393.808L556.325 395.792ZM560.651 387.379C561.488 384.173 561.9 380.711 561.9 377H558.9C558.9 380.489 558.512 383.694 557.749 386.621L560.651 387.379ZM561.9 377V362.2H558.9V377H561.9ZM561.9 362.2C561.9 358.489 561.488 355.027 560.651 351.821L557.749 352.579C558.512 355.506 558.9 358.711 558.9 362.2H561.9ZM560.666 351.881C559.947 348.575 558.501 345.674 556.325 343.208L554.075 345.192C555.899 347.26 557.12 349.692 557.734 352.519L560.666 351.881ZM556.325 343.208C554.1 340.687 550.975 338.831 547.059 337.572L546.141 340.428C549.692 341.569 552.3 343.18 554.075 345.192L556.325 343.208ZM547.121 337.593C543.29 336.175 538.361 335.5 532.4 335.5V338.5C538.173 338.5 542.71 339.159 546.079 340.407L547.121 337.593ZM532.4 335.5H491.2V338.5H532.4V335.5ZM489.7 337V401.6H492.7V337H489.7ZM511.8 355.9H529.8V352.9H511.8V355.9ZM529.8 355.9C533.498 355.9 535.329 356.863 536.114 358.172L538.686 356.628C537.071 353.937 533.835 352.9 529.8 352.9V355.9ZM536.114 358.172C537.162 359.919 537.7 361.914 537.7 364.2H540.7C540.7 361.419 540.038 358.881 538.686 356.628L536.114 358.172ZM537.7 364.2V374.8H540.7V364.2H537.7ZM537.7 374.8C537.7 377.086 537.162 379.081 536.114 380.828L538.686 382.372C540.038 380.119 540.7 377.581 540.7 374.8H537.7ZM536.114 380.828C535.329 382.137 533.498 383.1 529.8 383.1V386.1C533.835 386.1 537.071 385.063 538.686 382.372L536.114 380.828ZM529.8 383.1H511.8V386.1H529.8V383.1ZM513.3 384.6V354.4H510.3V384.6H513.3Z' fill='black' fill-opacity='0.15'/%3e%3c/svg%3e ");
      }

      .gallerythumbnailimage {
        aspect-ratio: 1 / 1;
        width: 100%;
        
      }

     .tokeninfos {
      display : flex;
        flex-direction: row;
        align-content: flex-start;
        justify-content: flex-start;
        align-items: flex-start;
        flex-wrap: wrap;
      }

      .tokeninfos h3{
        margin-left: 2em;
      }

      .aboutpage h5{
        color: var(--light-text-color);
        font-size: 1.5em;
        font-weight: 700;
        margin-bottom: 0em;
        margin-left:0.5em;

      }
      .aboutpage ul{
        font-weight: 500;
        background-color: var(--background-color);
        color: var(--inactive-button-text-color);
        box-shadow: var(--colored-offset);
        margin-top: -2em;
        margin-bottom: 2.5em;
        padding-top: 2.3em;
        padding-bottom: 1em;
      }

    `

}

///////////////////////////////// Navigation Components /////////////////////////////////////////////

export class TabButtons extends MiniPfp {

  static properties = {
    pathname: { attribute: false },
    tabs: { attribute: false },
  }

  constructor() {
    super()
    this.updateLocationPathname = this.updateLocationPathname.bind(this) // because in event callback this is bound to currentTarget!
    this.pathname = router.location.pathname
    this.updateGalleryWaiting = this.updateGalleryWaiting.bind(this)
    this.tabs = [
      {
        route: "/create",
        text: "Create your miniPFPs",
        id: "tocreate",
        isWaiting: false
      },
      {
        route: "/yours",
        text: "Your miniPFPs",
        id: "toyours",
        isWaiting: false
      },
      {
        route: "/buy",
        text: "Explore miniPFPs",
        id: "tobuy",
        isWaiting: true
      },
      {
        route: "/about",
        text: "?",
        id: "toabout",
        isWaiting: false
      },
    ]
  }

  updateLocationPathname(event) {
    this.pathname = router.location.pathname
  }

  updateGalleryWaiting(event) {

    console.log("listening to gallery-status")

    if (event.data.type == "gallery-status" && (event.data.length > 128 || event.data.allFetched == true)) {

      const waitingTabIndex = this.tabs
        .findIndex(
          (tab) => {
            return tab.id == "tobuy"
          }
        )

      this.tabs[waitingTabIndex].isWaiting = false

      this.tabs = [...this.tabs] // replacing the whole array to make lit component react
    }

    if (event.data.type == "gallery-status" && event.data.allFetched == true) {
      self.removeEventListener(
        "message",
        this.updateGalleryWaiting
      )
    }
  }

  connectedCallback() {
    super.connectedCallback()

    // the tabs will change style according to the current pathname
    self.addEventListener(
      'vaadin-router-location-changed',
      this.updateLocationPathname
    )

    self.addEventListener(
      "message",
      this.updateGalleryWaiting
    )
  }

  disconnectedCallback() {
    super.disconnectedCallback()

    self.removeEventListener(
      'vaadin-router-location-changed',
      this.updateLocationPathname
    )

    self.removeEventListener(
      "message",
      this.updateGalleryWaiting
    )
  }


  render() {

    let renderedTabs = []

    for (let tab of this.tabs) {

      // use clasmap based on this.location
      // class="tab selected" if current route
      // class="tab selectable"  if not

      const isCurrentRoute = this.pathname.startsWith(tab.route)

      tab.classes = { tab: true, selected: isCurrentRoute, selectable: !isCurrentRoute, waiting: tab.isWaiting };

      renderedTabs.push(
        html`  
        <a href="${tab.route}" id="${tab.id}" class="class=${classMap(tab.classes)}">${tab.text}</a>
        `
      )
    }

    return renderedTabs
  }

}
customElements.define('tab-buttons', TabButtons)

///////////////////////////////// Create Components /////////////////////////////////////////////

export class CreatePage extends MiniPfp {

  static properties = {
    MAX_LAYERS: { attribute: false },
    MAX_ATTRIBUTES: { attribute: false },
    MAX_PIXEL_SIZE: { attribute: false },
    layers: { attribute: false },
    seriesName: { attribute: false },
    seriesDescription: { attribute: false },

    isCompleteNaming: { attribute: false },
    areImageFilesComplete: { attribute: false },

    isMetadataUploaded: { attribute: false },
    directoryCid: { attribute: false },
    totalTokens: { attribute: false },
  }

  constructor() {
    super();
    this.addEventListener('series-name-change', this.handleNameChange, false)
    this.addEventListener('series-description-change', this.handleNameChange, false)
    this.addEventListener('layer-name-change', this.handleNameChange, false)
    this.addEventListener('attribute-name-change', this.handleNameChange, false)

    this.emitRequestRandomPreview = this.emitRequestRandomPreview.bind(this)
    this.uploadAllClicked = this.uploadAllButtonClicked.bind(this)

    this.addEventListener('file-drop', this.emitRequestRandomPreview)

    this.MAX_LAYERS = 4
    this.MAX_ATTRIBUTES = 4
    this.MAX_PIXEL_SIZE = 2048
    this.layers = []
    this.seriesName = ""
    this.seriesDescription = ""

    this.isCompleteNaming = false
    this.areImageFilesComplete = false

    this.createLayersData()

    this.canvas = document.createElement("canvas")
    this.canvas.id = "previewcanvas"

    let CTX = this.canvas.getContext("2d")

    CTX.imageSmoothingEnabled = false

    CTX.canvas.width = this.MAX_PIXEL_SIZE
    CTX.canvas.height = this.MAX_PIXEL_SIZE

    CTX.fillStyle = "hotpink"
    CTX.fillRect(0, 0, CTX.canvas.width, CTX.canvas.height)
    CTX.font = `${(CTX.canvas.width / 13)}px sans-serif`
    CTX.fillStyle = "white"
    CTX.textAlign = "center"
    CTX.fillText("PFP preview canvas", CTX.canvas.width / 2, CTX.canvas.height / 2)

    this.canvas.addEventListener('click', this.emitRequestRandomPreview)
  }

  layerNameKey(layerIndex) {
    return `layer${layerIndex}Name`
  }

  attributeNameKey(layerIndex, attributeIndex) {
    return `layer${layerIndex}attribute${attributeIndex}Name`
  }


  async createLayersData() {

    let layersStore = localforage.createInstance({
      name: "layers",
      storeName: "names",
      description: "miniPFP layers names"
    })

    try {
      this.seriesName = await layersStore.getItem("seriesname")
    } catch (err) {
      console.log(err);
    }

    try {
      this.seriesDescription = await layersStore.getItem("seriesdescription")
    } catch (err) {
      console.log(err);
    }


    // Create the layers list

    //[ { userFacingName, 
    //  layerIndex, 
    //  attributes : [ {attributeIndex, id, image, userFacingName, file}, ...] }, ...]

    const MAX_LAYERS = this.MAX_LAYERS
    const MAX_ATTRIBUTES = this.MAX_ATTRIBUTES

    let layers = []

    for (let layerIndex = 0; layerIndex < MAX_LAYERS; layerIndex++) {

      let layerUserFacingName

      try {
        layerUserFacingName = await layersStore.getItem(this.layerNameKey(layerIndex))
      } catch (err) {
        console.log(err);
      }

      layers.push(
        {
          userFacingName: layerUserFacingName,
          layerIndex: layerIndex,
          attributes: []
        }
      )

      for (let attributeIndex = 0; attributeIndex < MAX_ATTRIBUTES; attributeIndex++) {

        let attributeUserFacingName

        try {
          attributeUserFacingName = await layersStore.getItem(this.attributeNameKey(layerIndex, attributeIndex))
        } catch (err) {
          console.log(err);
        }

        let attribute = {
          attributeIndex: attributeIndex,
          id: `layer${layerIndex}attribute${attributeIndex}`,
          image: undefined,
          userFacingName: attributeUserFacingName,
          file: undefined,
        }

        layers[layerIndex].attributes.push(attribute)

      }
    }
    this.layers = layers // change inside an object are not detected by Lit
  }

  checkNaming() {

    this.isCompleteNaming = false

    if (!this.seriesName) return false

    if (!this.seriesDescription) return false

    for (let layer of this.layers) {

      if (!layer.userFacingName) return false

      for (let attribute of layer.attributes) {

        if (!attribute.userFacingName) return false

      }
    }

    this.isCompleteNaming = true

    console.log("naming check to true")
    return true
  }

  handleNameChange(event) {

    // console.log(event.type, event.detail)

    let layersStore = localforage.createInstance({
      name: "layers",
      storeName: "names",
      description: "miniPFP layers names"
    })


    if (event.type === "series-name-change") {

      this.seriesName = event.detail.name

      layersStore.setItem("seriesname", this.seriesName)
    }

    if (event.type === "series-description-change") {

      this.seriesDescription = event.detail.description

      layersStore.setItem("seriesdescription", this.seriesDescription)
    }

    if (event.type === "layer-name-change") {

      const key = this.layerNameKey(event.detail.layerIndex)

      layersStore.setItem(key, event.detail.name)

      this.layers[event.detail.layerIndex].userFacingName = event.detail.name

      this.layers = [...this.layers] // making the component aware of the changes

    }

    if (event.type === "attribute-name-change") {

      const key = this.attributeNameKey(event.detail.layerIndex, event.detail.attributeIndex)

      layersStore.setItem(key, event.detail.name)

      this.layers[event.detail.layerIndex].attributes[event.detail.attributeIndex].userFacingName = event.detail.name

      this.layers = [...this.layers] // making the component aware of the changes
    }

    this.checkNaming()

  }

  handleImageFilesEvents(event) {
    if (event.type == "image-files-complete") this.areImageFilesComplete = true

    if (event.type == "image-files-not-complete") this.areImageFilesComplete = false
  }

  get canvasContext() {
    return this.renderRoot?.getElementById("previewcanvas")?.getContext("2d")
  }

  get uploadallButtonElement() {
    return this.renderRoot?.getElementById("uploadall")
  }

  emitRequestRandomPreview(event) {

    let myEvent = new CustomEvent('request-random-preview', {
      detail: {
        canvascontext: this.canvasContext,
        maxlayers: this.MAX_LAYERS,
        maxattributes: this.MAX_ATTRIBUTES,
        maxpixelsize: this.MAX_PIXEL_SIZE
      },
      bubbles: true,
      composed: true
    });
    this.dispatchEvent(myEvent);
  }

  uploadAllButtonClicked(event) {

    this.canvas.removeEventListener('click', this.emitRequestRandomPreview)

    event.currentTarget.removeEventListener('click', this.uploadAllButtonClicked)

    event.currentTarget.classList.add('waiting')

    let myEvent = new CustomEvent('request-upload-all-pfps', {
      detail: {
        canvas: this.canvas,
        maxLayers: this.MAX_LAYERS,
        maxAttributes: this.MAX_ATTRIBUTES,
        layers: this.layers,
        seriesName: this.seriesName,
        seriesDescription: this.seriesDescription
      },
      bubbles: true,
      composed: true
    });
    this.dispatchEvent(myEvent);
  }




  render() {

    // set up PFP preview canvas

    let uploadallButton

    if (this.isMetadataUploaded) {
      uploadallButton = html`<button id="uploadall" class="inactive">Uploaded</button>`
    }
    else if (this.checkNaming() && this.areImageFilesComplete) {
      uploadallButton = html`<button id="uploadall" @click=${this.uploadAllButtonClicked}>Upload all 256 miniPFP to IPFS</button>`
    }
    else {
      uploadallButton = html`<button id="uploadall" class="inactive">Upload all 256 miniPFP to IPFS</button>`
    }

    let mintButton

    if (this.isMetadataUploaded) {
      mintButton = html`
        <mint-button id="mintbuttoncomponent" .directoryCid=${this.directoryCid} .totalTokens=${this.totalTokens}
          .seriesName=${this.seriesName} .status=${{ waiting: false, done: false, failed: false }}></mint-button>`
    }

    return html`
      <layers-form .layers=${this.layers} .seriesName=${this.seriesName} .seriesDescription=${this.seriesDescription}
        @image-files-complete=${this.handleImageFilesEvents} @image-files-not-complete=${this.handleImageFilesEvents}>
      </layers-form>
      ${this.canvas}
      ${uploadallButton}
      ${mintButton}
    `
  }
}

customElements.define('create-page', CreatePage)

export class LayersForm extends MiniPfp {

  static properties = {
    layers: { attribute: false },
    seriesName: { attribute: false },
    seriesDescription: { attribute: false },
    areImageFilesComplete: { attribute: false },
  }

  get formElement() { return this.renderRoot?.getElementById("layers-form") }

  constructor() {
    super();
    this.handleFiles = this.handleFiles.bind(this)
    this.areImageFilesComplete = false
  }

  connectedCallback() {
    super.connectedCallback()

    const dropArea = document.getElementsByTagName('body')[0]
    dropArea.addEventListener('drop', this.handleFiles, false)
  }

  disconnectedCallback() {
    super.disconnectedCallback()

    const dropArea = document.getElementsByTagName('body')[0]
    dropArea.removeEventListener('drop', this.handleFiles)
  }

  handleFiles(event) {

    let dt = event.dataTransfer
    let files = dt.files

    for (var i = 0; i < files.length; i++) {
      var file = files[i];
      var imageType = /^image\//;

      if (!imageType.test(file.type)) {
        continue;
      }

      // attach to input field if named right

      // for consistency with UI, artists name layer[1-4]trait[1-4]: 1-indexed, and trait instead of attribute

      // remove extension
      let fileName = file.name.substring(0, file.name.lastIndexOf('.'))
      // replace 'trait' by 'attribute'
      fileName = fileName.replace("trait", "attribute")
      // decrement indexes
      fileName = fileName.replace(/\d+/g, function (match) {
        return parseInt(match) - 1;
      });

      // console.log(file.name.substring(0, file.name.lastIndexOf('.')), fileName)

      const inputFileElement = this.renderRoot?.getElementById(fileName + "File")

      if (inputFileElement) {

        setFile(inputFileElement, file)

        inputFileElement.dispatchEvent(new Event('change'))

      }
    }

    let myEvent = new CustomEvent('file-drop', {
      bubbles: true,
      composed: true
    });
    this.dispatchEvent(myEvent)

    // https://stackoverflow.com/questions/5632629/how-to-change-a-file-inputs-filelist-programmatically
    // beware not in IE, and only since version 14.1 in Safari.

    function setFile(input, file) {
      const dataTransfer = new DataTransfer()
      dataTransfer.items.add(file)
      input.files = dataTransfer.files
    }
  }

  emitLayerNameChange(event) {

    event.currentTarget.value = event.currentTarget.value.trim()

    let myEvent = new CustomEvent('layer-name-change', {
      detail: {
        layerIndex: event.currentTarget.dataset.layerIndex,
        name: event.currentTarget.value,
      },
      bubbles: true,
      composed: true
    });
    this.dispatchEvent(myEvent);
  }

  emitAttributeNameChange(event) {

    event.currentTarget.value = event.currentTarget.value.trim()

    let myEvent = new CustomEvent('attribute-name-change', {
      detail: {
        layerIndex: event.currentTarget.dataset.layerIndex,
        attributeIndex: event.currentTarget.dataset.attributeIndex,
        name: event.currentTarget.value,
      },
      bubbles: true,
      composed: true
    });
    this.dispatchEvent(myEvent);
  }

  emitImageFilesComplete() {
    let myEvent = new CustomEvent('image-files-complete', {
      bubbles: true,
      composed: true
    });
    this.dispatchEvent(myEvent);
  }

  emitImageFilesNotComplete() {
    let myEvent = new CustomEvent('image-files-not-complete', {
      bubbles: true,
      composed: true
    });
    this.dispatchEvent(myEvent);
  }

  showThumbnail(event) {

    const previewElement = event.currentTarget

    if (previewElement.nextSibling
      && previewElement.nextSibling.tagName == "IMG"
      && previewElement.nextSibling.classList.contains("layer-thumbnail")
    ) {
      previewElement.nextSibling.remove()
    }

    if (previewElement.files.length > 0) {

      const file = previewElement.files[0]

      var img = document.createElement("img")
      img.classList.add("layer-thumbnail")

      previewElement.after(img)

      var reader = new FileReader()

      reader.onload = (
        function (aImg) {
          return function (e) { aImg.src = e.target.result }
        }
      )(img)

      reader.readAsDataURL(file)
    }

    this.checkImageFiles()

  }

  checkImageFiles() {

    this.areImageFilesComplete = false

    const inputFileElements = this.renderRoot?.querySelectorAll("input[type=file]")

    // full selector for a file:
    // document.querySelector("#contentcontainer > create-page").shadowRoot.querySelector("layers-form").shadowRoot.querySelectorAll("input[type=file]")[0].files[0]

    for (let input of inputFileElements) {

      if (input.files.length == 0
        || input.files[0].size == 0
        || !input.files[0].type.includes("image")
      ) {
        this.emitImageFilesNotComplete()
        return false
      }
    }

    this.areImageFilesComplete = true

    this.emitImageFilesComplete()

    return true
  }

  render() {

    const layerExamples = ["Background", "Character", "Eyes", "Hair"]

    const attributeExamples = [
      ["City", "Country", "Beach", "Space"],
      ["Witch", "Demon", "Monster", "Fairy"],
      ["Dark", "Red", "Violet", "Robot"],
      ["Blue", "White", "Black", "Fire"]
    ]

    const layerContainerTemplates = [];

    for (let layer of this.layers) {

      const thisLayerIndex = layer.layerIndex
      const thisLayerName = "layer" + thisLayerIndex
      const thislayerUserFacingName = layer.userFacingName

      const layerNameAndInput = html`
            <label for="${thisLayerName}Name" class="layernamelabel">What does layer ${thisLayerIndex + 1} represent?</label>
            <input type="text" id="${thisLayerName}Name" name="${thisLayerName}Name" size="20"
              placeholder="${layerExamples[thisLayerIndex]}" required="" class="layernameinput" style="cursor: auto;"
              autocomplete="layer" data-layer-index="${thisLayerIndex}" value=${thislayerUserFacingName}
              @change=${this.emitLayerNameChange}>
                    `

      let attributesTemplates = [layerNameAndInput]

      for (let attribute of layer.attributes) {

        const genericTextLabel = html` 
              Image for trait ${attribute.attributeIndex + 1} of layer ${layer.layerIndex + 1}
        `
        const customTextLabel = html` 
              Image for trait ${attribute.attributeIndex + 1} of ${layer.userFacingName}
            `

        const attributesTemplate = html`
                
                <label for="${attribute.id}File" class="filelabel">
                
                  ${layer.userFacingName ? customTextLabel : genericTextLabel}
                
                </label>
                
                <input type="file" name="${attribute.id}File" id="${attribute.id}File" required="" @change=${this.showThumbnail}>
                
                <label for="${attribute.id}Name" class="attributelabel">
                
                  Name trait ${attribute.attributeIndex + 1} of
                  ${layer.userFacingName ? layer.userFacingName : html`the layer`}
                
                </label>
                
                <input type="text" id="${attribute.id}Name" name="${attribute.id}Name" required="" size="20"
                  placeholder="${attributeExamples[layer.layerIndex][attribute.attributeIndex]}" required="" class="attributeinput"
                  autocomplete="trait" data-layer-index="${layer.layerIndex}" data-attribute-index="${attribute.attributeIndex}"
                  value=${attribute.userFacingName} @change=${this.emitAttributeNameChange}>
                      `

        attributesTemplates.push(attributesTemplate)
      }

      const layerContainerTemplate = html`<div class="layercontainer"> ${attributesTemplates} </div>`

      layerContainerTemplates.push(html`${layerContainerTemplate}`)

    }

    return html`
        <form action="" method="get" id="layers-form">
          <series-name seriesname=${this.seriesName}></series-name>
          <series-description seriesdescription=${this.seriesDescription}></series-description>
          ${layerContainerTemplates}
        </form>
            `
  }
}

customElements.define('layers-form', LayersForm)

export class SeriesName extends MiniPfp {

  static properties = {
    seriesName: {},
  }

  constructor() {
    super();
  }

  get input() {
    return this.renderRoot?.querySelector('input') ?? null;
  }

  emitSeriesNameChange(event) {

    event.currentTarget.value = event.currentTarget.value.trim()

    let myEvent = new CustomEvent('series-name-change', {
      detail: {
        name: event.currentTarget.value,
      },
      bubbles: true,
      composed: true
    });
    this.dispatchEvent(myEvent);
  }

  render() {

    return html`

                <label for="series" class="seriesnamelabel">What is the name of this collection ?</label>
                
                <input type="text" id="seriesName" name="series" size="20" placeholder="Fantasy Team" required=""
                  class="seriesnameinput" value=${this.seriesName} @change=${this.emitSeriesNameChange}>

                        `
  }

}
customElements.define('series-name', SeriesName)


export class seriesDescription extends MiniPfp {

  static properties = {
    seriesDescription: {},
  }

  constructor() {
    super();
  }

  get input() {
    return this.renderRoot?.querySelector('input') ?? null;
  }

  emitSeriesDescriptionChange(event) {

    event.currentTarget.value = stripHtml(event.currentTarget.value).result

    let myEvent = new CustomEvent('series-description-change', {
      detail: {
        description: event.currentTarget.value,
      },
      bubbles: true,
      composed: true
    });
    this.dispatchEvent(myEvent);
  }

  render() {

    return html`

                <label for="description" class="seriesdescriptionlabel">Description for the whole collection</label>
                
                <textarea id="seriesdescription" name="description" cols="80" rows="7" maxlength="560"
                  placeholder="A collection of magic creatures, hand-painted with watercolor" required="" class="seriesdescriptioninput"
                  @change=${this.emitSeriesDescriptionChange}>${this.seriesDescription}</textarea>
                        `
  }

}
customElements.define('series-description', seriesDescription)

export class MintButton extends MiniPfp {

  static properties = {
    totalTokens: { attribute: false },
    seriesName: { attribute: false },
    status: { attribute: false },
  }

  constructor() {
    super();
    this.status = { waiting: false, done: false, failed: false }
    this.handleMintEvents = this.handleMintEvents.bind(this)
  }

  get button() {
    return this.renderRoot?.querySelector('button') ?? null;
  }

  connectedCallback() {
    super.connectedCallback()

    self.addEventListener(
      'mint-applied',
      this.handleMintEvents)

    self.addEventListener(
      'mint-failed',
      this.handleMintEvents)
  }

  disconnectedCallback() {
    super.disconnectedCallback()

    self.removeEventListener(
      'mint-applied',
      this.handleMintEvents)

    self.removeEventListener(
      'mint-failed',
      this.handleMintEvents)

  }

  mintButtonClicked(event) {

    this.status = { waiting: true, done: false, failed: false }

    let myEvent = new CustomEvent('request-mint', {
      detail: {
        directoryCid: this.directoryCid,
        totalTokens: this.totalTokens
      },
      bubbles: true,
      composed: true
    });
    this.dispatchEvent(myEvent);
  }

  handleMintEvents(event) {

    console.log(event.type)

    if (event.type == 'mint-applied') this.status = { waiting: false, done: true, failed: false }
    if (event.type == 'mint-failed') this.status = { waiting: false, done: false, failed: true }
  }


  render() {

    return html`

      <button class=${classMap(this.status)} id="mintbutton" @click=${this.mintButtonClicked}>Mint ${this.totalTokens}
        ${this.seriesName} NFTs</button>

       `
  }

}
customElements.define('mint-button', MintButton)

///////////////////////////////// Your Tokens Components /////////////////////////////////////////////

export class YourTokens extends MiniPfp {

  static properties = {
    creator: {},
    pageLength: {},
    offset: {},
    keys: { attribute: false },
    path: {}
  }

  constructor() {
    super()
    this.offset = 0
    this.pageLength = 12
    this.path = "yours"
    this.keys = []
  }

  onBeforeEnter(location, commands, router) {

    let { initialized, address, error, loading, connect } = getWallet()

    if (initialized) {
      this.creator = address
      this.offset = Number.parseInt(location.params.offset, 10)

      console.log("wallet already connected , ", this.creator)

      // return this.getKeys(this.creator)

      const keysPromise = GalleryUtils.getKeysFiltered(
        "creators",
        this.creator,
        `${this.path}`,
        12,
        this.offset,
        commands)

        .then((keys) => {
          this.keys = keys
        })

      return keysPromise
    }
  }

  connectButtonClicked() {

    let { initialized, address, error, loading, connect } = getWallet()

    if (initialized) {
      this.creator = address

      console.log("already initialized connected, ", this.creator)

      GalleryUtils.getKeysFiltered(
        "creators",
        this.creator,
        `${this.path}`,
        12,
        this.offset,
        null)

        .then((keys) => {
          this.keys = keys
        })

    }

    if (!initialized) {
      connect()
        .then(
          (data) => {

            this.creator = data.address

            console.log("just initialized, ", this.creator)

            GalleryUtils.getKeysFiltered(
              "creators",
              this.creator,
              `${this.path}`,
              12,
              this.offset,
              null)

              .then((keys) => {
                this.keys = keys
              })
          })
    }
  }

  render() {

    console.log("rendering Yours page")

    if (getWallet().initialized) {

      return html`
    
    Your miniPFPs for ${this.creator}
    
    <gallery-container .keys=${this.keys} .pageLength=${this.pageLength} .offset=${this.offset} .path=${this.path}>
    </gallery-container>
    `

    }

    else {
      return html`
    
        Connect ('sync') your wallet to see the miniPFPs you created and minted here.
        
        <button id="connectwallet" class="" @click=${this.connectButtonClicked}>Connect Wallet using Beacon</button> (works with
        most Tezos wallets!)
    `
    }

  }
}

customElements.define('your-tokens', YourTokens)


///////////////////////////////// Gallery Components /////////////////////////////////////////////

class GalleryUtils {

  static updateOffset(offsetParam = 0, keylength, pageLength) {

    console.log("offsetParam: ", offsetParam, "keys: ", keylength)

    let updatedOffset

    if (!Number.isInteger(offsetParam)) {
      updatedOffset = 0
      return updatedOffset
    }

    // check boundary
    if (offsetParam < 0) {
      updatedOffset = 0
      return updatedOffset
    }

    // the formula length - (length % pageLength) gives us the offset for the last page
    if (offsetParam >= keylength) {
      console.log("offset too far")
      updatedOffset = keylength - (keylength % pageLength)
      return updatedOffset
    }

    updatedOffset = offsetParam
    return updatedOffset
  }

  static async getKeysFiltered(where = 'creators', equal, path = "artist", pageLength, offset, commands) {

    console.log(where, equal)

    let keys
    if (!where) {
      keys = db.metadata
        .toCollection()
        .primaryKeys()
    }
    else {
      keys = db.metadata
        .where(where)
        .equalsIgnoreCase(equal)
        .primaryKeys()
    }

    const keysPromise = keys.then((keys) => {

      console.log("got keys from the store", keys)

      const updatedOffset = GalleryUtils.updateOffset(offset, keys.length, pageLength)

      console.log("updated Offset is: ", updatedOffset)

      if (updatedOffset !== offset) {
        console.log(`rerouting to /${path}/${updatedOffset}`)
        Router.go(`/${path}/${updatedOffset}`)
      }

      return keys.reverse()

    })
      .catch((error) => {
        console.log(error)
      })

    return keysPromise
  }

  static async getMetadataFromStore(tokenId = 0) {

    return db.metadata.get(tokenId)
      .then((metadata) => {
        if (metadata == null) {
          throw new Error("no metadata for this token")
        }
        // console.log(`name for token ${tokenIdAsInt} is ${metadata?.name}`)
        return metadata
      })
      .catch(function (error) {
        console.log(error);
      })
  }

  static async getImageFromStore(ipfsUri) {

    return db.images.get(ipfsUri)
      .then((value) => {
        return value.image
      })
      .then((blob) => {
        if (blob == null) {
          throw new Error("no image for this token")
        }
        let source = URL.createObjectURL(blob)
        // console.log(`src for token ${tokenIdAsInt} is ${source}`)
        return source
      })
      .catch((error) => {
        console.log(error);
      })
  }
}


export class GalleryExplore extends MiniPfp {

  static properties = {
    pageLength: {},
    offset: {},
    keys: { attribute: false },
    path: {}
  }

  constructor() {
    super()

    this.offset = 0
    this.pageLength = 12
    this.path = "buy"
  }

  onBeforeEnter(location, commands, router) {

    this.creator = location.params.creator
    this.offset = Number.parseInt(location.params.offset, 10)

    const keysPromise = GalleryUtils.getKeysFiltered(
      "",
      "",
      `${this.path}`,
      12,
      this.offset,
      commands)

      .then((keys) => {
        this.keys = keys
      })

    return keysPromise
  }

  updateKeys(event) {

    console.log("updating keys")

    if (event.data.type == "gallery-status") {

      this.keys = event.data.keys
      this.keys = event.data.keys.reverse()

    }

    if (event.data.type == "gallery-status" && event.data.allFetched == true) {

      self.removeEventListener(
        "message",
        this.updateKeys
      )
    }
  }

  connectedCallback() {
    super.connectedCallback()

    self.addEventListener(
      "message",
      this.updateKeys
    )
  }

  disconnectedCallback() {
    super.disconnectedCallback()

    self.removeEventListener(
      "message",
      this.updateKeys
    )
  }

  render() {

    return html`
  <gallery-container .keys=${this.keys} .pageLength=${this.pageLength} .offset=${this.offset}></gallery-container>
`
  }
}

customElements.define('gallery-explore', GalleryExplore)

export class GalleryArtist extends MiniPfp {

  static properties = {
    creator: {},
    pageLength: {},
    offset: {},
    keys: { attribute: false },
    path: {}
  }

  constructor() {
    super()
    this.offset = 0
    this.pageLength = 12
    this.path = "artist"
  }

  onBeforeEnter(location, commands, router) {

    this.creator = location.params.creator
    this.offset = Number.parseInt(location.params.offset, 10)

    const keysPromise = GalleryUtils.getKeysFiltered(
      "creators",
      this.creator,
      `${this.path}/${this.creator}`,
      12,
      this.offset,
      commands)

      .then((keys) => {
        this.keys = keys
      })

    return keysPromise
  }

  render() {

    return html`
  <gallery-container .keys=${this.keys} .pageLength=${this.pageLength} .offset=${this.offset} .path=${this.path + "/" +
      this.creator}>
  </gallery-container>
`
  }
}

customElements.define('gallery-artist', GalleryArtist)

export class GalleryCollection extends MiniPfp {

  static properties = {
    collectionid: {},
    pageLength: {},
    offset: {},
    keys: { attribute: false },
    path: {}
  }

  constructor() {
    super()
    this.pageLength = 12
    this.path = "collection"
  }

  onBeforeEnter(location, commands, router) {

    this.collectionid = location.params.collectionid
    this.offset = Number.parseInt(location.params.offset, 10)

    const keysPromise = GalleryUtils.getKeysFiltered(
      "collectionid",
      this.collectionid,
      `${this.path}/${this.collectionid}`,
      12,
      this.offset,
      commands)

      .then((keys) => {
        this.keys = keys
      })

    return keysPromise
  }

  render() {

    return html`
  <gallery-container .keys=${this.keys} .pageLength=${this.pageLength} .offset=${this.offset} .path=${this.path + "/" +
      this.collectionid}>
  </gallery-container>
`
  }
}

customElements.define('gallery-collection', GalleryCollection)

export class GalleryContainer extends MiniPfp {

  static properties = {
    keys: { attribute: false },
    pageLength: {},
    offset: {},
    path: { attribute: false },
    previousPageOffset: {},
    nextPageOffset: {},
  }

  constructor() {
    super()
    this.keys = []
    this.pageLength = 12
    this.offset = 0,
      this.previousPageOffset = 0,
      this.nextPageOffset = this.offset + this.pageLength,
      this.path = "buy"
  }

  loadPrevious(event) {

    event.preventDefault()
    event.stopImmediatePropagation()
    this.offset = this.previousPageOffset
    history.pushState({ offset: this.offset }, "", `/${this.path}/${this.offset}`)

  }


  loadNext(event) {

    event.preventDefault()
    event.stopImmediatePropagation()
    this.offset = this.nextPageOffset
    history.pushState({ offset: this.offset }, "", `/${this.path}/${this.offset}`)

  }


  render() {

    const thumbnails = []

    const page = this.keys.slice(this.offset, this.offset + this.pageLength)

    for (let key of page) {
      thumbnails.push(html`<gallery-thumbnail tokenid="${key}"></gallery-thumbnail>`)
    }


    let previous, next = false

    // check which buttons to show
    if (this.offset > 0) { previous = true }
    if (this.offset + this.pageLength < this.keys.length) { next = true }

    this.previousPageOffset = this.offset - this.pageLength

    const previousButton = previous ?
      html`<a id="previousgallerypage" class="gallerybuttons tab" href="/${this.path}/${this.previousPageOffset}"
  @click=${this.loadPrevious}>Previous</a>`
      :
      null

    this.nextPageOffset = this.offset + this.pageLength

    const nextButton = next ?
      html`<a id="nextgallerypage" class="gallerybuttons  tab" href="/${this.path}/${this.nextPageOffset}"
  @click=${this.loadNext}>Next
</a>`
      :
      null


    return html`
        <div class="gallery">
          ${thumbnails}
        </div>
        <div class="tabs previousnext">
          ${previousButton}
          ${nextButton}
        </div>
            `
  }
}
customElements.define('gallery-container', GalleryContainer)

export class GalleryThumbnail extends MiniPfp {

  static properties = {
    tokenid: {},
    metadata: { state: true }
  }

  constructor() {
    super()
  }

  disconnectedCallback() {
    super.disconnectedCallback()

    this.revoke()
  }

  revoke() {
    self.URL.revokeObjectURL(this.source)
  }

  render() {

    const tokenIdAsInt = Number.parseInt(this.tokenid, 10)

    if (Number.isInteger(tokenIdAsInt)) {
      this.metadata = GalleryUtils.getMetadataFromStore(tokenIdAsInt)
      this.source = this.metadata
        .then((metadata) => {
          return GalleryUtils.getImageFromStore(metadata.thumbnailUri)
        })
    }
    else {
      console.log("[thumbnail] token id for is not an int ", this.tokenid)
    }

    const waitingThumbnail = html`
     
    <div class="gallerythumbnailimagesizer spinner"> </div>

           `

    const thumbnail = Promise.all([this.metadata, this.source])
      .then(() => {

        return html`
        <div class="gallerythumbnailimagesizer">
          <img class="gallerythumbnailimage" alt="thumbnail" src="${until(this.source)}">
        </div>
            `
      }
      )
      .catch((error) => {
        console.log(error);
      })


    const name = this.metadata.then((data) => data?.name)
    const creator = this.metadata.then((data) => data?.creators[0])
    const creatorUrl = this.metadata.then((data) => "/artist/" + data?.creators[0])

    return html`
              <div class="gallerythumbnail" id="gallerythumbnail${this.tokenid}">
                <a href="/token/${this.tokenid}">
                  ${until(thumbnail, waitingThumbnail)}
                </a>
                <div class="gallerythumbnailname">${until(name, "miniPFP")}</div>
                <div class="gallerythumbnailcreator">
                  by <a href="${until(creatorUrl, " #")}"> ${until(creator, "miniPFP")}</a>
                </div>
              </div>
            `
  }

}
customElements.define('gallery-thumbnail', GalleryThumbnail)


export class CollectionThumbnail extends MiniPfp {

  static properties = {
    collectionid: {},
    metadata: { state: true }
  }

  constructor() {
    super()
    this.collectionid = "aaa36d3e-c70d-4f71-af6b-d221cf8de8d2"
  }

  async getCollectionKeysFromStore(collectionid = "aaa36d3e-c70d-4f71-af6b-d221cf8de8d2") {

    const keysPromise = db.metadata
      .where('collectionid')
      .equalsIgnoreCase(collectionid)
      .primaryKeys()
      .then((keys) => {

        console.log("got keys from the store")
        this.keys = keys

        console.log("fresh keys… ", this.keys)
      })
      .catch(function (error) {
        console.log(error);
      })

    return keysPromise
  }

  disconnectedCallback() {
    super.disconnectedCallback()

    this.revoke()
  }

  revoke() {
    self.URL.revokeObjectURL(this.source)
  }

  render() {

    const tokenIdAsInt = Number.parseInt(this.tokenid, 10)

    if (Number.isInteger(tokenIdAsInt)) {
      this.metadata = GalleryUtils.getMetadataFromStore(tokenIdAsInt)
      this.source = this.metadata
        .then((metadata) => {
          return GalleryUtils.getImageFromStore(metadata.thumbnailUri)
        })
    }
    else {
      console.log("[thumbnail] token id for is not an int ", this.tokenid)
    }

    const waitingThumbnail = html`
     
    <div class="gallerythumbnailimagesizer spinner"> </div>

           `

    const thumbnail = Promise.all([this.metadata, this.source])
      .then(() => {

        return html`
        <div class="gallerythumbnailimagesizer">
          <img class="gallerythumbnailimage" alt="thumbnail" src="${until(this.source)}">
        </div>
            `
      }
      )
      .catch((error) => {
        console.log(error);
      })


    const collectionname = this.metadata.then((data) => data?.collectionname)
    const creator = this.metadata.then((data) => data?.creators[0])
    const creatorUrl = this.metadata.then((data) => "/artist/" + data?.creators[0])

    return html`
              <div class="gallerythumbnail" id="gallerythumbnail${this.tokenid}">
                <a href="/token/${this.tokenid}">
                  ${until(thumbnail, waitingThumbnail)}
                </a>
                <div class="gallerythumbnailname">${until(collectionname, "miniPFP")}</div>
                <div class="gallerythumbnailcreator">
                  by <a href="${until(creatorUrl, " #")}"> ${until(creator, "miniPFP")}</a>
                </div>
              </div>
            `
  }

}
customElements.define('collection-thumbnail', CollectionThumbnail)

///////////////////////////////// Token Infos /////////////////////////////////////////////

export class infosThumbnail extends MiniPfp {

  static properties = {
    tokenid: {},
    metadata: { state: true }
  }

  static styles = [
    MiniPfp.styles,
    css` 
    .ipfslinktext{
        background-color: var(--background-color);
        margin-top: 0em;
        margin-bottom: 0.3em;
        text-align: center;
    }
    `
  ]

  constructor() {
    super()
  }

  disconnectedCallback() {
    super.disconnectedCallback()

    this.revoke()
  }

  revoke() {
    self.URL.revokeObjectURL(this.source)
  }

  render() {

    const tokenIdAsInt = Number.parseInt(this.tokenid, 10)

    if (Number.isInteger(tokenIdAsInt)) {
      this.metadata = GalleryUtils.getMetadataFromStore(tokenIdAsInt)
      this.source = this.metadata
        .then((metadata) => {
          return GalleryUtils.getImageFromStore(metadata.thumbnailUri)
        })
    }
    else {
      console.log("[thumbnail] token id for is not an int ", this.tokenid)
    }

    const waitingThumbnail = html`
     
      <div class="gallerythumbnailimagesizer spinner">
        <div class="gallerythumbnailimage" style="width: 256px;"></div>
      </div>

           `

    const thumbnail = Promise.all([this.metadata, this.source])
      .then(() => {

        return html`
        <div class="gallerythumbnailimagesizer">
          <img class="gallerythumbnailimage" alt="thumbnail" src="${until(this.source)}">
        </div>
            `
      }
      )
      .catch((error) => {
        console.log(error);
      })


    const name = this.metadata.then((data) => data?.name)
    const creator = this.metadata.then((data) => data?.creators[0])
    const creatorUrl = this.metadata.then((data) => "/artist/" + data?.creators[0])

    const gateway = GATEWAY

    const artifactUrl = this.metadata.then(
      (data) => data.artifactUri.replace("ipfs://", gateway)
    )

    return html`
              <div class="gallerythumbnail" id="gallerythumbnail${this.tokenid}">
                <a class="" href="${until(artifactUrl, " #")}" target="blank">
                  <span>
                    ${until(thumbnail, waitingThumbnail)}
                  </span>
                  <p class="ipfslinktext newtab">2k IPFS image</p>
                </a>
              </div>
            `
  }

}
customElements.define('infos-thumbnail', infosThumbnail)

// should hold
// metadata
// markeplace price
// buy action
// send action for owned token when signed
// 
export class TokenInfos extends MiniPfp {

  static properties = {
    tokenid: {},
    metadata: {},
    alias: {},
    twitter: {},
    loading: {},
  }

  static styles = [
    MiniPfp.styles,
    css`

    h5 {
      color: var(--light-text-color);
      font-size: 1.5em;
      font-weight: 700;
      margin: 0;
    }

    .moreaboutcreator h6{
      color: var(--subdued-text-color);
      margin-bottom: 0;
    }

    .moreaboutcreator p
    {
      margin-top: 0;
      margin-bottom: 0;
    }

    .moreaboutcreator a
    {
      font-size: 0.8em;
    }

    a { 
      text-decoration: underline;
      color: var(--button-color);
    }

    .tokendescription {
      color: var(--dark-text-color)
    }

    .trait{
      background-color: var(--background-color);
      max-width: fit-content;
      display: inline-block;
      border-radius: 0.2em;
      padding: 0.5em 1em 0.4em;
      margin: 1vw;
      transform: rotate(355deg);
     }

    .traitcontainer:last-child{

      margin-right: 0;
    }

    .tokentraits{
      font-size: 80%;
      color: var(--dark-text-color) 
    }

    .traitname{
      font-weight: 500;
      display: flex;
    }

    .traitvalue{
      font-weight: 700;
      display: flex;
    }

    `,
  ];

  constructor() {
    super()
    this.loading = true;
    this.updateInfos = this.updateInfos.bind(this)
  }

  onBeforeEnter(location, commands, router) {

    this.loading = true;

    const tokenIdAsInt = Number.parseInt(location.params.tokenid, 10)

    if (Number.isInteger(tokenIdAsInt)) {

      return db.metadata.get(tokenIdAsInt)
        .then((metadata) => {

          console.log("[TokenInfos] is loading: ", this.loading)

          this.tokenid = tokenIdAsInt

          if (metadata == null) {

            self.addEventListener(
              "message",
              this.updateInfos
            )

            self.postMessage({
              type: "cache-token-data-locally",
              tokenid: tokenIdAsInt
            })
          }
          else {
            console.log("[TokenInfos] Got token from the local db")
            this.metadata = metadata
            this.loading = false
            console.log(this.metadata)
          }
          return
        })
        .catch(function (error) {
          console.log(error)
          return commands.redirect('/404')
        })
    }
    else {
      console.log("[TokenInfos] token id is not an int")
      return commands.redirect('/404')
    }
  }

  updateInfos(event) {

    console.log("[TokenInfos] received message", event)

    if (event.data.type == "token-status"
      && event.data.tokenid == this.tokenid
      && !event.data.exists
    ) {

      console.log("[TokenInfos] 404ing the token")

      Router.go("/404")
      return
    }

    if (event.data.type == "token-status"
      && event.data.tokenid == this.tokenid
      && event.data.exists
    ) {

      console.log("[TokenInfos] updating infos for token:", event.data.tokenid, this.tokenid)

      const tokenIdAsInt = Number.parseInt(this.tokenid, 10)

      db.metadata.get(tokenIdAsInt)
        .then((metadata) => {
          console.log("[TokenInfos] Got metadata from the local db after update")
          this.tokenid = tokenIdAsInt
          this.metadata = metadata
          console.log(this.metadata)
          this.loading = false;
        })

      self.removeEventListener(
        "message",
        this.updateInfos
      )
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback()

    self.removeEventListener(
      "message",
      this.updateInfos
    )
  }

  render() {

    if (this.loading) {
      return html`<div>Loading...</div>`;
    }

    const collectionUrl = "/collection/" + this.metadata.collectionid

    const creator = this.metadata.creators[0]
    const creatorUrl = "/artist/" + this.metadata.creators[0]

    const gateway = GATEWAY

    const artifactUrl = this.metadata.artifactUri.replace("ipfs://", gateway)

    let attributes = []

    for (let attribute of this.metadata.attributes) {
      attributes.push(
        html`
        <div class="trait"> <span class="traitname">${attribute.name}</span>
          <span class="traitvalue">${attribute.value}</span></div>
          `
      )
    }

    let profileUrl
    if (this.twitter) {
      profileUrl = `https://twitter.com/${this.twitter}`
    }
    else {
      profileUrl = `https://tzkt.io/${creator}`
    }

    let name
    if (this.alias) {
      name = this.alias
    }
    else {
      name = creator.slice(0, 8) + "…" + creator.slice(-5)
    }

    return html`
    <div class="tokeninfos">
      <infos-thumbnail tokenid="${this.tokenid}"></infos-thumbnail>
    
      <div class="tokendescription">
        <h5 class="tokenname">${this.metadata.name}</h5>
        <p class="tokentraits"> ${attributes}</p>
        <p class="tokendescription"> ${this.metadata.description}</p>
        <p class="collectionname">
          <a href=${collectionUrl}>${this.metadata.collectionname} collection</a>
        </p>
    
    
        <div class="moreaboutcreator">
          <h6>More from ${name}</h6>
          <p> <a href="${until(creatorUrl, " #")}">Created miniPFPs</a></p>
          <p> <a href="${until(profileUrl, " #")}">Profile</a></p>
        </div>
        <buy-button></buy-button>
        <send-button></send-button>
      </div>
    
    </div>

      `

  }
}

customElements.define('token-infos', TokenInfos)


///////////////////// About Page ///////////////////////////

export class AboutPage extends MiniPfp {

  constructor() {
    super()
  }

  render() {

    // adding the link as a URL object so Parcel can detect that the file is in use
    const exampleImages = new URL('./media/example-images.zip', import.meta.url)

    return html`
  <div class="aboutpage">
  
    <h5 id="why">Why miniPFP?</h5>
    <ul aria-labelledby="why">
      <li>No-code, low-cost: the PFP generator for all artists</li>
      <li>Create 256 different generative artworks with just 16 PNGs: 4 layers of 4 variations each</li>
      <li>Automated batch minting and integrated marketplace</li>
      <li>On Tezos: energy efficient and low cost transactions, artist-friendly blockchain</li>
      <li>100% FA2 entry points compatible: it means you can send, buy, swap, etc. any of the 256 NFTs <b>immediatly after
          minting</b>
        (no <em>lazy minting</em> ie. no post-poned, centralized, fake minting)
      </li>
      <li>7x times lower minting cost, thanks to 3-passes of smart contract storage optimizations: introducing <a
          href="https://twitter.com/juliendorra/status/1545319020651495426">Lazy Ledger </a></li>
      <li>Follow miniPFP on Twitter: <a href="https://twitter.com/minipfp">twitter.com/minipfp</a></li>
    </ul>
  
    <h5 id="forartist">Are you an artist?</h5>
    <ul aria-labelledby="forartist">
      <li>Download the example images: 16 PNGs, 2048x2048, named just right</li>
      <li><a href="${exampleImages}" router-ignore>Example Images (zipped folder)</a></li>
      <li>First 4 images are the base layer, the 12 others are transparent images that will be combined with the base
        layer</li>
      <li>Try that (after unzipping them): select the 16 images, drop them on the <a href="/create">create page</a>. They
        will be added to the compositor and you will see one random combination among the 256 in the canvas at the bottom
      </li>
      <li>Click the canvas at the bottom to see another combination</li>
      <li>If you keep the naming for your own images, you can just magically drop the 16 images and they will be connected
        to the right layers</li>
      <li>Once you have your images right, name your collection, what your layer are and what the traits means, and click
        on Upload All to IPFS to create your 256 images, the metadata that goes which each one (name, link to images, etc)
        and have everything uploaded on the decentralized IPFS file system</li>
      <li>Uploading your image might takes as long as 30 minutes (as there's actually 1024 different files to create and
        upload!) </li>
      <li>
        But once it's done, you can mint your 256 NFTs in one click, and that's quite fast! 1 or 2 minutes</li>
    </ul>
  
    <h5 id="forcollector">Are you a collector?</h5>
    <ul aria-labelledby="forcollector">
      <li>All miniPFPs are pure FA2 tokens, fully decentralized, and can be shared, sent or swapped like any other FA2
        token</li>
      <li>All miniPFPs are automatically added to the dedicated mini-marketplace (that is 100% compatible with the lazy
        ledger storage optimizations) </li>
      <li>Go to the <a href="/buy">explore page</a> to find and buy unique miniPFPs</li>
    </ul>
  
  </div>
`
  }
}

customElements.define('about-page', AboutPage)


///////////////////// Not Found ///////////////////////////

export class NotFound extends MiniPfp {

  constructor() {
    super()
  }

  render() {

    return html`
  <div class="notfound">
    Not Found
  </div>
`
  }
}

customElements.define('not-found', NotFound)

///////////////////// Admin ///////////////////////////

export class AdminPage extends MiniPfp {

  constructor() {
    super()
  }

  render() {

    return html`
    <div id="container">
      <button id="changeFA2admin" @click=${changeFA2admin}>Change FA2 Admin to Minter contract</button>
      <button id="printContractSignature" @click=${printContractSignature}>Get Call Signature</button>
    </div>
  `
  }
}

customElements.define('admin-page', AdminPage)
